// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";
const resources = {
  en: {
    translation: {
      "Emergency Line": "Emergency Line",
      "Support Email": "Support Email",
      "Doctor Appointment": "Doctor Appointment",
      "Book": "Book",
      "Lab Booking": "Lab Booking",
      "Medicine Booking": "Medicine Booking",
      "Skins": "Skins",
      "Care & Vitamin": "Care & Vitamin",
      "My Patient": "My Patient",
      "Add New": "Add New",
      "Your Favorites": "Your Favorites",
      "Doctor Your Love": "Doctor Your Love",
      "Go Home": "Go Home",
      "Home": "Home",
      "Our Services": "Our Services",
      "In Person": "In Person",
      "Video Visit": "Video Visit",
      "Total Experience": "Total Experience",
      "Rating": "Rating",
      "Consultation Fee": "Consultation Fee",
      "Book Appointment": "Book Appointment",
      "Doctor Details": "Doctor Details",
      "FAQs": "FAQs",
      "Cancel Policy": "Cancel Policy",
      "About": "About",
      "Review": "Review",
      "Awards": "Awards",
      "Photos": "Photos",
      "Service": "Service",
      "Availability": "Availability",
      "Morning": "Morning",
      "Afternoon": "Afternoon",
      "Evening": "Evening",
      "Loading...": "Loading...",
      "Clinic Details": "Clinic Details",
      "Doctor Bio": "Doctor Bio",
      "Doctor Profile": "Doctor Profile",
      "Years Experience": "Years Experience",
      "Appointment Details": "Appointment Details",
      "Select Patient": "Select Patient",
      "Message": "Message",
      "Pay from Wallet": "Pay from Wallet",
      "My Wallet": "My Wallet",
      "Apply Coupon": "Apply Coupon",
      "Use Code": "Use Code",
      "Remove": "Remove",
      "Apply": "Apply",
      "View All Coupons": "View All Coupons",
      "Review Your Requirements for This Request": "Review Your Requirements for This Request",
      "Service Total": "Service Total",
      "Additional Service Charge(s)": "Additional Service Charge(s)",
      "Wallet": "Wallet",
      "Coupon": "Coupon",
      "Service Fee & Tax": "Service Fee & Tax",
      "Additional Patient Charge": "Additional Patient Charge",
      "Total Payable Amount": "Total Payable Amount",
      "View Detailed Bill": "View Detailed Bill",
      "Proceed": "Proceed",
      "Best Coupon": "Best Coupon",
      "Coupon Code": "Coupon Code",
      "Coupon Amount": "Coupon Amount",
      "Minimum Amount": "Minimum Amount",
      "Ex Date": "Ex Date",
      "Apply Coupons": "Apply Coupons",
      "Select Payment Method": "Select Payment Method",
      "Category": "Category",
      "Lab Details": "Lab Details",
      "Popular Tests": "Popular Tests",
      "Affordable Packages": "Affordable Packages",
      "Recommended Packages": "Recommended Packages",
      "Item in Cart": "Item in Cart",
      "Home Collect Extra Price": "Home Collect Extra Price",
      "Sample Type": "Sample Type",
      "Fasting Required": "Fasting Required",
      "Test Report Time": "Test Report Time",
      "Package Includes": "Package Includes",
      "Package Description": "Package Description",
      "Test Details & Package Details": "Test Details & Package Details",
      "Remove Cart?": "Remove Cart?",
      "Are You Sure You Want To Delete All Items?": "Are You Sure You Want To Delete All Items?",
      "From Urine Test Report": "From Urine Test Report",
      "Cancel": "Cancel",
      "Select Sample Collection Slot": "Select Sample Collection Slot",
      "Select Date": "Select Date",
      "Select Time": "Select Time",
      "Symptoms / Private Note": "Symptoms / Private Note",
      "Home Service (Collect my test sample)": "Home Service (Collect my test sample)",
      "Additional Cost Required to Pay": "Additional Cost Required to Pay",
      "Your Lab Appointment Location": "Your Lab Appointment Location",
      "Kindly visit the address below for your scheduled lab services.": "Kindly visit the address below for your scheduled lab services.",
      "Choose a Delivery Address": "Choose a Delivery Address",
      "Add New Address": "Add New Address",
      "Save Address As": "Save Address As",
      "Save Address": "Save Address",
      "We Come to You": "We Come to You",
      "Choose your address for hassle-free sample collection at home": "Choose your address for hassle-free sample collection at home",
      "Home Collection Free": "Home Collection Free",
      "Our Category": "Our Category",
      "Shop": "Shop",
      "Shop List": "Shop List",
      "Categories": "Categories",
      "Bestseller Products": "Bestseller Products",
      "Add": "Add",
      "Option": "Option",
      "No Store Available": "No Store Available",
      "In Your Area.": "In Your Area.",
      "Done": "Done",
      "View Cart": "View Cart",
      "Items": "Items",
      "Shop Home Page": "Shop Home Page",
      "Checkout": "Checkout",
      "Order Details": "Order Details",
      "Your Uploaded Prescription": "Your Uploaded Prescription",
      "+ Add Prescription": "+ Add Prescription",
      "+ Add More": "+ Add More",
      "Total Price": "Total Price",
      "Select Delivery Address": "Select Delivery Address",
      "We deliver the product to this address.": "We deliver the product to this address.",
      "Shop Total": "Shop Total",
      "Commission Rate (Fixed)": "Commission Rate (Fixed)",
      "Continue Total Payable Amount": "Continue Total Payable Amount",
      "Packages": "Packages",
      "Cart Booking": "Cart Booking",
      "My Booking": "My Booking",
      "My Order": "My Order",
      "Booking Package": "Booking Package",
      "Refer & Earn": "Refer & Earn",
      "Language": "Language",
      "Chat": "Chat",
      "Log Out": "Log Out",
      "Current Booking": "Current Booking",
      "Past Booking": "Past Booking",
      "Call Doctor": "Call Doctor",
      "No Booking Placed!!": "No Booking Placed!!",
      "Currently You Don't Have Any Booking": "Currently You Don't Have Any Booking",
      "Call": "Call",
      "About Appointment": "About Appointment",
      "Patient Info": "Patient Info",
      "In Person Appointment": "In Person Appointment",
      "In Video Appointment": "In Video Appointment",
      "OTP Info": "OTP Info",
      "QR Code": "QR Code",
      "Appointment Checklists": "Appointment Checklists",
      "Download Prescription": "Download Prescription",
      "Booking Date & Time Info": "Booking Date & Time Info",
      "Bill Summary": "Bill Summary",
      "Doctor Consultation Charge": "Doctor Consultation Charge",
      "Additional Price": "Additional Price",
      "Doctor Commission": "Doctor Commission",
      "Wallet Amount": "Wallet Amount",
      "Payment": "Payment",
      "Hospital Address": "Hospital Address",
      "Health Concerns": "Health Concerns",
      "Add Health Documents": "Add Health Documents",
      "E.g. Past Prescription, Test Report, Photo, etc.": "E.g. Past Prescription, Test Report, Photo, etc.",
      "Maximum File Upload Size": "Maximum File Upload Size",
      "Document": "Document",
      "Add Photo": "Add Photo",
      "Add Document": "Add Document",
      "Submit Details": "Submit Details",
      "Virtual and Physical": "Virtual and Physical",
      "Diagnosis Test": "Diagnosis Test",
      "Medicine": "Medicine",
      "Information": "Information",
      "Medicine Name": "Medicine Name",
      "Time": "Time",
      "Dosage": "Dosage",
      "Duration": "Duration",
      "Frequency": "Frequency",
      "Instructions": "Instructions",
      "Select Reason": "Select Reason",
      "Please Select the Reason for Cancellation": "Please Select the Reason for Cancellation",
      "Confirm": "Confirm",
      "Current Order": "Current Order",
      "Past Order": "Past Order",
      "Info": "Info",
      "No Order Placed!!": "No Order Placed!!",
      "Currently You Don't Have Any Order": "Currently You Don't Have Any Order",
      "Order Info": "Order Info",
      "Medicine Prescription": "Medicine Prescription",
      "Order Status": "Order Status",
      "Pending": "Pending",
      "Processing": "Processing",
      "On Route": "On Route",
      "Payment & Address Info": "Payment & Address Info",
      "Seller Commission": "Seller Commission",
      "Site Commission": "Site Commission",
      "Payment Method": "Payment Method",
      "Address": "Address",
      "Paid from Wallet": "Paid from Wallet",
      "Online Paid": "Online Paid",
      "Deliver": "Deliver",
      "Complete": "Complete",
      "Check Status": "Check Status",
      "Report": "Report",
      "Package Charge": "Package Charge",
      "Home Collection Fee": "Home Collection Fee",
      "TOTAL WALLET BALANCE": "TOTAL WALLET BALANCE",
      "Top Up": "Top Up",
      "Transaction History": "Transaction History",
      "Go & Add Your Amount": "Go & Add Your Amount",
      "Continue": "Continue",
      "Add Wallet Amount": "Add Wallet Amount",
      "Earn": "Earn",
      "For Each Friend You Refer": "For Each Friend You Refer",
      "Share the Referral Link with Your Friends": "Share the Referral Link with Your Friends",
      "Friend Gets": "Friend Gets",
      "On First Complete Transaction": "On First Complete Transaction",
      "You Get": "You Get",
      "On Your Wallet": "On Your Wallet",
      "Select User": "Select User",
      "Send Notification": "Send Notification",
      "Appointment Cancel": "Appointment Cancel",
      "Product Amount": "Product Amount",
      "Login": "Login",
      "Search Doctor": "Search Doctor",
      "Incoming Video Call From": "Incoming Video Call From",
      "Patient Name": "Patient Name",
      "Relationship": "Relationship",
      "Blood Type": "Blood Type",
      "Patient Gender": "Patient Gender",
      "Male": "Male", "Female": "Female",
      "Patient Age": "Patient Age",
      "National ID": "National ID",
      "Height": "Height",
      "Weight": "Weight",
      "Allergies": "Allergies",
      "Medical History": "Medical History",
      "SUBMIT": "SUBMIT",
      "Relationship Type": "Relationship Type",
      "Includes": "Includes",
      "tests": "tests",
      "Reports in": "Reports in",
      "Hours": "Hours",
      "Package Price": "Package Price",
      "Prescription Required": "Prescription Required",
      "No Store available": "No Store available",
      "in your area.": "in your area.",
      "Call doctor": "Call doctor",
      "No Booking placed !!": "No Booking placed !!",
      "Currently you don't have any Booking": "Currently you don't have any Booking",
      "Required for voice and video calls. Make": "Required for voice and video calls. Make",
      "sure your audio device (headset, speakers,": "sure your audio device (headset, speakers,",
      "or microphone) is connected and working.": "or microphone) is connected and working.",
      "Vital & Physical Information": "Vital & Physical Information",
      "Physical examination details": "Physical examination details",
      "Drugs & Prescription Info": "Drugs & Prescription Info",
      "Medications prescription and dosage instructions": "Medications prescription and dosage instructions",
      "Diagnosis Tests": "Diagnosis Tests",
      "Medical tests and diagnostic evaluations": "Medical tests and diagnostic evaluations",
      "Booking": "Booking",
      "Share Health Concerns": "Share Health Concerns",
      "With": "With",
      "prior to your consultation": "prior to your consultation",
      "Enter Disease": "Enter Disease",
      "Start OTP": "Start OTP",
      "End OTP": "End OTP",
      "Appointment ID": "Appointment ID",
      "Accepted": "Accepted",
      "Collector Assigned": "Collector Assigned",
      "Ongoing": "Ongoing",
      "Completed": "Completed",
      "Cancelled": "Cancelled",
      "YourOrderPlaced": "Waiting for confirmation from the laboratory.",
      "OrderPending": "Laboratory has accepted the appointment request.",
      "OrderDelivering": "The appointment is currently in progress.",
      "ProductDelivered": "Lab tests are being processed and analyzed.",
      "OrderDelivered": "The appointment and all related tests are completed.",
      "CollectorAssigned": "A Laboratory technician has been assigned for sample collection.",
      "Search...": "Search...",
      "Say Something...": "Say Something...",
      "Please Select User !!": "Please Select User !!",
      "Please Write Message !!": "Please Write Message !!",
      "Add Patient Photo": "Add Patient Photo",
      "Add Patient Details": "Add Patient Details",
      "You cannot book this time": "You cannot book this time",
      "This time is already book": "This time is already book",
      "Select time for your appointment!": "Select time for your appointment!",
      "Coupon Add Successful": "Coupon Add Successful",
      "Please Select Patient": "Please Select Patient",
      "Please Select Date & Time": "Please Select Date & Time",
      "Please Select Address": "Please Select Address",
      "Please Enter Details": "Please Enter Details",
      "Edit Profile": "Edit Profile",
      "Update": "Update",
      "Please Select Patients": "Please Select Patients",
      "Add patient prescription": "Add patient prescription",
      "Select deliver address": "Select deliver address",
      "Select Cancel Reason": "Select Cancel Reason",
      "Enter Other Reason": "Enter Other Reason",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Doctor hasn't uploaded your details. Please contact them to update your info.",
      "Upload Profile Photo": "Upload Profile Photo",
      "Enter details": "Enter details",
      "No lab report uploaded yet. You’ll be notified once it's available.": "No lab report uploaded yet. You’ll be notified once it's available.",
      "Text copied to clipboard !!": "Text copied to clipboard !!",
      "Logout Successful!": "Logout Successful!",
      "Please Enter Amount": "Please Enter Amount",
      "Please enter number": "Please enter number",
      "Please enter password": "Please enter password",
      "OTP is invalid !!": "OTP is invalid !!",
      "Please Enter a Valid Email": "Please Enter a Valid Email",
      "No Doctor available in your area.": "No Doctor available in your area.",
      "ID": "ID",
      "No Lab available in your area.": "No Lab available in your area.",
      "Book Now": "Book Now",
      "You have successfully booking": "You have successfully booking",
      "Booking Fee": "Booking Fee",
      "Clinic name": "Clinic name",
      "Department name": "Department name",
      "SubType": "SubType",
      "Transaction Dtails": "Transaction Dtails",
      "Payment Type": "Payment Type",
      "View Booking": "View Booking",
      "1 Love this": "1 Love this",
      "Reviews": "Reviews",
      "Currently you don't have any": "Currently you don't have any",
      "doctor in you area!.": "doctor in you area!.",
      "No Doctor yet!": "No Doctor yet!",
      "Leave a Review": "Leave a Review",
      "How was your experience": "How was your experience",
      "Maybe Later": "Maybe Later",
      "Submit": "Submit",
      "Write Your Rewiew": "Write Your Rewiew",
      "Your reviewe here..": "Your reviewe here..",
      "Home Collect Person": "Home Collect Person",
      "Name": "Name",
      "Email": "Email",
      "Phone Number": "Phone Number",
      "Appointment": "Appointment",
      "Comment": "Comment",
      "Order ID": "Order ID",
      "Appointment Date & Time Info": "Appointment Date & Time Info",
      "Upload": "Upload",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Powered By GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Choose us for reliable, detail-oriented cleaning",
      "that meets all your cleanliness needs.": "that meets all your cleanliness needs.",
      "Enable Location Services": "Enable Location Services",
      "To provide accurate services, please enable your location.": "To provide accurate services, please enable your location.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Allow location access when prompted. If not prompted, enable it in your browser settings.",
      "Refresh the page after enabling.": "Refresh the page after enabling.",
      "Enable Now": "Enable Now",
      "TransactionId": "TransactionId",
      "Search Hevan Medical Store Product": "Search Hevan Medical Store Products",
      "No product yet!": "No products yet!",
      "product in you area!.": "products in your area.",
      "No Doctors found !!": "No Doctors found !!",
      "No messages found !!": "No messages found !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,",
      "managing, and attending doctor's appointments.": "managing, and attending doctor's appointments.",
      "Shop by Categories": "Shop by Categories",
      "No Store yet!": "No Store yet!",
      "store in you area!.": "store in you area!.",
      "Search by store": "Search by store",
      "Your Token": "Your Token",
      "Waiting": "Waiting",
      "Now Serving": "Now Serving",
      "Ahead fo You": "Ahead fo You",
      "Add New Patient": "Add New Patient",
      "Book Today": "Book Today",
      "View All": "View All",
      "Cancellation Policy": "Cancellation Policy",
      "Clinic Photos": "Clinic Photos",
      "No review": "No review",
      "years": "years",
      "Video": "Video",
      "No doctors found": "No doctors found",
      "Try adjusting your search": "Try adjusting your search",
      "Clinic": "Clinic",
      "Welcome back": "Welcome back",
      "Manage your health services": "Manage your health services",
      "Logout": "Logout",
      "Wallet Balance": "Wallet Balance",
      "My Profile (Member Since)": "My Profile (Member Since)",
      "Only JPG, PNG, WEBP files are allowed!": "Only JPG, PNG, WEBP files are allowed!",
      "My Profile": "My Profile",
      "Full Name": "Full Name",
      "Email Address": "Email Address",
      "Password": "Password",
      "Save Changes": "Save Changes",
      "Enter Password (Optional)": "Enter Password (Optional)",
    }
  },
  hi: {
    translation: {
      "Emergency Line": "आपातकालीन लाइन",
      "Support Email": "सहायता ईमेल",
      "Doctor Appointment": "डॉक्टर अपॉइंटमेंट",
      "Book": "बुक करें",
      "Lab Booking": "लैब बुकिंग",
      "Medicine Booking": "दवा बुकिंग",
      "Skins": "त्वचा संबंधित",
      "Care & Vitamin": "देखभाल और विटामिन",
      "My Patient": "मेरा रोगी",
      "Add New": "नया जोड़ें",
      "Your Favorites": "आपकी पसंदीदा चीजें",
      "Doctor Your Love": "आपके पसंदीदा डॉक्टर",
      "Go Home": "घर जाएं",
      "Home": "होम",
      "Our Services": "हमारी सेवाएं",
      "In Person": "प्रत्यक्ष रूप से",
      "Video Visit": "वीडियो विजिट",
      "Total Experience": "कुल अनुभव",
      "Rating": "रेटिंग",
      "Consultation Fee": "परामर्श शुल्क",
      "Book Appointment": "अपॉइंटमेंट बुक करें",
      "Doctor Details": "डॉक्टर विवरण",
      "FAQs": "अक्सर पूछे जाने वाले प्रश्न",
      "Cancel Policy": "रद्द करने की नीति",
      "About": "के बारे में",
      "Review": "समीक्षा",
      "Awards": "पुरस्कार",
      "Photos": "फोटो",
      "Service": "सेवा",
      "Availability": "उपलब्धता",
      "Morning": "सुबह",
      "Afternoon": "दोपहर",
      "Evening": "शाम",
      "Loading...": "लोड हो रहा है...",
      "Clinic Details": "क्लिनिक विवरण",
      "Doctor Bio": "डॉक्टर की जीवनी",
      "Doctor Profile": "डॉक्टर प्रोफ़ाइल",
      "Years Experience": "वर्षों का अनुभव",
      "Appointment Details": "अपॉइंटमेंट विवरण",
      "Select Patient": "रोगी चुनें",
      "Message": "संदेश",
      "Pay from Wallet": "वॉलेट से भुगतान करें",
      "My Wallet": "मेरा वॉलेट",
      "Apply Coupon": "कूपन लागू करें",
      "Use Code": "कोड का उपयोग करें",
      "Remove": "हटाएं",
      "Apply": "लागू करें",
      "View All Coupons": "सभी कूपन देखें",
      "Review Your Requirements for This Request": "इस अनुरोध के लिए अपनी आवश्यकताओं की समीक्षा करें",
      "Service Total": "सेवा का कुल मूल्य",
      "Additional Service Charge(s)": "अतिरिक्त सेवा शुल्क",
      "Wallet": "वॉलेट",
      "Coupon": "कूपन",
      "Service Fee & Tax": "सेवा शुल्क और कर",
      "Additional Patient Charge": "अतिरिक्त रोगी शुल्क",
      "Total Payable Amount": "कुल देय राशि",
      "View Detailed Bill": "विस्तृत बिल देखें",
      "Proceed": "आगे बढ़ें",
      "Best Coupon": "सर्वश्रेष्ठ कूपन",
      "Coupon Code": "कूपन कोड",
      "Coupon Amount": "कूपन राशि",
      "Minimum Amount": "न्यूनतम राशि",
      "Ex Date": "समाप्ति तिथि",
      "Apply Coupons": "कूपन लागू करें",
      "Select Payment Method": "भुगतान विधि चुनें",
      "Category": "श्रेणी",
      "Lab Details": "लैब विवरण",
      "Popular Tests": "लोकप्रिय परीक्षण",
      "Affordable Packages": "सस्ते पैकेज",
      "Recommended Packages": "सिफारिश किए गए पैकेज",
      "Item in Cart": "कार्ट में आइटम",
      "Home Collect Extra Price": "घर से संग्रह पर अतिरिक्त शुल्क",
      "Sample Type": "नमूने का प्रकार",
      "Fasting Required": "उपवास आवश्यक",
      "Test Report Time": "परीक्षण रिपोर्ट समय",
      "Package Includes": "पैकेज में शामिल हैं",
      "Package Description": "पैकेज विवरण",
      "Test Details & Package Details": "परीक्षण और पैकेज विवरण",
      "Remove Cart?": "कार्ट हटाएं?",
      "Are You Sure You Want To Delete All Items?": "क्या आप वाकई सभी आइटम हटाना चाहते हैं?",
      "From Urine Test Report": "मूत्र परीक्षण रिपोर्ट से",
      "Cancel": "रद्द करें",
      "Select Sample Collection Slot": "नमूना संग्रह का समय चुनें",
      "Select Date": "तिथि चुनें",
      "Select Time": "समय चुनें",
      "Symptoms / Private Note": "लक्षण / निजी टिप्पणी",
      "Home Service (Collect my test sample)": "घरेलू सेवा (मेरा परीक्षण नमूना लें)",
      "Additional Cost Required to Pay": "अतिरिक्त लागत देनी होगी",
      "Your Lab Appointment Location": "आपका लैब अपॉइंटमेंट स्थान",
      "Kindly visit the address below for your scheduled lab services.": "कृपया अपनी निर्धारित लैब सेवा के लिए नीचे दिए गए पते पर जाएं।",
      "Choose a Delivery Address": "वितरण पता चुनें",
      "Add New Address": "नया पता जोड़ें",
      "Save Address As": "पते को इस नाम से सहेजें",
      "Save Address": "पता सहेजें",
      "We Come to You": "हम आपके पास आते हैं",
      "Choose your address for hassle-free sample collection at home": "घर पर आसान नमूना संग्रह के लिए पता चुनें",
      "Home Collection Free": "घरेलू संग्रह निःशुल्क",
      "Our Category": "हमारी श्रेणी",
      "Shop": "दुकान",
      "Shop List": "दुकानों की सूची",
      "Categories": "श्रेणियाँ",
      "Bestseller Products": "बेस्टसेलर उत्पाद",
      "Add": "जोड़ें",
      "Option": "विकल्प",
      "No Store Available": "कोई स्टोर उपलब्ध नहीं है",
      "In Your Area.": "आपके क्षेत्र में।",
      "Done": "पूरा हुआ",
      "View Cart": "कार्ट देखें",
      "Items": "आइटम्स",
      "Shop Home Page": "दुकान का मुखपृष्ठ",
      "Checkout": "चेकआउट",
      "Order Details": "ऑर्डर विवरण",
      "Your Uploaded Prescription": "आपका अपलोड किया गया प्रिस्क्रिप्शन",
      "+ Add Prescription": "+ प्रिस्क्रिप्शन जोड़ें",
      "+ Add More": "+ और जोड़ें",
      "Total Price": "कुल मूल्य",
      "Select Delivery Address": "वितरण पता चुनें",
      "We deliver the product to this address.": "हम इस पते पर उत्पाद वितरित करते हैं।",
      "Shop Total": "दुकान कुल",
      "Commission Rate (Fixed)": "कमीशन दर (नियत)",
      "Continue Total Payable Amount": "कुल देय राशि जारी रखें",
      "Packages": "पैकेज",
      "Cart Booking": "कार्ट बुकिंग",
      "My Booking": "मेरी बुकिंग",
      "My Order": "मेरा ऑर्डर",
      "Booking Package": "बुकिंग पैकेज",
      "Refer & Earn": "रेफर करें और कमाएं",
      "Language": "भाषा",
      "Chat": "चैट",
      "Log Out": "लॉग आउट",
      "Current Booking": "वर्तमान बुकिंग",
      "Past Booking": "पिछली बुकिंग",
      "Call Doctor": "डॉक्टर को कॉल करें",
      "No Booking Placed!!": "कोई बुकिंग नहीं की गई!!",
      "Currently You Don't Have Any Booking": "फिलहाल आपकी कोई बुकिंग नहीं है",
      "Call": "कॉल",
      "About Appointment": "अपॉइंटमेंट के बारे में",
      "Patient Info": "रोगी की जानकारी",
      "In Person Appointment": "प्रत्यक्ष अपॉइंटमेंट",
      "In Video Appointment": "वीडियो अपॉइंटमेंट",
      "OTP Info": "ओटीपी जानकारी",
      "QR Code": "क्यूआर कोड",
      "Appointment Checklists": "अपॉइंटमेंट चेकलिस्ट",
      "Download Prescription": "प्रिस्क्रिप्शन डाउनलोड करें",
      "Booking Date & Time Info": "बुकिंग तिथि और समय की जानकारी",
      "Bill Summary": "बिल सारांश",
      "Doctor Consultation Charge": "डॉक्टर परामर्श शुल्क",
      "Additional Price": "अतिरिक्त मूल्य",
      "Doctor Commission": "डॉक्टर कमीशन",
      "Wallet Amount": "वॉलेट राशि",
      "Payment": "भुगतान",
      "Hospital Address": "अस्पताल का पता",
      "Health Concerns": "स्वास्थ्य संबंधी चिंताएं",
      "Add Health Documents": "स्वास्थ्य दस्तावेज़ जोड़ें",
      "E.g. Past Prescription, Test Report, Photo, etc.": "जैसे पूर्व प्रिस्क्रिप्शन, टेस्ट रिपोर्ट, फोटो आदि",
      "Maximum File Upload Size": "अधिकतम फ़ाइल अपलोड आकार",
      "Document": "दस्तावेज़",
      "Add Photo": "फोटो जोड़ें",
      "Add Document": "दस्तावेज़ जोड़ें",
      "Submit Details": "विवरण सबमिट करें",
      "Virtual and Physical": "आभासी और भौतिक",
      "Diagnosis Test": "निदान परीक्षण",
      "Medicine": "दवा",
      "Information": "जानकारी",
      "Medicine Name": "दवा का नाम",
      "Time": "समय",
      "Dosage": "खुराक",
      "Duration": "अवधि",
      "Frequency": "आवृत्ति",
      "Instructions": "निर्देश",
      "Select Reason": "कारण चुनें",
      "Please Select the Reason for Cancellation": "कृपया रद्द करने का कारण चुनें",
      "Confirm": "पुष्टि करें",
      "Current Order": "वर्तमान ऑर्डर",
      "Past Order": "पिछला ऑर्डर",
      "Info": "जानकारी",
      "No Order Placed!!": "कोई ऑर्डर नहीं किया गया!!",
      "Currently You Don't Have Any Order": "फिलहाल आपका कोई ऑर्डर नहीं है",
      "Order Info": "ऑर्डर की जानकारी",
      "Medicine Prescription": "दवा प्रिस्क्रिप्शन",
      "Order Status": "ऑर्डर की स्थिति",
      "Pending": "लंबित",
      "Processing": "प्रसंस्करण में",
      "On Route": "रास्ते में",
      "Payment & Address Info": "भुगतान और पता जानकारी",
      "Seller Commission": "विक्रेता कमीशन",
      "Site Commission": "साइट कमीशन",
      "Payment Method": "भुगतान का तरीका",
      "Address": "पता",
      "Paid from Wallet": "वॉलेट से भुगतान किया गया",
      "Online Paid": "ऑनलाइन भुगतान किया गया",
      "Deliver": "डिलीवर करें",
      "Complete": "पूर्ण करें",
      "Check Status": "स्थिति जांचें",
      "Report": "रिपोर्ट",
      "Package Charge": "पैकेज शुल्क",
      "Home Collection Fee": "घर से संग्रह शुल्क",
      "TOTAL WALLET BALANCE": "कुल वॉलेट बैलेंस",
      "Top Up": "टॉप अप करें",
      "Transaction History": "लेन-देन का इतिहास",
      "Go & Add Your Amount": "जाएं और अपनी राशि जोड़ें",
      "Continue": "जारी रखें",
      "Add Wallet Amount": "वॉलेट राशि जोड़ें",
      "Earn": "कमाएं",
      "For Each Friend You Refer": "हर मित्र को रेफर करने पर",
      "Share the Referral Link with Your Friends": "अपने दोस्तों के साथ रेफरल लिंक साझा करें",
      "Friend Gets": "मित्र को मिलेगा",
      "On First Complete Transaction": "पहले पूर्ण लेन-देन पर",
      "You Get": "आपको मिलेगा",
      "On Your Wallet": "आपके वॉलेट पर",
      "Select User": "उपयोगकर्ता चुनें",
      "Send Notification": "सूचना भेजें",
      "Appointment Cancel": "अपॉइंटमेंट रद्द करें",
      "Product Amount": "उत्पाद राशि",
      "Login": "लॉगिन",
      "Search Doctor": "डॉक्टर खोजें",
      "Incoming Video Call From": "इनकमिंग वीडियो कॉल",
      "Patient Name": "रोगी का नाम",
      "Relationship": "रिश्ता",
      "Blood Type": "ब्लड टाइप",
      "Patient Gender": "रोगी का लिंग",
      "Male": "पुरुष",
      "Female": "महिला",
      "Patient Age": "रोगी की उम्र",
      "National ID": "राष्ट्रीय पहचान पत्र",
      "Height": "ऊंचाई",
      "Weight": "वजन",
      "Allergies": "एलर्जी",
      "Medical History": "चिकित्सा इतिहास",
      "SUBMIT": "सबमिट करें",
      "Relationship Type": "रिश्ते का प्रकार",
      "Includes": "शामिल है",
      "tests": "परीक्षण",
      "Reports in": "रिपोर्ट समय",
      "Hours": "घंटे",
      "Package Price": "पैकेज कीमत",
      "Prescription Required": "प्रिस्क्रिप्शन आवश्यक",
      "No Store available": "कोई स्टोर उपलब्ध नहीं",
      "in your area.": "आपके क्षेत्र में।",
      "Call doctor": "डॉक्टर को कॉल करें",
      "No Booking placed !!": "कोई बुकिंग नहीं की गई !!",
      "Currently you don't have any Booking": "इस समय आपकी कोई बुकिंग नहीं है",
      "Required for voice and video calls. Make": "वॉयस और वीडियो कॉल के लिए आवश्यक। कृपया",
      "sure your audio device (headset, speakers,": "सुनिश्चित करें कि आपका ऑडियो डिवाइस (हेडसेट, स्पीकर,",
      "or microphone) is connected and working.": "या माइक्रोफोन) जुड़ा हुआ है और कार्य कर रहा है।",
      "Vital & Physical Information": "मूल और शारीरिक जानकारी",
      "Physical examination details": "शारीरिक जांच विवरण",
      "Drugs & Prescription Info": "दवाइयों और प्रिस्क्रिप्शन की जानकारी",
      "Medications prescription and dosage instructions": "दवाइयों का प्रिस्क्रिप्शन और खुराक निर्देश",
      "Diagnosis Tests": "निदान परीक्षण",
      "Medical tests and diagnostic evaluations": "चिकित्सा परीक्षण और निदान मूल्यांकन",
      "Booking": "बुकिंग",
      "Share Health Concerns": "स्वास्थ्य चिंताएं साझा करें",
      "With": "के साथ",
      "prior to your consultation": "आपकी परामर्श से पहले",
      "Enter Disease": "रोग दर्ज करें",
      "Start OTP": "ओटीपी प्रारंभ करें",
      "End OTP": "ओटीपी समाप्त करें",
      "Appointment ID": "अपॉइंटमेंट आईडी",
      "Accepted": "स्वीकृत",
      "Collector Assigned": "संग्राहक नियुक्त",
      "Ongoing": "चालू",
      "Completed": "पूर्ण",
      "Cancelled": "रद्द",
      "YourOrderPlaced": "प्रयोगशाला से पुष्टि का इंतजार है।",
      "OrderPending": "प्रयोगशाला ने अपॉइंटमेंट अनुरोध स्वीकार कर लिया है।",
      "OrderDelivering": "अपॉइंटमेंट वर्तमान में प्रगति पर है।",
      "ProductDelivered": "प्रयोगशाला परीक्षणों को संसाधित और विश्लेषण किया जा रहा है।",
      "OrderDelivered": "अपॉइंटमेंट और सभी संबंधित परीक्षण पूरे हो गए हैं।",
      "CollectorAssigned": "नमूना संग्रह के लिए एक प्रयोगशाला तकनीशियन नियुक्त किया गया है।",
      "Search...": "खोजें...",
      "Say Something...": "कुछ कहें...",
      "Please Select User !!": "कृपया उपयोगकर्ता चुनें !!",
      "Please Write Message !!": "कृपया संदेश लिखें !!",
      "Add Patient Photo": "रोगी की फोटो जोड़ें",
      "Add Patient Details": "रोगी का विवरण जोड़ें",
      "You cannot book this time": "आप इस समय पर बुक नहीं कर सकते",
      "This time is already book": "यह समय पहले से बुक है",
      "Select time for your appointment!": "अपॉइंटमेंट के लिए समय चुनें!",
      "Coupon Add Successful": "कूपन सफलतापूर्वक जोड़ा गया",
      "Please Select Patient": "कृपया रोगी चुनें",
      "Please Select Date & Time": "कृपया तिथि और समय चुनें",
      "Please Select Address": "कृपया पता चुनें",
      "Please Enter Details": "कृपया विवरण दर्ज करें",
      "Edit Profile": "प्रोफ़ाइल संपादित करें",
      "Update": "अपडेट करें",
      "Please Select Patients": "कृपया रोगियों का चयन करें",
      "Add patient prescription": "रोगी का प्रिस्क्रिप्शन जोड़ें",
      "Select deliver address": "डिलीवरी पता चुनें",
      "Select Cancel Reason": "रद्द करने का कारण चुनें",
      "Enter Other Reason": "अन्य कारण दर्ज करें",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "डॉक्टर ने आपकी जानकारी अपलोड नहीं की है। कृपया उनसे संपर्क करें।",
      "Upload Profile Photo": "प्रोफ़ाइल फोटो अपलोड करें",
      "Enter details": "विवरण दर्ज करें",
      "No lab report uploaded yet. You’ll be notified once it's available.": "कोई लैब रिपोर्ट अभी तक अपलोड नहीं की गई है। उपलब्ध होने पर सूचित किया जाएगा।",
      "Text copied to clipboard !!": "टेक्स्ट क्लिपबोर्ड पर कॉपी किया गया !!",
      "Logout Successful!": "लॉगआउट सफल रहा!",
      "Please Enter Amount": "कृपया राशि दर्ज करें",
      "Please enter number": "कृपया नंबर दर्ज करें",
      "Please enter password": "कृपया पासवर्ड दर्ज करें",
      "OTP is invalid !!": "ओटीपी अमान्य है !!",
      "Please Enter a Valid Email": "कृपया एक मान्य ईमेल दर्ज करें",
      "No Doctor available in your area.": "आपके क्षेत्र में कोई डॉक्टर उपलब्ध नहीं है।",
      "ID": "पहचान संख्या",
      "No Lab available in your area.": "आपके क्षेत्र में कोई प्रयोगशाला उपलब्ध नहीं है।",
      "Book Now": "अभी बुक करें",
      "You have successfully booking": "आपकी बुकिंग सफल रही है",
      "Booking Fee": "बुकिंग शुल्क",
      "Clinic name": "क्लिनिक का नाम",
      "Department name": "विभाग का नाम",
      "SubType": "उपप्रकार",
      "Transaction Dtails": "लेन-देन का विवरण",
      "Payment Type": "भुगतान प्रकार",
      "View Booking": "बुकिंग देखें",
      "1 Love this": "1 इसे पसंद किया",
      "Reviews": "समीक्षाएं",
      "Currently you don't have any": "वर्तमान में आपके पास कोई नहीं है",
      "doctor in you area!.": "आपके क्षेत्र में कोई डॉक्टर नहीं है!",
      "No Doctor yet!": "अभी तक कोई डॉक्टर नहीं है!",
      "Leave a Review": "समीक्षा छोड़ें",
      "How was your experience": "आपका अनुभव कैसा रहा",
      "Maybe Later": "शायद बाद में",
      "Submit": "जमा करें",
      "Write Your Rewiew": "अपनी समीक्षा लिखें",
      "Your reviewe here..": "यहाँ अपनी समीक्षा लिखें..",
      "Home Collect Person": "होम कलेक्ट व्यक्ति",
      "Name": "नाम",
      "Email": "ईमेल",
      "Phone Number": "फोन नंबर",
      "Appointment": "नियुक्ति",
      "Comment": "टिप्पणी",
      "Order ID": "ऑर्डर आईडी",
      "Enter Amount": "राशि दर्ज करें",
      "Appointment Date & Time Info": "अपॉइंटमेंट की तारीख और समय की जानकारी",
      "Upload": "अपलोड करें",
      "GoDoctor": "गो डॉक्टर",
      "@ Powered By GoDoctor": "@ गो डॉक्टर द्वारा संचालित",
      "Choose us for reliable, detail-oriented cleaning": "भरोसेमंद और विवरण-उन्मुख सफाई के लिए हमें चुनें",
      "that meets all your cleanliness needs.": "जो आपकी सभी सफाई आवश्यकताओं को पूरा करता है।",
      "Enable Location Services": "स्थान सेवाएँ सक्षम करें",
      "To provide accurate services, please enable your location.": "सटीक सेवाएँ प्रदान करने के लिए कृपया अपना स्थान सक्षम करें।",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "जब पूछा जाए तो स्थान की अनुमति दें। यदि न पूछा जाए, तो अपने ब्राउज़र सेटिंग्स में जाकर इसे सक्षम करें।",
      "Refresh the page after enabling.": "सक्षम करने के बाद पृष्ठ को रिफ्रेश करें।",
      "Enable Now": "अब सक्षम करें",
      "TransactionId": "लेनदेन पहचान संख्या",
      "Search Hevan Medical Store Product": "हेवन मेडिकल स्टोर उत्पाद खोजें",
      "No product yet!": "अभी तक कोई उत्पाद नहीं है!",
      "product in you area!.": "आपके क्षेत्र में कोई उत्पाद नहीं है।",
      "No Doctors found !!": "कोई डॉक्टर नहीं मिले !!",
      "No messages found !!": "कोई संदेश नहीं मिला !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "डॉक्टर अपॉइंटमेंट समाधान एक प्रणाली को संदर्भित करता है, जो अक्सर एक ऐप के रूप में होती है, जो बुकिंग की प्रक्रिया को आसान बनाती है,",
      "managing, and attending doctor's appointments.": "डॉक्टर की अपॉइंटमेंट को प्रबंधित करने और उपस्थित होने की प्रक्रिया को भी।",
      "Shop by Categories": "श्रेणियों के अनुसार खरीदारी करें",
      "No Store yet!": "अभी तक कोई स्टोर नहीं है!",
      "store in you area!.": "आपके क्षेत्र में स्टोर।",
      "Search by store": "स्टोर के अनुसार खोजें",
      "Your Token": "आपका टोकन",
      "Waiting": "प्रतीक्षा में",
      "Now Serving": "अब सेवा दे रहे हैं",
      "Ahead fo You": "आपसे आगे",
      "Add New Patient": "नया मरीज जोड़ें",
      "Book Today": "आज ही बुक करें",
      "View All": "सभी देखें",
      "Cancellation Policy": "रद्द करने की नीति",
      "Clinic Photos": "क्लिनिक की तस्वीरें",
      "No review": "कोई समीक्षा नहीं",
      "years": "साल",
      "Video": "वीडियो",
      "No doctors found": "कोई डॉक्टर नहीं मिले",
      "Try adjusting your search": "अपना खोज समायोजित करने का प्रयास करें",
      "Clinic": "क्लिनिक",
      "Welcome back": "वापसी पर स्वागत है",
      "Manage your health services": "अपनी स्वास्थ्य सेवाओं का प्रबंधन करें",
      "Logout": "लॉगआउट",
      "Wallet Balance": "वॉलेट बैलेंस",
      "My Profile (Member Since)": "मेरा प्रोफ़ाइल (सदस्यता की तिथि से)",
      "Only JPG, PNG, WEBP files are allowed!": "केवल JPG, PNG, WEBP फ़ाइलें ही अनुमति हैं!",
      "My Profile": "मेरा प्रोफ़ाइल",
      "Full Name": "पूरा नाम",
      "Email Address": "ईमेल पता",
      "Password": "पासवर्ड",
      "Save Changes": "परिवर्तन सहेजें",
      "Enter Password (Optional)": "पासवर्ड दर्ज करें (वैकल्पिक)"
    }
  },
  ar: {
    translation: {
      "Emergency Line": "خط الطوارئ",
      "Support Email": "البريد الإلكتروني للدعم",
      "Doctor Appointment": "موعد الطبيب",
      "Book": "حجز",
      "Lab Booking": "حجز المختبر",
      "Medicine Booking": "حجز الدواء",
      "Skins": "البشرة",
      "Care & Vitamin": "العناية والفيتامينات",
      "My Patient": "مريضي",
      "Add New": "إضافة جديد",
      "Your Favorites": "المفضلة لديك",
      "Doctor Your Love": "الطبيب الذي تحبه",
      "Go Home": "اذهب إلى الصفحة الرئيسية",
      "Home": "الرئيسية",
      "Our Services": "خدماتنا",
      "In Person": "شخصيًا",
      "Video Visit": "زيارة فيديو",
      "Total Experience": "إجمالي الخبرة",
      "Rating": "التقييم",
      "Consultation Fee": "رسوم الاستشارة",
      "Book Appointment": "حجز موعد",
      "Doctor Details": "تفاصيل الطبيب",
      "FAQs": "الأسئلة الشائعة",
      "Cancel Policy": "سياسة الإلغاء",
      "About": "حول",
      "Review": "مراجعة",
      "Awards": "الجوائز",
      "Photos": "الصور",
      "Service": "الخدمة",
      "Availability": "التوفر",
      "Morning": "صباحًا",
      "Afternoon": "بعد الظهر",
      "Evening": "مساءً",
      "Loading...": "جارٍ التحميل...",
      "Clinic Details": "تفاصيل العيادة",
      "Doctor Bio": "نبذة عن الطبيب",
      "Doctor Profile": "ملف الطبيب",
      "Years Experience": "سنوات الخبرة",
      "Appointment Details": "تفاصيل الموعد",
      "Select Patient": "اختر المريض",
      "Message": "رسالة",
      "Pay from Wallet": "الدفع من المحفظة",
      "My Wallet": "محفظتي",
      "Apply Coupon": "تطبيق القسيمة",
      "Use Code": "استخدام الرمز",
      "Remove": "إزالة",
      "Apply": "تطبيق",
      "View All Coupons": "عرض جميع القسائم",
      "Review Your Requirements for This Request": "مراجعة متطلباتك لهذا الطلب",
      "Service Total": "إجمالي الخدمة",
      "Additional Service Charge(s)": "رسوم خدمة إضافية",
      "Wallet": "المحفظة",
      "Coupon": "قسيمة",
      "Service Fee & Tax": "رسوم الخدمة والضرائب",
      "Additional Patient Charge": "رسوم إضافية للمريض",
      "Total Payable Amount": "إجمالي المبلغ المستحق",
      "View Detailed Bill": "عرض الفاتورة التفصيلية",
      "Proceed": "المتابعة",
      "Best Coupon": "أفضل قسيمة",
      "Coupon Code": "رمز القسيمة",
      "Coupon Amount": "قيمة القسيمة",
      "Minimum Amount": "الحد الأدنى للمبلغ",
      "Ex Date": "تاريخ الانتهاء",
      "Apply Coupons": "تطبيق القسائم",
      "Select Payment Method": "اختر طريقة الدفع",
      "Category": "الفئة",
      "Lab Details": "تفاصيل المختبر",
      "Popular Tests": "الاختبارات الشائعة",
      "Affordable Packages": "الباقات الميسورة",
      "Recommended Packages": "الباقات الموصى بها",
      "Item in Cart": "عنصر في السلة",
      "Home Collect Extra Price": "تكلفة إضافية لجمع العينة من المنزل",
      "Sample Type": "نوع العينة",
      "Fasting Required": "الصيام مطلوب",
      "Test Report Time": "وقت تقرير الاختبار",
      "Package Includes": "تتضمن الباقة",
      "Package Description": "وصف الباقة",
      "Test Details & Package Details": "تفاصيل الاختبار وتفاصيل الباقة",
      "Remove Cart?": "إزالة السلة؟",
      "Are You Sure You Want To Delete All Items?": "هل أنت متأكد أنك تريد حذف كل العناصر؟",
      "From Urine Test Report": "من تقرير اختبار البول",
      "Cancel": "إلغاء",
      "Select Sample Collection Slot": "اختر فترة جمع العينة",
      "Select Date": "اختر التاريخ",
      "Select Time": "اختر الوقت",
      "Symptoms / Private Note": "الأعراض / ملاحظة خاصة",
      "Home Service (Collect my test sample)": "الخدمة المنزلية (جمع عينة الاختبار الخاصة بي)",
      "Additional Cost Required to Pay": "التكلفة الإضافية المطلوبة للدفع",
      "Your Lab Appointment Location": "موقع موعد المختبر الخاص بك",
      "Kindly visit the address below for your scheduled lab services.": "يرجى زيارة العنوان أدناه لخدمات المختبر المجدولة الخاصة بك.",
      "Choose a Delivery Address": "اختر عنوان التوصيل",
      "Add New Address": "إضافة عنوان جديد",
      "Save Address As": "حفظ العنوان كـ",
      "Save Address": "حفظ العنوان",
      "We Come to You": "نحن نأتي إليك",
      "Choose your address for hassle-free sample collection at home": "اختر عنوانك لجمع العينة بسهولة في المنزل",
      "Home Collection Free": "جمع العينة من المنزل مجانًا",
      "Our Category": "فئتنا",
      "Shop": "المتجر",
      "Shop List": "قائمة المتاجر",
      "Categories": "الفئات",
      "Bestseller Products": "المنتجات الأكثر مبيعًا",
      "Add": "إضافة",
      "Option": "خيار",
      "No Store Available": "لا يوجد متجر متاح",
      "In Your Area.": "في منطقتك.",
      "Done": "تم",
      "View Cart": "عرض السلة",
      "Items": "عناصر",
      "Shop Home Page": "الصفحة الرئيسية للمتجر",
      "Checkout": "الدفع",
      "Order Details": "تفاصيل الطلب",
      "Your Uploaded Prescription": "الوصفة الطبية التي قمت برفعها",
      "+ Add Prescription": "+ إضافة وصفة طبية",
      "+ Add More": "+ إضافة المزيد",
      "Total Price": "السعر الإجمالي",
      "Select Delivery Address": "اختر عنوان التوصيل",
      "We deliver the product to this address.": "نقوم بتوصيل المنتج إلى هذا العنوان.",
      "Shop Total": "إجمالي المتجر",
      "Commission Rate (Fixed)": "معدل العمولة (ثابت)",
      "Continue Total Payable Amount": "استمر إلى إجمالي المبلغ المستحق",
      "Packages": "الباقات",
      "Cart Booking": "حجز السلة",
      "My Booking": "حجوزاتي",
      "My Order": "طلباتي",
      "Booking Package": "حجز الباقة",
      "Refer & Earn": "أحِل واربح",
      "Language": "اللغة",
      "Chat": "الدردشة",
      "Log Out": "تسجيل الخروج",
      "Current Booking": "الحجز الحالي",
      "Past Booking": "الحجز السابق",
      "Call Doctor": "اتصل بالطبيب",
      "No Booking Placed!!": "لم يتم إجراء أي حجز!!",
      "Currently You Don't Have Any Booking": "ليس لديك أي حجز حاليا",
      "Call": "اتصال",
      "About Appointment": "حول الموعد",
      "Patient Info": "معلومات المريض",
      "In Person Appointment": "موعد شخصي",
      "In Video Appointment": "موعد فيديو",
      "OTP Info": "معلومات رمز التحقق",
      "QR Code": "رمز الاستجابة السريعة",
      "Appointment Checklists": "قوائم التحقق من الموعد",
      "Download Prescription": "تحميل الوصفة الطبية",
      "Booking Date & Time Info": "معلومات تاريخ ووقت الحجز",
      "Bill Summary": "ملخص الفاتورة",
      "Doctor Consultation Charge": "رسوم استشارة الطبيب",
      "Additional Price": "سعر إضافي",
      "Doctor Commission": "عمولة الطبيب",
      "Wallet Amount": "رصيد المحفظة",
      "Payment": "الدفع",
      "Hospital Address": "عنوان المستشفى",
      "Health Concerns": "المخاوف الصحية",
      "Add Health Documents": "إضافة مستندات صحية",
      "E.g. Past Prescription, Test Report, Photo, etc.": "مثلاً: وصفة سابقة، تقرير اختبار، صورة، إلخ.",
      "Maximum File Upload Size": "أقصى حجم لتحميل الملف",
      "Document": "مستند",
      "Add Photo": "إضافة صورة",
      "Add Document": "إضافة مستند",
      "Submit Details": "إرسال التفاصيل",
      "Virtual and Physical": "افتراضي وفعلي",
      "Diagnosis Test": "اختبار التشخيص",
      "Medicine": "دواء",
      "Information": "معلومات",
      "Medicine Name": "اسم الدواء",
      "Time": "الوقت",
      "Dosage": "الجرعة",
      "Duration": "المدة",
      "Frequency": "التكرار",
      "Instructions": "تعليمات",
      "Select Reason": "اختر السبب",
      "Please Select the Reason for Cancellation": "يرجى اختيار سبب الإلغاء",
      "Confirm": "تأكيد",
      "Current Order": "الطلب الحالي",
      "Past Order": "الطلب السابق",
      "Info": "معلومات",
      "No Order Placed!!": "لم يتم تقديم أي طلب!!",
      "Currently You Don't Have Any Order": "ليس لديك أي طلب حاليا",
      "Order Info": "معلومات الطلب",
      "Medicine Prescription": "وصفة الدواء",
      "Order Status": "حالة الطلب",
      "Pending": "قيد الانتظار",
      "Processing": "قيد المعالجة",
      "On Route": "في الطريق",
      "Payment & Address Info": "معلومات الدفع والعنوان",
      "Seller Commission": "عمولة البائع",
      "Site Commission": "عمولة الموقع",
      "Payment Method": "طريقة الدفع",
      "Address": "العنوان",
      "Paid from Wallet": "مدفوع من المحفظة",
      "Online Paid": "مدفوع أونلاين",
      "Deliver": "تسليم",
      "Complete": "مكتمل",
      "Check Status": "تحقق من الحالة",
      "Report": "تقرير",
      "Package Charge": "رسوم الباقة",
      "Home Collection Fee": "رسوم جمع العينة من المنزل",
      "TOTAL WALLET BALANCE": "الرصيد الإجمالي للمحفظة",
      "Top Up": "شحن الرصيد",
      "Transaction History": "تاريخ المعاملات",
      "Go & Add Your Amount": "اذهب وأضف المبلغ الخاص بك",
      "Continue": "متابعة",
      "Add Wallet Amount": "أضف مبلغ المحفظة",
      "Earn": "اكسب",
      "For Each Friend You Refer": "لكل صديق تحيله",
      "Share the Referral Link with Your Friends": "شارك رابط الإحالة مع أصدقائك",
      "Friend Gets": "يحصل الصديق على",
      "On First Complete Transaction": "على أول عملية مكتملة",
      "You Get": "تحصل أنت على",
      "On Your Wallet": "في محفظتك",
      "Select User": "اختر المستخدم",
      "Send Notification": "إرسال إشعار",
      "Appointment Cancel": "إلغاء الموعد",
      "Product Amount": "مبلغ المنتج",
      "Login": "تسجيل الدخول",
      "Search Doctor": "البحث عن طبيب",
      "Incoming Video Call From": "مكالمة فيديو واردة من",
      "Patient Name": "اسم المريض",
      "Relationship": "العلاقة",
      "Blood Type": "فصيلة الدم",
      "Patient Gender": "جنس المريض",
      "Male": "ذكر",
      "Female": "أنثى",
      "Patient Age": "عمر المريض",
      "National ID": "الهوية الوطنية",
      "Height": "الطول",
      "Weight": "الوزن",
      "Allergies": "الحساسية",
      "Medical History": "التاريخ الطبي",
      "SUBMIT": "إرسال",
      "Relationship Type": "نوع العلاقة",
      "Includes": "يشمل",
      "tests": "اختبارات",
      "Reports in": "التقارير خلال",
      "Hours": "ساعات",
      "Package Price": "سعر الباقة",
      "Prescription Required": "تتطلب وصفة طبية",
      "No Store available": "لا يوجد متجر متاح",
      "in your area.": "في منطقتك.",
      "Call doctor": "اتصل بالطبيب",
      "No Booking placed !!": "لم يتم إجراء أي حجز!!",
      "Currently you don't have any Booking": "ليس لديك أي حجز حاليا",
      "Required for voice and video calls. Make": "مطلوب للمكالمات الصوتية والمرئية. تأكد من",
      "sure your audio device (headset, speakers,": "توصيل جهاز الصوت (سماعة الرأس، مكبرات الصوت،",
      "or microphone) is connected and working.": "أو الميكروفون) وأنه يعمل.",
      "Vital & Physical Information": "المعلومات الحيوية والجسدية",
      "Physical examination details": "تفاصيل الفحص الجسدي",
      "Drugs & Prescription Info": "معلومات الأدوية والوصفات الطبية",
      "Medications prescription and dosage instructions": "وصفات الأدوية وتعليمات الجرعات",
      "Diagnosis Tests": "اختبارات التشخيص",
      "Medical tests and diagnostic evaluations": "الفحوصات الطبية والتقييمات التشخيصية",
      "Booking": "الحجز",
      "Share Health Concerns": "مشاركة المخاوف الصحية",
      "With": "مع",
      "prior to your consultation": "قبل استشارتك",
      "Enter Disease": "أدخل المرض",
      "Start OTP": "بداية رمز التحقق",
      "End OTP": "نهاية رمز التحقق",
      "Appointment ID": "رقم الموعد",
      "Accepted": "تم قبوله",
      "Collector Assigned": "تم تعيين جامع العينة",
      "Ongoing": "جارٍ التنفيذ",
      "Completed": "مكتمل",
      "Cancelled": "ملغي",
      "YourOrderPlaced": "في انتظار تأكيد المختبر.",
      "OrderPending": "قبل المختبر طلب الموعد.",
      "OrderDelivering": "الموعد جارٍ حاليًا.",
      "ProductDelivered": "يتم الآن معالجة وتحليل فحوصات المختبر.",
      "OrderDelivered": "تم الانتهاء من الموعد وجميع الفحوصات المتعلقة به.",
      "CollectorAssigned": "تم تعيين فني مختبر لجمع العينات.",
      "Search...": "بحث...",
      "Say Something...": "قل شيئًا...",
      "Please Select User !!": "يرجى اختيار المستخدم !!",
      "Please Write Message !!": "يرجى كتابة رسالة !!",
      "Add Patient Photo": "إضافة صورة المريض",
      "Add Patient Details": "إضافة تفاصيل المريض",
      "You cannot book this time": "لا يمكنك الحجز في هذا الوقت",
      "This time is already book": "هذا الوقت محجوز بالفعل",
      "Select time for your appointment!": "اختر وقت موعدك!",
      "Coupon Add Successful": "تمت إضافة القسيمة بنجاح",
      "Please Select Patient": "يرجى اختيار المريض",
      "Please Select Date & Time": "يرجى اختيار التاريخ والوقت",
      "Please Select Address": "يرجى اختيار العنوان",
      "Please Enter Details": "يرجى إدخال التفاصيل",
      "Edit Profile": "تعديل الملف الشخصي",
      "Update": "تحديث",
      "Please Select Patients": "يرجى اختيار المرضى",
      "Add patient prescription": "إضافة وصفة المريض",
      "Select deliver address": "اختر عنوان التوصيل",
      "Select Cancel Reason": "اختر سبب الإلغاء",
      "Enter Other Reason": "أدخل سببًا آخر",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "لم يقم الطبيب بتحميل بياناتك. يرجى الاتصال به لتحديث معلوماتك.",
      "Upload Profile Photo": "تحميل صورة الملف الشخصي",
      "Enter details": "أدخل التفاصيل",
      "No lab report uploaded yet. You’ll be notified once it's available.": "لم يتم رفع تقرير المختبر بعد. سيتم إعلامك بمجرد توفره.",
      "Text copied to clipboard !!": "تم نسخ النص إلى الحافظة !!",
      "Logout Successful!": "تم تسجيل الخروج بنجاح!",
      "Please Enter Amount": "يرجى إدخال المبلغ",
      "Please enter number": "يرجى إدخال رقم",
      "Please enter password": "يرجى إدخال كلمة المرور",
      "OTP is invalid !!": "رمز التحقق غير صالح !!",
      "Please Enter a Valid Email": "يرجى إدخال بريد إلكتروني صالح",
      "No Doctor available in your area.": "لا يوجد طبيب متاح في منطقتك.",
      "ID": "المعرف",
      "No Lab available in your area.": "لا توجد مختبرات متاحة في منطقتك.",
      "Book Now": "احجز الآن",
      "You have successfully booking": "تم الحجز بنجاح",
      "Booking Fee": "رسوم الحجز",
      "Clinic name": "اسم العيادة",
      "Department name": "اسم القسم",
      "SubType": "النوع الفرعي",
      "Transaction Dtails": "تفاصيل المعاملة",
      "Payment Type": "نوع الدفع",
      "View Booking": "عرض الحجز",
      "1 Love this": "1 أحب هذا",
      "Reviews": "المراجعات",
      "Currently you don't have any": "حالياً ليس لديك أي شيء",
      "doctor in you area!.": "لا يوجد طبيب في منطقتك!",
      "No Doctor yet!": "لا يوجد طبيب حتى الآن!",
      "Leave a Review": "اترك مراجعة",
      "How was your experience": "كيف كانت تجربتك؟",
      "Maybe Later": "ربما لاحقًا",
      "Submit": "إرسال",
      "Write Your Rewiew": "اكتب تقييمك",
      "Your reviewe here..": "اكتب تقييمك هنا..",
      "Home Collect Person": "شخص جمع العينات من المنزل",
      "Name": "الاسم",
      "Email": "البريد الإلكتروني",
      "Phone Number": "رقم الهاتف",
      "Appointment": "الموعد",
      "Comment": "تعليق",
      "Order ID": "رقم الطلب",
      "Enter Amount": "أدخل المبلغ",
      "Appointment Date & Time Info": "معلومات تاريخ ووقت الموعد",
      "Upload": "تحميل",
      "GoDoctor": "جو دكتور",
      "@ Powered By GoDoctor": "@ بدعم من جو دكتور",
      "Choose us for reliable, detail-oriented cleaning": "اخترنا لتنظيف موثوق ودقيق بالتفاصيل",
      "that meets all your cleanliness needs.": "الذي يلبي جميع احتياجاتك من النظافة.",
      "Enable Location Services": "تمكين خدمات الموقع",
      "To provide accurate services, please enable your location.": "لتقديم خدمات دقيقة، يرجى تمكين الموقع الخاص بك.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "اسمح بالوصول إلى الموقع عند الطلب. إذا لم يُطلب منك، فعِّله من إعدادات المتصفح.",
      "Refresh the page after enabling.": "قم بتحديث الصفحة بعد التمكين.",
      "Enable Now": "فعِّل الآن",
      "TransactionId": "معرّف المعاملة",
      "Search Hevan Medical Store Product": "ابحث عن منتجات متجر هيفان الطبي",
      "No product yet!": "لا توجد منتجات بعد!",
      "product in you area!.": "لا توجد منتجات في منطقتك.",
      "No Doctors found !!": "لم يتم العثور على أطباء !!",
      "No messages found !!": "لم يتم العثور على رسائل !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "يشير حل مواعيد الطبيب إلى نظام، غالبًا ما يكون على شكل تطبيق، يُبسّط عملية الحجز،",
      "managing, and attending doctor's appointments.": "وإدارة وحضور مواعيد الطبيب.",
      "Shop by Categories": "تسوق حسب الفئات",
      "No Store yet!": "لا يوجد متجر حتى الآن!",
      "store in you area!.": "متجر في منطقتك.",
      "Search by store": "البحث حسب المتجر",
      "Your Token": "رقمك",
      "Waiting": "قيد الانتظار",
      "Now Serving": "يتم الآن الخدمة",
      "Ahead fo You": "أمامك",
      "Add New Patient": "إضافة مريض جديد",
      "Book Today": "احجز اليوم",
      "View All": "عرض الكل",
      "Cancellation Policy": "سياسة الإلغاء",
      "Clinic Photos": "صور العيادة",
      "No review": "لا توجد مراجعات",
      "years": "سنوات",
      "Video": "فيديو",
      "No doctors found": "لم يتم العثور على أطباء",
      "Try adjusting your search": "حاول تعديل بحثك",
      "Clinic": "عيادة",
      "Welcome back": "مرحبًا بعودتك",
      "Manage your health services": "إدارة خدماتك الصحية",
      "Logout": "تسجيل الخروج",
      "Wallet Balance": "رصيد المحفظة",
      "My Profile (Member Since)": "ملفي الشخصي (عضو منذ)",
      "Only JPG, PNG, WEBP files are allowed!": "يُسمح فقط بملفات JPG و PNG و WEBP!",
      "My Profile": "ملفي الشخصي",
      "Full Name": "الاسم الكامل",
      "Email Address": "عنوان البريد الإلكتروني",
      "Password": "كلمة المرور",
      "Save Changes": "حفظ التغييرات",
      "Enter Password (Optional)": "أدخل كلمة المرور (اختياري)"
    }
  },
  sp: {
    translation: {
      "Emergency Line": "Línea de Emergencia",
      "Support Email": "Correo de Soporte",
      "Doctor Appointment": "Cita con el Doctor",
      "Book": "Reservar",
      "Lab Booking": "Reserva de Laboratorio",
      "Medicine Booking": "Reserva de Medicamentos",
      "Skins": "Piel",
      "Care & Vitamin": "Cuidado y Vitaminas",
      "My Patient": "Mi Paciente",
      "Add New": "Agregar Nuevo",
      "Your Favorites": "Tus Favoritos",
      "Doctor Your Love": "Doctor que Amas",
      "Go Home": "Ir a Inicio",
      "Home": "Inicio",
      "Our Services": "Nuestros Servicios",
      "In Person": "Presencial",
      "Video Visit": "Consulta por Video",
      "Total Experience": "Experiencia Total",
      "Rating": "Calificación",
      "Consultation Fee": "Tarifa de Consulta",
      "Book Appointment": "Reservar Cita",
      "Doctor Details": "Detalles del Doctor",
      "FAQs": "Preguntas Frecuentes",
      "Cancel Policy": "Política de Cancelación",
      "About": "Acerca de",
      "Review": "Reseña",
      "Awards": "Premios",
      "Photos": "Fotos",
      "Service": "Servicio",
      "Availability": "Disponibilidad",
      "Morning": "Mañana",
      "Afternoon": "Tarde",
      "Evening": "Noche",
      "Loading...": "Cargando...",
      "Clinic Details": "Detalles de la Clínica",
      "Doctor Bio": "Biografía del Doctor",
      "Doctor Profile": "Perfil del Doctor",
      "Years Experience": "Años de Experiencia",
      "Appointment Details": "Detalles de la Cita",
      "Select Patient": "Seleccionar Paciente",
      "Message": "Mensaje",
      "Pay from Wallet": "Pagar desde la Billetera",
      "My Wallet": "Mi Billetera",
      "Apply Coupon": "Aplicar Cupón",
      "Use Code": "Usar Código",
      "Remove": "Eliminar",
      "Apply": "Aplicar",
      "View All Coupons": "Ver Todos los Cupones",
      "Review Your Requirements for This Request": "Revisa tus Requisitos para esta Solicitud",
      "Service Total": "Total del Servicio",
      "Additional Service Charge(s)": "Cargos Adicionales por Servicio",
      "Wallet": "Billetera",
      "Coupon": "Cupón",
      "Service Fee & Tax": "Tarifa de Servicio e Impuestos",
      "Additional Patient Charge": "Cargo Adicional por Paciente",
      "Total Payable Amount": "Monto Total a Pagar",
      "View Detailed Bill": "Ver Factura Detallada",
      "Proceed": "Proceder",
      "Best Coupon": "Mejor Cupón",
      "Coupon Code": "Código de Cupón",
      "Coupon Amount": "Monto del Cupón",
      "Minimum Amount": "Monto Mínimo",
      "Ex Date": "Fecha de Expiración",
      "Apply Coupons": "Aplicar Cupones",
      "Select Payment Method": "Seleccionar Método de Pago",
      "Category": "Categoría",
      "Lab Details": "Detalles del Laboratorio",
      "Popular Tests": "Pruebas Populares",
      "Affordable Packages": "Paquetes Asequibles",
      "Recommended Packages": "Paquetes Recomendados",
      "Item in Cart": "Artículo en el Carrito",
      "Home Collect Extra Price": "Precio Extra por Recolección en Casa",
      "Sample Type": "Tipo de Muestra",
      "Fasting Required": "Ayuno Requerido",
      "Test Report Time": "Tiempo de Informe de Prueba",
      "Package Includes": "El Paquete Incluye",
      "Package Description": "Descripción del Paquete",
      "Test Details & Package Details": "Detalles de la Prueba y del Paquete",
      "Remove Cart?": "¿Eliminar Carrito?",
      "Are You Sure You Want To Delete All Items?": "¿Seguro que deseas eliminar todos los artículos?",
      "From Urine Test Report": "Del Informe de Prueba de Orina",
      "Cancel": "Cancelar",
      "Select Sample Collection Slot": "Seleccionar Franja para Recolección de Muestra",
      "Select Date": "Seleccionar Fecha",
      "Select Time": "Seleccionar Hora",
      "Symptoms / Private Note": "Síntomas / Nota Privada",
      "Home Service (Collect my test sample)": "Servicio a Domicilio (Recolectar mi muestra)",
      "Additional Cost Required to Pay": "Costo Adicional a Pagar",
      "Your Lab Appointment Location": "Ubicación de tu Cita de Laboratorio",
      "Kindly visit the address below for your scheduled lab services.": "Por favor visita la dirección a continuación para tus servicios programados de laboratorio.",
      "Choose a Delivery Address": "Elige una Dirección de Entrega",
      "Add New Address": "Agregar Nueva Dirección",
      "Save Address As": "Guardar Dirección Como",
      "Save Address": "Guardar Dirección",
      "We Come to You": "Vamos a Ti",
      "Choose your address for hassle-free sample collection at home": "Elige tu dirección para recolección de muestras sin complicaciones en casa",
      "Home Collection Free": "Recolección en Casa Gratis",
      "Our Category": "Nuestra Categoría",
      "Shop": "Tienda",
      "Shop List": "Lista de Tiendas",
      "Categories": "Categorías",
      "Bestseller Products": "Productos Más Vendidos",
      "Add": "Agregar",
      "Option": "Opción",
      "No Store Available": "No hay tienda disponible",
      "In Your Area.": "En tu área.",
      "Done": "Hecho",
      "View Cart": "Ver Carrito",
      "Items": "Artículos",
      "Shop Home Page": "Página Principal de la Tienda",
      "Checkout": "Pagar",
      "Order Details": "Detalles del Pedido",
      "Your Uploaded Prescription": "Tu Receta Cargada",
      "+ Add Prescription": "+ Agregar Receta",
      "+ Add More": "+ Agregar Más",
      "Total Price": "Precio Total",
      "Select Delivery Address": "Seleccionar Dirección de Entrega",
      "We deliver the product to this address.": "Entregamos el producto en esta dirección.",
      "Shop Total": "Total de la Tienda",
      "Commission Rate (Fixed)": "Tasa de Comisión (Fija)",
      "Continue Total Payable Amount": "Continuar con el Monto Total a Pagar",
      "Packages": "Paquetes",
      "Cart Booking": "Reserva del Carrito",
      "My Booking": "Mi Reserva",
      "My Order": "Mi Pedido",
      "Booking Package": "Paquete de Reserva",
      "Refer & Earn": "Invita y Gana",
      "Language": "Idioma",
      "Chat": "Chat",
      "Log Out": "Cerrar Sesión",
      "Current Booking": "Reserva Actual",
      "Past Booking": "Reservas Anteriores",
      "Call Doctor": "Llamar al Doctor",
      "No Booking Placed!!": "¡No se ha Realizado Ninguna Reserva!",
      "Currently You Don't Have Any Booking": "Actualmente no tienes ninguna reserva",
      "Call": "Llamar",
      "About Appointment": "Sobre la Cita",
      "Patient Info": "Información del Paciente",
      "In Person Appointment": "Cita Presencial",
      "In Video Appointment": "Cita por Video",
      "OTP Info": "Información de OTP",
      "QR Code": "Código QR",
      "Appointment Checklists": "Listas de Verificación para la Cita",
      "Download Prescription": "Descargar Receta",
      "Booking Date & Time Info": "Información de Fecha y Hora de la Cita",
      "Bill Summary": "Resumen de la Factura",
      "Doctor Consultation Charge": "Cargo por Consulta Médica",
      "Additional Price": "Precio Adicional",
      "Doctor Commission": "Comisión del Doctor",
      "Wallet Amount": "Monto en Billetera",
      "Payment": "Pago",
      "Hospital Address": "Dirección del Hospital",
      "Health Concerns": "Preocupaciones de Salud",
      "Add Health Documents": "Agregar Documentos Médicos",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Ej. Recetas anteriores, informes de pruebas, fotos, etc.",
      "Maximum File Upload Size": "Tamaño Máximo de Archivo",
      "Document": "Documento",
      "Add Photo": "Agregar Foto",
      "Add Document": "Agregar Documento",
      "Submit Details": "Enviar Detalles",
      "Virtual and Physical": "Virtual y Presencial",
      "Diagnosis Test": "Prueba de Diagnóstico",
      "Medicine": "Medicina",
      "Information": "Información",
      "Medicine Name": "Nombre del Medicamento",
      "Time": "Hora",
      "Dosage": "Dosis",
      "Duration": "Duración",
      "Frequency": "Frecuencia",
      "Instructions": "Instrucciones",
      "Select Reason": "Seleccionar Motivo",
      "Please Select the Reason for Cancellation": "Por favor, selecciona el motivo de la cancelación",
      "Confirm": "Confirmar",
      "Current Order": "Pedido Actual",
      "Past Order": "Pedidos Anteriores",
      "Info": "Información",
      "No Order Placed!!": "¡No se ha Realizado Ningún Pedido!",
      "Currently You Don't Have Any Order": "Actualmente no tienes ningún pedido",
      "Order Info": "Información del Pedido",
      "Medicine Prescription": "Receta Médica",
      "Order Status": "Estado del Pedido",
      "Pending": "Pendiente",
      "Processing": "Procesando",
      "On Route": "En Camino",
      "Payment & Address Info": "Información de Pago y Dirección",
      "Seller Commission": "Comisión del Vendedor",
      "Site Commission": "Comisión del Sitio",
      "Payment Method": "Método de Pago",
      "Address": "Dirección",
      "Paid from Wallet": "Pagado desde la Billetera",
      "Online Paid": "Pagado en Línea",
      "Deliver": "Entregar",
      "Complete": "Completado",
      "Check Status": "Verificar Estado",
      "Report": "Informe",
      "Package Charge": "Cargo del Paquete",
      "Home Collection Fee": "Tarifa de Recolección a Domicilio",
      "TOTAL WALLET BALANCE": "SALDO TOTAL DE LA CARTERA",
      "Top Up": "Recargar",
      "Transaction History": "Historial de Transacciones",
      "Go & Add Your Amount": "Ve y Agrega Tu Monto",
      "Continue": "Continuar",
      "Add Wallet Amount": "Agregar Monto a la Cartera",
      "Earn": "Ganar",
      "For Each Friend You Refer": "Por Cada Amigo que Refieras",
      "Share the Referral Link with Your Friends": "Comparte el Enlace de Referencia con Tus Amigos",
      "Friend Gets": "Tu Amigo Recibe",
      "On First Complete Transaction": "En su Primera Transacción Completa",
      "You Get": "Tú Recibes",
      "On Your Wallet": "En Tu Cartera",
      "Select User": "Seleccionar Usuario",
      "Send Notification": "Enviar Notificación",
      "Appointment Cancel": "Cita Cancelada",
      "Product Amount": "Monto del Producto",
      "Login": "Iniciar Sesión",
      "Search Doctor": "Buscar Médico",
      "Incoming Video Call From": "Llamada de Video Entrante de",
      "Patient Name": "Nombre del Paciente",
      "Relationship": "Relación",
      "Blood Type": "Tipo de Sangre",
      "Patient Gender": "Género del Paciente",
      "Male": "Masculino",
      "Female": "Femenino",
      "Patient Age": "Edad del Paciente",
      "National ID": "Identificación Nacional",
      "Height": "Altura",
      "Weight": "Peso",
      "Allergies": "Alergias",
      "Medical History": "Historial Médico",
      "SUBMIT": "ENVIAR",
      "Relationship Type": "Tipo de Relación",
      "Includes": "Incluye",
      "tests": "pruebas",
      "Reports in": "Informes en",
      "Hours": "Horas",
      "Package Price": "Precio del Paquete",
      "Prescription Required": "Requiere Receta Médica",
      "No Store available": "No hay Tiendas Disponibles",
      "in your area.": "en tu zona.",
      "Call doctor": "Llamar al médico",
      "No Booking placed !!": "¡No se ha Realizado Ninguna Reserva!",
      "Currently you don't have any Booking": "Actualmente no tienes ninguna Reserva",
      "Required for voice and video calls. Make": "Requerido para llamadas de voz y video. Asegúrate de que",
      "sure your audio device (headset, speakers,": "tu dispositivo de audio (auriculares, altavoces,",
      "or microphone) is connected and working.": "o micrófono) esté conectado y funcionando.",
      "Vital & Physical Information": "Información Vital y Física",
      "Physical examination details": "Detalles del Examen Físico",
      "Drugs & Prescription Info": "Medicamentos e Información de Recetas",
      "Medications prescription and dosage instructions": "Recetas de medicamentos e instrucciones de dosificación",
      "Diagnosis Tests": "Pruebas de Diagnóstico",
      "Medical tests and diagnostic evaluations": "Pruebas médicas y evaluaciones diagnósticas",
      "Booking": "Reserva",
      "Share Health Concerns": "Comparte Preocupaciones de Salud",
      "With": "Con",
      "prior to your consultation": "antes de tu consulta",
      "Enter Disease": "Ingresar Enfermedad",
      "Start OTP": "Iniciar OTP",
      "End OTP": "Finalizar OTP",
      "Appointment ID": "ID de la Cita",
      "Accepted": "Aceptado",
      "Collector Assigned": "Recolector Asignado",
      "Ongoing": "En Curso",
      "Completed": "Completado",
      "Cancelled": "Cancelado",
      "YourOrderPlaced": "Esperando confirmación del laboratorio.",
      "OrderPending": "El laboratorio ha aceptado la solicitud de cita.",
      "OrderDelivering": "La cita está en progreso.",
      "ProductDelivered": "Las pruebas de laboratorio están siendo procesadas y analizadas.",
      "OrderDelivered": "La cita y todas las pruebas relacionadas están completadas.",
      "CollectorAssigned": "Se ha asignado un técnico de laboratorio para la recolección de muestras.",
      "Search...": "Buscar...",
      "Say Something...": "Di Algo...",
      "Please Select User !!": "¡Por Favor Selecciona un Usuario!",
      "Please Write Message !!": "¡Por Favor Escribe un Mensaje!",
      "Add Patient Photo": "Agregar Foto del Paciente",
      "Add Patient Details": "Agregar Detalles del Paciente",
      "You cannot book this time": "No puedes reservar esta hora",
      "This time is already book": "Esta hora ya está reservada",
      "Select time for your appointment!": "¡Selecciona la hora para tu cita!",
      "Coupon Add Successful": "Cupón Agregado Exitosamente",
      "Please Select Patient": "Por Favor Selecciona un Paciente",
      "Please Select Date & Time": "Por Favor Selecciona Fecha y Hora",
      "Please Select Address": "Por Favor Selecciona una Dirección",
      "Please Enter Details": "Por Favor Ingresa los Detalles",
      "Edit Profile": "Editar Perfil",
      "Update": "Actualizar",
      "Please Select Patients": "Por Favor Selecciona Pacientes",
      "Add patient prescription": "Agregar Receta del Paciente",
      "Select deliver address": "Seleccionar Dirección de Entrega",
      "Select Cancel Reason": "Seleccionar Motivo de Cancelación",
      "Enter Other Reason": "Ingresar Otro Motivo",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "El médico no ha subido tus detalles. Por favor, contáctalo para actualizar tu información.",
      "Upload Profile Photo": "Subir Foto de Perfil",
      "Enter details": "Ingresar detalles",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Aún no se ha subido ningún informe de laboratorio. Se te notificará cuando esté disponible.",
      "Text copied to clipboard !!": "¡Texto copiado al portapapeles!",
      "Logout Successful!": "¡Cierre de sesión exitoso!",
      "Please Enter Amount": "Por Favor Ingresa el Monto",
      "Please enter number": "Por Favor Ingresa un Número",
      "Please enter password": "Por Favor Ingresa la Contraseña",
      "OTP is invalid !!": "¡El OTP no es válido!",
      "Please Enter a Valid Email": "Por Favor Ingresa un Correo Válido",
      "No Doctor available in your area.": "No hay ningún médico disponible en tu área.",
      "ID": "ID",
      "No Lab available in your area.": "No hay ningún laboratorio disponible en tu área.",
      "Book Now": "Reservar ahora",
      "You have successfully booking": "Has reservado con éxito",
      "Booking Fee": "Tarifa de reserva",
      "Clinic name": "Nombre de la clínica",
      "Department name": "Nombre del departamento",
      "SubType": "Subtipo",
      "Transaction Dtails": "Detalles de la transacción",
      "Payment Type": "Tipo de pago",
      "View Booking": "Ver reserva",
      "1 Love this": "1 Me encanta",
      "Reviews": "Reseñas",
      "Currently you don't have any": "Actualmente no tienes ninguno",
      "doctor in you area!.": "¡No hay ningún médico en tu área!",
      "No Doctor yet!": "¡Aún no hay ningún médico!",
      "Leave a Review": "Dejar una reseña",
      "How was your experience": "¿Cómo fue tu experiencia?",
      "Maybe Later": "Quizás más tarde",
      "Submit": "Enviar",
      "Write Your Rewiew": "Escribe tu reseña",
      "Your reviewe here..": "Escribe tu reseña aquí..",
      "Home Collect Person": "Persona de recogida a domicilio",
      "Name": "Nombre",
      "Email": "Correo electrónico",
      "Phone Number": "Número de teléfono",
      "Appointment": "Cita",
      "Comment": "Comentario",
      "Order ID": "ID de pedido",
      "Enter Amount": "Ingresar monto",
      "Appointment Date & Time Info": "Información de fecha y hora de la cita",
      "Upload": "Subir",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Desarrollado por GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Elíjanos para una limpieza confiable y detallada",
      "that meets all your cleanliness needs.": "que cubra todas sus necesidades de limpieza.",
      "Enable Location Services": "Habilitar servicios de ubicación",
      "To provide accurate services, please enable your location.": "Para proporcionar servicios precisos, por favor habilita tu ubicación.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Permite el acceso a la ubicación cuando se te solicite. Si no se solicita, habilítalo en la configuración de tu navegador.",
      "Refresh the page after enabling.": "Actualiza la página después de habilitarlo.",
      "Enable Now": "Habilitar ahora",
      "TransactionId": "Identificador de transacción",
      "Search Hevan Medical Store Product": "Buscar productos de la tienda médica Hevan",
      "No product yet!": "¡Aún no hay productos!",
      "product in you area!.": "No hay productos en tu zona.",
      "No Doctors found !!": "¡No se encontraron médicos!",
      "No messages found !!": "¡No se encontraron mensajes!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Una solución para citas médicas se refiere a un sistema, a menudo en forma de aplicación, que agiliza el proceso de reserva,",
      "managing, and attending doctor's appointments.": "gestión y asistencia a las citas con el médico.",
      "Shop by Categories": "Comprar por categorías",
      "No Store yet!": "¡Aún no hay tiendas!",
      "store in you area!.": "Tienda en tu área.",
      "Search by store": "Buscar por tienda",
      "Your Token": "Tu turno",
      "Waiting": "En espera",
      "Now Serving": "Atendiendo ahora",
      "Ahead fo You": "Delante de ti",
      "Add New Patient": "Agregar nuevo paciente",
      "Book Today": "Reservar hoy",
      "View All": "Ver todo",
      "Cancellation Policy": "Política de cancelación",
      "Clinic Photos": "Fotos de la clínica",
      "No review": "Sin reseñas",
      "years": "años",
      "Video": "Video",
      "No doctors found": "No se encontraron doctores",
      "Try adjusting your search": "Intenta ajustar tu búsqueda",
      "Clinic": "Clínica",
      "Welcome back": "Bienvenido de nuevo",
      "Manage your health services": "Gestiona tus servicios de salud",
      "Logout": "Cerrar sesión",
      "Wallet Balance": "Saldo de la cartera",
      "My Profile (Member Since)": "Mi perfil (Miembro desde)",
      "Only JPG, PNG, WEBP files are allowed!": "¡Solo se permiten archivos JPG, PNG o WEBP!",
      "My Profile": "Mi perfil",
      "Full Name": "Nombre completo",
      "Email Address": "Correo electrónico",
      "Password": "Contraseña",
      "Save Changes": "Guardar cambios",
      "Enter Password (Optional)": "Ingresar contraseña (Opcional)"
    }
  },
  fr: {
    translation: {
      "Emergency Line": "Ligne d'urgence",
      "Support Email": "Email de support",
      "Doctor Appointment": "Rendez-vous médical",
      "Book": "Réserver",
      "Lab Booking": "Réservation de laboratoire",
      "Medicine Booking": "Réservation de médicaments",
      "Skins": "Soins de la peau",
      "Care & Vitamin": "Soins & Vitamines",
      "My Patient": "Mon patient",
      "Add New": "Ajouter nouveau",
      "Your Favorites": "Vos favoris",
      "Doctor Your Love": "Médecin que vous aimez",
      "Go Home": "Aller à l'accueil",
      "Home": "Accueil",
      "Our Services": "Nos services",
      "In Person": "En personne",
      "Video Visit": "Visite vidéo",
      "Total Experience": "Expérience totale",
      "Rating": "Évaluation",
      "Consultation Fee": "Frais de consultation",
      "Book Appointment": "Prendre rendez-vous",
      "Doctor Details": "Détails du médecin",
      "FAQs": "FAQs",
      "Cancel Policy": "Politique d'annulation",
      "About": "À propos",
      "Review": "Avis",
      "Awards": "Récompenses",
      "Photos": "Photos",
      "Service": "Service",
      "Availability": "Disponibilité",
      "Morning": "Matin",
      "Afternoon": "Après-midi",
      "Evening": "Soirée",
      "Loading...": "Chargement...",
      "Clinic Details": "Détails de la clinique",
      "Doctor Bio": "Biographie du médecin",
      "Doctor Profile": "Profil du médecin",
      "Years Experience": "Années d'expérience",
      "Appointment Details": "Détails du rendez-vous",
      "Select Patient": "Sélectionner un patient",
      "Message": "Message",
      "Pay from Wallet": "Payer depuis le portefeuille",
      "My Wallet": "Mon portefeuille",
      "Apply Coupon": "Appliquer un coupon",
      "Use Code": "Utiliser le code",
      "Remove": "Supprimer",
      "Apply": "Appliquer",
      "View All Coupons": "Voir tous les coupons",
      "Review Your Requirements for This Request": "Vérifiez vos exigences pour cette demande",
      "Service Total": "Total du service",
      "Additional Service Charge(s)": "Frais de service supplémentaires",
      "Wallet": "Portefeuille",
      "Coupon": "Coupon",
      "Service Fee & Tax": "Frais de service et taxes",
      "Additional Patient Charge": "Frais supplémentaires pour le patient",
      "Total Payable Amount": "Montant total à payer",
      "View Detailed Bill": "Voir la facture détaillée",
      "Proceed": "Procéder",
      "Best Coupon": "Meilleur coupon",
      "Coupon Code": "Code promo",
      "Coupon Amount": "Montant du coupon",
      "Minimum Amount": "Montant minimum",
      "Ex Date": "Date d'expiration",
      "Apply Coupons": "Appliquer les coupons",
      "Select Payment Method": "Sélectionner le mode de paiement",
      "Category": "Catégorie",
      "Lab Details": "Détails du laboratoire",
      "Popular Tests": "Tests populaires",
      "Affordable Packages": "Forfaits abordables",
      "Recommended Packages": "Forfaits recommandés",
      "Item in Cart": "Article dans le panier",
      "Home Collect Extra Price": "Frais supplémentaires pour la collecte à domicile",
      "Sample Type": "Type d'échantillon",
      "Fasting Required": "Jeûne requis",
      "Test Report Time": "Délai du rapport de test",
      "Package Includes": "Le forfait comprend",
      "Package Description": "Description du forfait",
      "Test Details & Package Details": "Détails du test et du forfait",
      "Remove Cart?": "Supprimer le panier ?",
      "Are You Sure You Want To Delete All Items?": "Êtes-vous sûr de vouloir supprimer tous les articles ?",
      "From Urine Test Report": "À partir du rapport d'analyse d'urine",
      "Cancel": "Annuler",
      "Select Sample Collection Slot": "Sélectionner un créneau de collecte d'échantillon",
      "Select Date": "Sélectionner la date",
      "Select Time": "Sélectionner l'heure",
      "Symptoms / Private Note": "Symptômes / Note privée",
      "Home Service (Collect my test sample)": "Service à domicile (Collecte de mon échantillon)",
      "Additional Cost Required to Pay": "Coût supplémentaire à payer",
      "Your Lab Appointment Location": "Lieu de votre rendez-vous au laboratoire",
      "Kindly visit the address below for your scheduled lab services.": "Veuillez vous rendre à l'adresse ci-dessous pour vos services de laboratoire prévus.",
      "Choose a Delivery Address": "Choisir une adresse de livraison",
      "Add New Address": "Ajouter une nouvelle adresse",
      "Save Address As": "Enregistrer l'adresse sous",
      "Save Address": "Enregistrer l'adresse",
      "We Come to You": "Nous venons à vous",
      "Choose your address for hassle-free sample collection at home": "Choisissez votre adresse pour une collecte d'échantillons à domicile sans tracas",
      "Home Collection Free": "Collecte à domicile gratuite",
      "Our Category": "Notre catégorie",
      "Shop": "Boutique",
      "Shop List": "Liste des boutiques",
      "Categories": "Catégories",
      "Bestseller Products": "Produits les plus vendus",
      "Add": "Ajouter",
      "Option": "Option",
      "No Store Available": "Aucun magasin disponible",
      "In Your Area.": "Dans votre région.",
      "Done": "Terminé",
      "View Cart": "Voir le panier",
      "Items": "Articles",
      "Shop Home Page": "Page d'accueil de la boutique",
      "Checkout": "Paiement",
      "Order Details": "Détails de la commande",
      "Your Uploaded Prescription": "Votre ordonnance téléchargée",
      "+ Add Prescription": "+ Ajouter une ordonnance",
      "+ Add More": "+ Ajouter plus",
      "Total Price": "Prix total",
      "Select Delivery Address": "Sélectionner l'adresse de livraison",
      "We deliver the product to this address.": "Nous livrons le produit à cette adresse.",
      "Shop Total": "Total de la boutique",
      "Commission Rate (Fixed)": "Taux de commission (fixe)",
      "Continue Total Payable Amount": "Continuer le montant total à payer",
      "Packages": "Forfaits",
      "Cart Booking": "Réservation du panier",
      "My Booking": "Ma réservation",
      "My Order": "Ma commande",
      "Booking Package": "Forfait de réservation",
      "Refer & Earn": "Parrainez et gagnez",
      "Language": "Langue",
      "Chat": "Discussion",
      "Log Out": "Se déconnecter",
      "Current Booking": "Réservation en cours",
      "Past Booking": "Réservations passées",
      "Call Doctor": "Appeler le médecin",
      "No Booking Placed!!": "Aucune réservation effectuée !!",
      "Currently You Don't Have Any Booking": "Vous n'avez actuellement aucune réservation",
      "Call": "Appeler",
      "About Appointment": "À propos du rendez-vous",
      "Patient Info": "Informations du patient",
      "In Person Appointment": "Rendez-vous en personne",
      "In Video Appointment": "Rendez-vous en vidéo",
      "OTP Info": "Infos OTP",
      "QR Code": "Code QR",
      "Appointment Checklists": "Listes de contrôle du rendez-vous",
      "Download Prescription": "Télécharger l'ordonnance",
      "Booking Date & Time Info": "Informations sur la date et l'heure du rendez-vous",
      "Bill Summary": "Résumé de la facture",
      "Doctor Consultation Charge": "Frais de consultation du médecin",
      "Additional Price": "Coût supplémentaire",
      "Doctor Commission": "Commission du médecin",
      "Wallet Amount": "Montant du portefeuille",
      "Payment": "Paiement",
      "Hospital Address": "Adresse de l'hôpital",
      "Health Concerns": "Problèmes de santé",
      "Add Health Documents": "Ajouter des documents médicaux",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Par ex. ordonnance précédente, rapport de test, photo, etc.",
      "Maximum File Upload Size": "Taille maximale de fichier autorisée",
      "Document": "Document",
      "Add Photo": "Ajouter une photo",
      "Add Document": "Ajouter un document",
      "Submit Details": "Soumettre les détails",
      "Virtual and Physical": "Virtuel et physique",
      "Diagnosis Test": "Test de diagnostic",
      "Medicine": "Médicament",
      "Information": "Information",
      "Medicine Name": "Nom du médicament",
      "Time": "Heure",
      "Dosage": "Dosage",
      "Duration": "Durée",
      "Frequency": "Fréquence",
      "Instructions": "Instructions",
      "Select Reason": "Sélectionner une raison",
      "Please Select the Reason for Cancellation": "Veuillez sélectionner la raison de l'annulation",
      "Confirm": "Confirmer",
      "Current Order": "Commande en cours",
      "Past Order": "Commandes passées",
      "Info": "Infos",
      "No Order Placed!!": "Aucune commande effectuée !!",
      "Currently You Don't Have Any Order": "Vous n'avez actuellement aucune commande",
      "Order Info": "Informations sur la commande",
      "Medicine Prescription": "Ordonnance médicale",
      "Order Status": "Statut de la commande",
      "Pending": "En attente",
      "Processing": "En traitement",
      "On Route": "En route",
      "Payment & Address Info": "Informations de paiement et d'adresse",
      "Seller Commission": "Commission du vendeur",
      "Site Commission": "Commission du site",
      "Payment Method": "Méthode de paiement",
      "Address": "Adresse",
      "Paid from Wallet": "Payé depuis le portefeuille",
      "Online Paid": "Payé en ligne",
      "Deliver": "Livrer",
      "Complete": "Terminé",
      "Check Status": "Vérifier le statut",
      "Report": "Rapport",
      "Package Charge": "Frais du forfait",
      "Home Collection Fee": "Frais de collecte à domicile",
      "TOTAL WALLET BALANCE": "SOLDE TOTAL DU PORTEFEUILLE",
      "Top Up": "Recharger",
      "Transaction History": "Historique des transactions",
      "Go & Add Your Amount": "Allez ajouter votre montant",
      "Continue": "Continuer",
      "Add Wallet Amount": "Ajouter un montant au portefeuille",
      "Earn": "Gagner",
      "For Each Friend You Refer": "Pour chaque ami que vous parrainez",
      "Share the Referral Link with Your Friends": "Partagez le lien de parrainage avec vos amis",
      "Friend Gets": "Votre ami reçoit",
      "On First Complete Transaction": "À la première transaction complète",
      "You Get": "Vous recevez",
      "On Your Wallet": "Sur votre portefeuille",
      "Select User": "Sélectionner un utilisateur",
      "Send Notification": "Envoyer une notification",
      "Appointment Cancel": "Annulation de rendez-vous",
      "Product Amount": "Montant du produit",
      "Login": "Connexion",
      "Search Doctor": "Rechercher un médecin",
      "Incoming Video Call From": "Appel vidéo entrant de",
      "Patient Name": "Nom du patient",
      "Relationship": "Relation",
      "Blood Type": "Groupe sanguin",
      "Patient Gender": "Sexe du patient",
      "Male": "Homme",
      "Female": "Femme",
      "Patient Age": "Âge du patient",
      "National ID": "ID national",
      "Height": "Taille",
      "Weight": "Poids",
      "Allergies": "Allergies",
      "Medical History": "Antécédents médicaux",
      "SUBMIT": "SOUMETTRE",
      "Relationship Type": "Type de relation",
      "Includes": "Comprend",
      "tests": "tests",
      "Reports in": "Rapports dans",
      "Hours": "Heures",
      "Package Price": "Prix du forfait",
      "Prescription Required": "Ordonnance requise",
      "No Store available": "Aucun magasin disponible",
      "in your area.": "dans votre région.",
      "Call doctor": "Appeler le médecin",
      "No Booking placed !!": "Aucune réservation effectuée !!",
      "Currently you don't have any Booking": "Vous n'avez actuellement aucune réservation",
      "Required for voice and video calls. Make": "Nécessaire pour les appels vocaux et vidéo. Assurez-vous",
      "sure your audio device (headset, speakers,": "que votre périphérique audio (casque, haut-parleurs,",
      "or microphone) is connected and working.": "ou microphone) est connecté et fonctionne.",
      "Vital & Physical Information": "Informations vitales et physiques",
      "Physical examination details": "Détails de l'examen physique",
      "Drugs & Prescription Info": "Infos sur les médicaments et prescriptions",
      "Medications prescription and dosage instructions": "Ordonnances et instructions de dosage des médicaments",
      "Diagnosis Tests": "Tests de diagnostic",
      "Medical tests and diagnostic evaluations": "Tests médicaux et évaluations diagnostiques",
      "Booking": "Réservation",
      "Share Health Concerns": "Partager les préoccupations de santé",
      "With": "Avec",
      "prior to your consultation": "avant votre consultation",
      "Enter Disease": "Saisir la maladie",
      "Start OTP": "Démarrer OTP",
      "End OTP": "Terminer OTP",
      "Appointment ID": "ID du rendez-vous",
      "Accepted": "Accepté",
      "Collector Assigned": "Collecteur assigné",
      "Ongoing": "En cours",
      "Completed": "Terminé",
      "Cancelled": "Annulé",
      "YourOrderPlaced": "En attente de confirmation du laboratoire.",
      "OrderPending": "Le laboratoire a accepté la demande de rendez-vous.",
      "OrderDelivering": "Le rendez-vous est en cours.",
      "ProductDelivered": "Les analyses de laboratoire sont en cours de traitement et d’analyse.",
      "OrderDelivered": "Le rendez-vous et tous les tests associés sont terminés.",
      "CollectorAssigned": "Un technicien de laboratoire a été assigné pour la collecte des échantillons.",
      "Search...": "Rechercher...",
      "Say Something...": "Dites quelque chose...",
      "Please Select User !!": "Veuillez sélectionner un utilisateur !!",
      "Please Write Message !!": "Veuillez écrire un message !!",
      "Add Patient Photo": "Ajouter une photo du patient",
      "Add Patient Details": "Ajouter les détails du patient",
      "You cannot book this time": "Vous ne pouvez pas réserver à cette heure",
      "This time is already book": "Cette heure est déjà réservée",
      "Select time for your appointment!": "Sélectionnez l'heure de votre rendez-vous !",
      "Coupon Add Successful": "Coupon ajouté avec succès",
      "Please Select Patient": "Veuillez sélectionner un patient",
      "Please Select Date & Time": "Veuillez sélectionner la date et l'heure",
      "Please Select Address": "Veuillez sélectionner une adresse",
      "Please Enter Details": "Veuillez entrer les détails",
      "Edit Profile": "Modifier le profil",
      "Update": "Mettre à jour",
      "Please Select Patients": "Veuillez sélectionner des patients",
      "Add patient prescription": "Ajouter une ordonnance pour le patient",
      "Select deliver address": "Sélectionner l'adresse de livraison",
      "Select Cancel Reason": "Sélectionner une raison d'annulation",
      "Enter Other Reason": "Entrer une autre raison",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Le médecin n'a pas encore téléchargé vos informations. Veuillez le contacter pour les mettre à jour.",
      "Upload Profile Photo": "Télécharger une photo de profil",
      "Enter details": "Entrer les détails",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Aucun rapport de laboratoire n’a encore été téléchargé. Vous serez notifié dès qu’il sera disponible.",
      "Text copied to clipboard !!": "Texte copié dans le presse-papiers !!",
      "Logout Successful!": "Déconnexion réussie !",
      "Please Enter Amount": "Veuillez entrer un montant",
      "Please enter number": "Veuillez entrer un numéro",
      "Please enter password": "Veuillez entrer un mot de passe",
      "OTP is invalid !!": "Le code OTP est invalide !!",
      "Please Enter a Valid Email": "Veuillez entrer un email valide",
      "No Doctor available in your area.": "Aucun médecin n'est disponible dans votre région.",
      "ID": "ID",
      "No Lab available in your area.": "Aucun laboratoire n'est disponible dans votre région.",
      "Book Now": "Réserver maintenant",
      "You have successfully booking": "Votre réservation a été effectuée avec succès",
      "Booking Fee": "Frais de réservation",
      "Clinic name": "Nom de la clinique",
      "Department name": "Nom du département",
      "SubType": "Sous-type",
      "Transaction Dtails": "Détails de la transaction",
      "Payment Type": "Type de paiement",
      "View Booking": "Voir la réservation",
      "1 Love this": "1 J'adore",
      "Reviews": "Avis",
      "Currently you don't have any": "Actuellement, vous n'en avez aucun",
      "doctor in you area!.": "Aucun médecin dans votre région !",
      "No Doctor yet!": "Pas encore de médecin !",
      "Leave a Review": "Laisser un avis",
      "How was your experience": "Comment s'est passée votre expérience ?",
      "Maybe Later": "Peut-être plus tard",
      "Submit": "Soumettre",
      "Write Your Rewiew": "Écrivez votre avis",
      "Your reviewe here..": "Écrivez votre avis ici..",
      "Home Collect Person": "Personne de collecte à domicile",
      "Name": "Nom",
      "Email": "E-mail",
      "Phone Number": "Numéro de téléphone",
      "Appointment": "Rendez-vous",
      "Comment": "Commentaire",
      "Order ID": "ID de commande",
      "Enter Amount": "Entrer le montant",
      "Appointment Date & Time Info": "Informations sur la date et l'heure du rendez-vous",
      "Upload": "Téléverser",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Propulsé par GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Choisissez-nous pour un nettoyage fiable et minutieux",
      "that meets all your cleanliness needs.": "qui répond à tous vos besoins en matière de propreté.",
      "Enable Location Services": "Activer les services de localisation",
      "To provide accurate services, please enable your location.": "Pour fournir des services précis, veuillez activer votre localisation.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Autorisez l'accès à la localisation lorsqu'on vous le demande. Si ce n'est pas le cas, activez-la dans les paramètres de votre navigateur.",
      "Refresh the page after enabling.": "Rafraîchissez la page après l'activation.",
      "Enable Now": "Activer maintenant",
      "TransactionId": "Identifiant de transaction",
      "Search Hevan Medical Store Product": "Rechercher des produits du magasin médical Hevan",
      "No product yet!": "Aucun produit pour le moment !",
      "product in you area!.": "Aucun produit dans votre région.",
      "No Doctors found !!": "Aucun médecin trouvé !!",
      "No messages found !!": "Aucun message trouvé !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Une solution de prise de rendez-vous médicaux désigne un système, souvent sous forme d'application, qui simplifie le processus de réservation,",
      "managing, and attending doctor's appointments.": "de gestion et de participation aux rendez-vous médicaux.",
      "Shop by Categories": "Acheter par catégories",
      "No Store yet!": "Aucun magasin pour le moment !",
      "store in you area!.": "Magasin dans votre région.",
      "Search by store": "Rechercher par magasin",
      "Your Token": "Votre ticket",
      "Waiting": "En attente",
      "Now Serving": "En cours de service",
      "Ahead fo You": "Devant vous",
      "Add New Patient": "Ajouter un nouveau patient",
      "Book Today": "Réserver aujourd'hui",
      "View All": "Voir tout",
      "Cancellation Policy": "Politique d'annulation",
      "Clinic Photos": "Photos de la clinique",
      "No review": "Pas d'avis",
      "years": "ans",
      "Video": "Vidéo",
      "No doctors found": "Aucun médecin trouvé",
      "Try adjusting your search": "Essayez d'ajuster votre recherche",
      "Clinic": "Clinique",
      "Welcome back": "Bon retour",
      "Manage your health services": "Gérez vos services de santé",
      "Logout": "Se déconnecter",
      "Wallet Balance": "Solde du portefeuille",
      "My Profile (Member Since)": "Mon profil (Membre depuis)",
      "Only JPG, PNG, WEBP files are allowed!": "Seuls les fichiers JPG, PNG ou WEBP sont autorisés !",
      "My Profile": "Mon profil",
      "Full Name": "Nom complet",
      "Email Address": "Adresse e-mail",
      "Password": "Mot de passe",
      "Save Changes": "Enregistrer les modifications",
      "Enter Password (Optional)": "Entrer le mot de passe (Optionnel)"
    }
  },
  ge: {
    translation: {
      "Emergency Line": "Notrufnummer",
      "Support Email": "Support-E-Mail",
      "Doctor Appointment": "Arzttermin",
      "Book": "Buchen",
      "Lab Booking": "Laborbuchung",
      "Medicine Booking": "Medikamentenbestellung",
      "Skins": "Hautpflege",
      "Care & Vitamin": "Pflege & Vitamine",
      "My Patient": "Mein Patient",
      "Add New": "Neu hinzufügen",
      "Your Favorites": "Ihre Favoriten",
      "Doctor Your Love": "Ihr Lieblingsarzt",
      "Go Home": "Zur Startseite",
      "Home": "Startseite",
      "Our Services": "Unsere Leistungen",
      "In Person": "Persönlich",
      "Video Visit": "Video-Besuch",
      "Total Experience": "Gesamterfahrung",
      "Rating": "Bewertung",
      "Consultation Fee": "Beratungskosten",
      "Book Appointment": "Termin buchen",
      "Doctor Details": "Arztdetails",
      "FAQs": "Häufige Fragen",
      "Cancel Policy": "Stornierungsbedingungen",
      "About": "Über uns",
      "Review": "Bewertung",
      "Awards": "Auszeichnungen",
      "Photos": "Fotos",
      "Service": "Service",
      "Availability": "Verfügbarkeit",
      "Morning": "Morgen",
      "Afternoon": "Nachmittag",
      "Evening": "Abend",
      "Loading...": "Lädt...",
      "Clinic Details": "Klinikdetails",
      "Doctor Bio": "Arztbiografie",
      "Doctor Profile": "Arztprofil",
      "Years Experience": "Jahre Erfahrung",
      "Appointment Details": "Termindetails",
      "Select Patient": "Patient auswählen",
      "Message": "Nachricht",
      "Pay from Wallet": "Vom Wallet bezahlen",
      "My Wallet": "Mein Wallet",
      "Apply Coupon": "Gutschein einlösen",
      "Use Code": "Code verwenden",
      "Remove": "Entfernen",
      "Apply": "Anwenden",
      "View All Coupons": "Alle Gutscheine ansehen",
      "Review Your Requirements for This Request": "Überprüfen Sie Ihre Anforderungen für diese Anfrage",
      "Service Total": "Service gesamt",
      "Additional Service Charge(s)": "Zusätzliche Servicegebühren",
      "Wallet": "Wallet",
      "Coupon": "Gutschein",
      "Service Fee & Tax": "Servicegebühr & Steuern",
      "Additional Patient Charge": "Zusätzliche Patientenpauschale",
      "Total Payable Amount": "Gesamtzahlungsbetrag",
      "View Detailed Bill": "Detaillierte Rechnung ansehen",
      "Proceed": "Fortfahren",
      "Best Coupon": "Bester Gutschein",
      "Coupon Code": "Gutscheincode",
      "Coupon Amount": "Gutscheinbetrag",
      "Minimum Amount": "Mindestbetrag",
      "Ex Date": "Ablaufdatum",
      "Apply Coupons": "Gutscheine anwenden",
      "Select Payment Method": "Zahlungsmethode auswählen",
      "Category": "Kategorie",
      "Lab Details": "Labordetails",
      "Popular Tests": "Beliebte Tests",
      "Affordable Packages": "Bezahlbare Pakete",
      "Recommended Packages": "Empfohlene Pakete",
      "Item in Cart": "Artikel im Warenkorb",
      "Home Collect Extra Price": "Zusätzliche Kosten für Hausabholung",
      "Sample Type": "Probenart",
      "Fasting Required": "Fasten erforderlich",
      "Test Report Time": "Testergebniszeit",
      "Package Includes": "Paket beinhaltet",
      "Package Description": "Paketbeschreibung",
      "Test Details & Package Details": "Test- & Paketdetails",
      "Remove Cart?": "Warenkorb entfernen?",
      "Are You Sure You Want To Delete All Items?": "Sind Sie sicher, dass Sie alle Artikel löschen möchten?",
      "From Urine Test Report": "Aus dem Urintestbericht",
      "Cancel": "Abbrechen",
      "Select Sample Collection Slot": "Abholzeit für Probe auswählen",
      "Select Date": "Datum auswählen",
      "Select Time": "Uhrzeit auswählen",
      "Symptoms / Private Note": "Symptome / private Notiz",
      "Home Service (Collect my test sample)": "Hausservice (Probeabholung)",
      "Additional Cost Required to Pay": "Zusätzliche Kosten zu zahlen",
      "Your Lab Appointment Location": "Ihr Labor-Terminort",
      "Kindly visit the address below for your scheduled lab services.": "Bitte besuchen Sie die untenstehende Adresse für Ihre geplanten Labordienste.",
      "Choose a Delivery Address": "Lieferadresse auswählen",
      "Add New Address": "Neue Adresse hinzufügen",
      "Save Address As": "Adresse speichern als",
      "Save Address": "Adresse speichern",
      "We Come to You": "Wir kommen zu Ihnen",
      "Choose your address for hassle-free sample collection at home": "Wählen Sie Ihre Adresse für eine einfache Probenabholung zu Hause",
      "Home Collection Free": "Kostenlose Hausabholung",
      "Our Category": "Unsere Kategorie",
      "Shop": "Shop",
      "Shop List": "Shop-Liste",
      "Categories": "Kategorien",
      "Bestseller Products": "Bestseller-Produkte",
      "Add": "Hinzufügen",
      "Option": "Option",
      "No Store Available": "Kein Geschäft verfügbar",
      "In Your Area.": "In Ihrer Gegend.",
      "Done": "Fertig",
      "View Cart": "Warenkorb ansehen",
      "Items": "Artikel",
      "Shop Home Page": "Shop-Startseite",
      "Checkout": "Zur Kasse",
      "Order Details": "Bestelldetails",
      "Your Uploaded Prescription": "Ihr hochgeladenes Rezept",
      "+ Add Prescription": "+ Rezept hinzufügen",
      "+ Add More": "+ Mehr hinzufügen",
      "Total Price": "Gesamtpreis",
      "Select Delivery Address": "Lieferadresse auswählen",
      "We deliver the product to this address.": "Wir liefern das Produkt an diese Adresse.",
      "Shop Total": "Gesamtsumme Shop",
      "Commission Rate (Fixed)": "Provisionssatz (Fest)",
      "Continue Total Payable Amount": "Weiter zum Gesamtbetrag",
      "Packages": "Pakete",
      "Cart Booking": "Warenkorbbuchung",
      "My Booking": "Meine Buchung",
      "My Order": "Meine Bestellung",
      "Booking Package": "Buchungspaket",
      "Refer & Earn": "Empfehlen & Verdienen",
      "Language": "Sprache",
      "Chat": "Chat",
      "Log Out": "Abmelden",
      "Current Booking": "Aktuelle Buchung",
      "Past Booking": "Vergangene Buchung",
      "Call Doctor": "Arzt anrufen",
      "No Booking Placed!!": "Keine Buchung vorhanden!!",
      "Currently You Don't Have Any Booking": "Sie haben derzeit keine Buchung",
      "Call": "Anrufen",
      "About Appointment": "Über den Termin",
      "Patient Info": "Patienteninformationen",
      "In Person Appointment": "Termin vor Ort",
      "In Video Appointment": "Video-Termin",
      "OTP Info": "OTP-Informationen",
      "QR Code": "QR-Code",
      "Appointment Checklists": "Terminchecklisten",
      "Download Prescription": "Rezept herunterladen",
      "Booking Date & Time Info": "Buchungsdatum & Zeit",
      "Bill Summary": "Rechnungsübersicht",
      "Doctor Consultation Charge": "Arztberatungsgebühr",
      "Additional Price": "Zusätzlicher Preis",
      "Doctor Commission": "Arztprovision",
      "Wallet Amount": "Wallet-Guthaben",
      "Payment": "Zahlung",
      "Hospital Address": "Krankenhausadresse",
      "Health Concerns": "Gesundheitsprobleme",
      "Add Health Documents": "Gesundheitsdokumente hinzufügen",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Z.B. früheres Rezept, Testergebnis, Foto, etc.",
      "Maximum File Upload Size": "Maximale Dateigröße",
      "Document": "Dokument",
      "Add Photo": "Foto hinzufügen",
      "Add Document": "Dokument hinzufügen",
      "Submit Details": "Details absenden",
      "Virtual and Physical": "Virtuell und Physisch",
      "Diagnosis Test": "Diagnosetest",
      "Medicine": "Medizin",
      "Information": "Information",
      "Medicine Name": "Medizinname",
      "Time": "Zeit",
      "Dosage": "Dosierung",
      "Duration": "Dauer",
      "Frequency": "Häufigkeit",
      "Instructions": "Anweisungen",
      "Select Reason": "Grund auswählen",
      "Please Select the Reason for Cancellation": "Bitte wählen Sie den Stornierungsgrund",
      "Confirm": "Bestätigen",
      "Current Order": "Aktuelle Bestellung",
      "Past Order": "Vergangene Bestellung",
      "Info": "Info",
      "No Order Placed!!": "Keine Bestellung vorhanden!!",
      "Currently You Don't Have Any Order": "Sie haben derzeit keine Bestellung",
      "Order Info": "Bestellinformationen",
      "Medicine Prescription": "Medizinrezept",
      "Order Status": "Bestellstatus",
      "Pending": "Ausstehend",
      "Processing": "In Bearbeitung",
      "On Route": "Unterwegs",
      "Payment & Address Info": "Zahlungs- & Adressinformationen",
      "Seller Commission": "Verkäuferprovision",
      "Site Commission": "Seitenprovision",
      "Payment Method": "Zahlungsmethode",
      "Address": "Adresse",
      "Paid from Wallet": "Vom Wallet bezahlt",
      "Online Paid": "Online bezahlt",
      "Deliver": "Liefern",
      "Check Status": "Status prüfen",
      "Report": "Bericht",
      "Package Charge": "Pauschalgebühr",
      "Home Collection Fee": "Gebühr für Heimabholung",
      "TOTAL WALLET BALANCE": "GESAMTGUTHABEN IM WALLETT",
      "Top Up": "Aufladen",
      "Transaction History": "Transaktionsverlauf",
      "Go & Add Your Amount": "Gehen Sie und fügen Sie Ihren Betrag hinzu",
      "Continue": "Weiter",
      "Add Wallet Amount": "Wallet-Guthaben hinzufügen",
      "Earn": "Verdienen",
      "For Each Friend You Refer": "Für jeden Freund, den Sie empfehlen",
      "Share the Referral Link with Your Friends": "Teilen Sie den Empfehlungslink mit Ihren Freunden",
      "Friend Gets": "Freund erhält",
      "On First Complete Transaction": "Bei der ersten abgeschlossenen Transaktion",
      "You Get": "Sie erhalten",
      "On Your Wallet": "Auf Ihr Wallet",
      "Select User": "Benutzer auswählen",
      "Send Notification": "Benachrichtigung senden",
      "Appointment Cancel": "Termin abgesagt",
      "Product Amount": "Produktbetrag",
      "Login": "Anmelden",
      "Search Doctor": "Arzt suchen",
      "Incoming Video Call From": "Eingehender Videoanruf von",
      "Patient Name": "Patientenname",
      "Relationship": "Beziehung",
      "Blood Type": "Blutgruppe",
      "Patient Gender": "Geschlecht des Patienten",
      "Male": "Männlich",
      "Female": "Weiblich",
      "Patient Age": "Alter des Patienten",
      "National ID": "Personalausweis",
      "Height": "Größe",
      "Weight": "Gewicht",
      "Allergies": "Allergien",
      "Medical History": "Medizinische Vorgeschichte",
      "SUBMIT": "ABSENDEN",
      "Relationship Type": "Beziehungsart",
      "Includes": "Enthält",
      "tests": "Tests",
      "Reports in": "Berichte in",
      "Hours": "Stunden",
      "Package Price": "Paketpreis",
      "Prescription Required": "Rezept erforderlich",
      "No Store available": "Kein Geschäft verfügbar",
      "in your area.": "in Ihrer Gegend.",
      "Call doctor": "Arzt anrufen",
      "No Booking placed !!": "Keine Buchung vorgenommen!!",
      "Currently you don't have any Booking": "Derzeit haben Sie keine Buchung",
      "Required for voice and video calls. Make": "Erforderlich für Sprach- und Videoanrufe. Stellen Sie sicher,",
      "sure your audio device (headset, speakers,": "dass Ihr Audiogerät (Headset, Lautsprecher,",
      "or microphone) is connected and working.": "oder Mikrofon) angeschlossen und funktionsfähig ist.",
      "Vital & Physical Information": "Wichtige & körperliche Informationen",
      "Physical examination details": "Details zur körperlichen Untersuchung",
      "Drugs & Prescription Info": "Medikamente & Rezeptinformationen",
      "Medications prescription and dosage instructions": "Medikationsrezept und Dosierungsanweisungen",
      "Diagnosis Tests": "Diagnosetests",
      "Medical tests and diagnostic evaluations": "Medizinische Tests und diagnostische Bewertungen",
      "Booking": "Buchung",
      "Share Health Concerns": "Teilen Sie gesundheitliche Bedenken",
      "With": "Mit",
      "prior to your consultation": "vor Ihrer Beratung",
      "Enter Disease": "Krankheit eingeben",
      "Start OTP": "OTP Start",
      "End OTP": "OTP Ende",
      "Appointment ID": "Termin-ID",
      "Accepted": "Akzeptiert",
      "Collector Assigned": "Sammler zugewiesen",
      "Ongoing": "Laufend",
      "Completed": "Abgeschlossen",
      "Cancelled": "Abgesagt",
      "YourOrderPlaced": "Warten auf Bestätigung vom Labor.",
      "OrderPending": "Das Labor hat die Terminvereinbarung akzeptiert.",
      "OrderDelivering": "Der Termin ist gerade im Gange.",
      "ProductDelivered": "Die Labortests werden verarbeitet und analysiert.",
      "OrderDelivered": "Der Termin und alle zugehörigen Tests sind abgeschlossen.",
      "CollectorAssigned": "Ein Labortechniker wurde für die Probenentnahme zugewiesen.",
      "Search...": "Suchen...",
      "Say Something...": "Sagen Sie etwas...",
      "Please Select User !!": "Bitte wählen Sie einen Benutzer aus!!",
      "Please Write Message !!": "Bitte schreiben Sie eine Nachricht!!",
      "Add Patient Photo": "Patientenfoto hinzufügen",
      "Add Patient Details": "Patientendaten hinzufügen",
      "You cannot book this time": "Sie können diese Zeit nicht buchen",
      "This time is already book": "Diese Zeit ist bereits gebucht",
      "Select time for your appointment!": "Wählen Sie die Zeit für Ihren Termin!",
      "Coupon Add Successful": "Gutschein erfolgreich hinzugefügt",
      "Please Select Patient": "Bitte wählen Sie einen Patienten aus",
      "Please Select Date & Time": "Bitte wählen Sie Datum & Uhrzeit",
      "Please Select Address": "Bitte wählen Sie eine Adresse aus",
      "Please Enter Details": "Bitte Details eingeben",
      "Edit Profile": "Profil bearbeiten",
      "Update": "Aktualisieren",
      "Please Select Patients": "Bitte wählen Sie Patienten aus",
      "Add patient prescription": "Patientenrezept hinzufügen",
      "Select deliver address": "Lieferadresse auswählen",
      "Select Cancel Reason": "Stornierungsgrund auswählen",
      "Enter Other Reason": "Anderen Grund eingeben",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Der Arzt hat Ihre Daten nicht hochgeladen. Bitte kontaktieren Sie ihn, um Ihre Informationen zu aktualisieren.",
      "Upload Profile Photo": "Profilfoto hochladen",
      "Enter details": "Details eingeben",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Noch kein Laborbericht hochgeladen. Sie werden benachrichtigt, sobald er verfügbar ist.",
      "Text copied to clipboard !!": "Text in die Zwischenablage kopiert!!",
      "Logout Successful!": "Erfolgreich abgemeldet!",
      "Please Enter Amount": "Bitte Betrag eingeben",
      "Please enter number": "Bitte Nummer eingeben",
      "Please enter password": "Bitte Passwort eingeben",
      "OTP is invalid !!": "OTP ist ungültig!!",
      "Please Enter a Valid Email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "No Doctor available in your area.": "In Ihrer Gegend ist kein Arzt verfügbar.",
      "ID": "ID",
      "No Lab available in your area.": "In Ihrer Gegend ist kein Labor verfügbar.",
      "Book Now": "Jetzt buchen",
      "You have successfully booking": "Ihre Buchung war erfolgreich",
      "Booking Fee": "Buchungsgebühr",
      "Clinic name": "Name der Klinik",
      "Department name": "Name der Abteilung",
      "SubType": "Untertyp",
      "Transaction Dtails": "Transaktionsdetails",
      "Payment Type": "Zahlungsart",
      "View Booking": "Buchung anzeigen",
      "1 Love this": "1 Gefällt mir",
      "Reviews": "Bewertungen",
      "Currently you don't have any": "Derzeit haben Sie keine",
      "doctor in you area!.": "Kein Arzt in Ihrer Gegend!",
      "No Doctor yet!": "Noch kein Arzt verfügbar!",
      "Leave a Review": "Eine Bewertung hinterlassen",
      "How was your experience": "Wie war Ihre Erfahrung?",
      "Maybe Later": "Vielleicht später",
      "Submit": "Absenden",
      "Write Your Rewiew": "Schreiben Sie Ihre Bewertung",
      "Your reviewe here..": "Schreiben Sie Ihre Bewertung hier..",
      "Home Collect Person": "Abholperson zu Hause",
      "Name": "Name",
      "Email": "E-Mail",
      "Phone Number": "Telefonnummer",
      "Appointment": "Termin",
      "Comment": "Kommentar",
      "Order ID": "Bestellnummer",
      "Enter Amount": "Betrag eingeben",
      "Appointment Date & Time Info": "Informationen zum Termin und zur Uhrzeit",
      "Upload": "Hochladen",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Bereitgestellt von GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Wählen Sie uns für eine zuverlässige, detailorientierte Reinigung",
      "that meets all your cleanliness needs.": "die all Ihre Reinigungsbedürfnisse erfüllt.",
      "Enable Location Services": "Standortdienste aktivieren",
      "To provide accurate services, please enable your location.": "Um genaue Dienste bereitzustellen, aktivieren Sie bitte Ihren Standort.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Erlauben Sie den Standortzugriff, wenn Sie dazu aufgefordert werden. Falls keine Aufforderung erscheint, aktivieren Sie ihn in den Browser-Einstellungen.",
      "Refresh the page after enabling.": "Aktualisieren Sie die Seite nach der Aktivierung.",
      "Enable Now": "Jetzt aktivieren",
      "TransactionId": "Transaktions-ID",
      "Search Hevan Medical Store Product": "Produkte des Hevan Medical Stores suchen",
      "No product yet!": "Noch keine Produkte vorhanden!",
      "product in you area!.": "Keine Produkte in deiner Region.",
      "No Doctors found !!": "Keine Ärzte gefunden !!",
      "No messages found !!": "Keine Nachrichten gefunden !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Eine Lösung für Arzttermine bezeichnet ein System, oft in Form einer App, das den Buchungsprozess vereinfacht,",
      "managing, and attending doctor's appointments.": "sowie die Verwaltung und Wahrnehmung von Arztterminen.",
      "Shop by Categories": "Nach Kategorien einkaufen",
      "No Store yet!": "Noch kein Geschäft vorhanden!",
      "store in you area!.": "Geschäft in Ihrer Nähe.",
      "Search by store": "Nach Geschäft suchen",
      "Your Token": "Ihre Nummer",
      "Waiting": "Wartend",
      "Now Serving": "Jetzt in Behandlung",
      "Ahead fo You": "Vor Ihnen",
      "Add New Patient": "Neuen Patienten hinzufügen",
      "Book Today": "Heute buchen",
      "View All": "Alle anzeigen",
      "Cancellation Policy": "Stornierungsbedingungen",
      "Clinic Photos": "Klinikfotos",
      "No review": "Keine Bewertungen",
      "years": "Jahre",
      "Video": "Video",
      "No doctors found": "Keine Ärzte gefunden",
      "Try adjusting your search": "Versuchen Sie, Ihre Suche anzupassen",
      "Clinic": "Klinik",
      "Welcome back": "Willkommen zurück",
      "Manage your health services": "Verwalten Sie Ihre Gesundheitsdienste",
      "Logout": "Abmelden",
      "Wallet Balance": "Wallet-Guthaben",
      "My Profile (Member Since)": "Mein Profil (Mitglied seit)",
      "Only JPG, PNG, WEBP files are allowed!": "Nur JPG-, PNG- oder WEBP-Dateien sind erlaubt!",
      "My Profile": "Mein Profil",
      "Full Name": "Vollständiger Name",
      "Email Address": "E-Mail-Adresse",
      "Password": "Passwort",
      "Save Changes": "Änderungen speichern",
      "Enter Password (Optional)": "Passwort eingeben (Optional)",
    }
  },
  in: {
    translation: {
      "Emergency Line": "Garis Darurat",
      "Support Email": "Email Dukungan",
      "Doctor Appointment": "Janji Dokter",
      "Book": "Pesan",
      "Lab Booking": "Pemesanan Laboratorium",
      "Medicine Booking": "Pemesanan Obat",
      "Skins": "Kulit",
      "Care & Vitamin": "Perawatan & Vitamin",
      "My Patient": "Pasien Saya",
      "Add New": "Tambah Baru",
      "Your Favorites": "Favorit Anda",
      "Doctor Your Love": "Dokter Favorit Anda",
      "Go Home": "Kembali ke Beranda",
      "Home": "Beranda",
      "Our Services": "Layanan Kami",
      "In Person": "Tatap Muka",
      "Video Visit": "Kunjungan Video",
      "Total Experience": "Total Pengalaman",
      "Rating": "Penilaian",
      "Consultation Fee": "Biaya Konsultasi",
      "Book Appointment": "Pesan Janji",
      "Doctor Details": "Detail Dokter",
      "FAQs": "Pertanyaan Umum",
      "Cancel Policy": "Kebijakan Pembatalan",
      "About": "Tentang",
      "Review": "Ulasan",
      "Awards": "Penghargaan",
      "Photos": "Foto",
      "Service": "Layanan",
      "Availability": "Ketersediaan",
      "Morning": "Pagi",
      "Afternoon": "Siang",
      "Evening": "Sore",
      "Loading...": "Memuat...",
      "Clinic Details": "Detail Klinik",
      "Doctor Bio": "Profil Dokter",
      "Doctor Profile": "Profil Dokter",
      "Years Experience": "Tahun Pengalaman",
      "Appointment Details": "Detail Janji",
      "Select Patient": "Pilih Pasien",
      "Message": "Pesan",
      "Pay from Wallet": "Bayar dari Dompet",
      "My Wallet": "Dompet Saya",
      "Apply Coupon": "Gunakan Kupon",
      "Use Code": "Gunakan Kode",
      "Remove": "Hapus",
      "Apply": "Terapkan",
      "View All Coupons": "Lihat Semua Kupon",
      "Review Your Requirements for This Request": "Tinjau Persyaratan Anda untuk Permintaan Ini",
      "Service Total": "Total Layanan",
      "Additional Service Charge(s)": "Biaya Layanan Tambahan",
      "Wallet": "Dompet",
      "Coupon": "Kupon",
      "Service Fee & Tax": "Biaya Layanan & Pajak",
      "Additional Patient Charge": "Biaya Pasien Tambahan",
      "Total Payable Amount": "Total Jumlah yang Harus Dibayar",
      "View Detailed Bill": "Lihat Tagihan Detail",
      "Proceed": "Lanjutkan",
      "Best Coupon": "Kupon Terbaik",
      "Coupon Code": "Kode Kupon",
      "Coupon Amount": "Jumlah Kupon",
      "Minimum Amount": "Jumlah Minimum",
      "Ex Date": "Tanggal Kadaluarsa",
      "Apply Coupons": "Terapkan Kupon",
      "Select Payment Method": "Pilih Metode Pembayaran",
      "Category": "Kategori",
      "Lab Details": "Detail Laboratorium",
      "Popular Tests": "Tes Populer",
      "Affordable Packages": "Paket Terjangkau",
      "Recommended Packages": "Paket Rekomendasi",
      "Item in Cart": "Item di Keranjang",
      "Home Collect Extra Price": "Harga Tambahan Pengambilan di Rumah",
      "Sample Type": "Jenis Sampel",
      "Fasting Required": "Puasa Diperlukan",
      "Test Report Time": "Waktu Laporan Tes",
      "Package Includes": "Paket Termasuk",
      "Package Description": "Deskripsi Paket",
      "Test Details & Package Details": "Detail Tes & Paket",
      "Remove Cart?": "Hapus Keranjang?",
      "Are You Sure You Want To Delete All Items?": "Apakah Anda Yakin Ingin Menghapus Semua Item?",
      "From Urine Test Report": "Dari Laporan Tes Urin",
      "Cancel": "Batal",
      "Select Sample Collection Slot": "Pilih Slot Pengambilan Sampel",
      "Select Date": "Pilih Tanggal",
      "Select Time": "Pilih Waktu",
      "Symptoms / Private Note": "Gejala / Catatan Pribadi",
      "Home Service (Collect my test sample)": "Layanan Rumah (Ambil Sampel Tes Saya)",
      "Additional Cost Required to Pay": "Biaya Tambahan yang Harus Dibayar",
      "Your Lab Appointment Location": "Lokasi Janji Laboratorium Anda",
      "Kindly visit the address below for your scheduled lab services.": "Silakan kunjungi alamat di bawah untuk layanan laboratorium yang dijadwalkan.",
      "Choose a Delivery Address": "Pilih Alamat Pengiriman",
      "Add New Address": "Tambah Alamat Baru",
      "Save Address As": "Simpan Alamat Sebagai",
      "Save Address": "Simpan Alamat",
      "We Come to You": "Kami Datang ke Anda",
      "Choose your address for hassle-free sample collection at home": "Pilih alamat Anda untuk pengambilan sampel di rumah tanpa repot",
      "Home Collection Free": "Pengambilan di Rumah Gratis",
      "Our Category": "Kategori Kami",
      "Shop": "Toko",
      "Shop List": "Daftar Toko",
      "Categories": "Kategori",
      "Bestseller Products": "Produk Terlaris",
      "Add": "Tambah",
      "Option": "Opsi",
      "No Store Available": "Toko Tidak Tersedia",
      "In Your Area.": "Di Area Anda.",
      "Done": "Selesai",
      "View Cart": "Lihat Keranjang",
      "Items": "Item",
      "Shop Home Page": "Halaman Utama Toko",
      "Checkout": "Pembayaran",
      "Order Details": "Detail Pesanan",
      "Your Uploaded Prescription": "Resep yang Anda Unggah",
      "+ Add Prescription": "+ Tambah Resep",
      "+ Add More": "+ Tambah Lagi",
      "Total Price": "Total Harga",
      "Select Delivery Address": "Pilih Alamat Pengiriman",
      "We deliver the product to this address.": "Kami mengirimkan produk ke alamat ini.",
      "Shop Total": "Total Toko",
      "Commission Rate (Fixed)": "Tarif Komisi (Tetap)",
      "Continue Total Payable Amount": "Lanjutkan Total Jumlah yang Harus Dibayar",
      "Packages": "Paket",
      "Cart Booking": "Pemesanan Keranjang",
      "My Booking": "Pemesanan Saya",
      "My Order": "Pesanan Saya",
      "Booking Package": "Paket Pemesanan",
      "Refer & Earn": "Referensi & Dapatkan",
      "Language": "Bahasa",
      "Chat": "Obrolan",
      "Log Out": "Keluar",
      "Current Booking": "Pemesanan Saat Ini",
      "Past Booking": "Pemesanan Sebelumnya",
      "Call Doctor": "Panggil Dokter",
      "No Booking Placed!!": "Tidak Ada Pemesanan!!",
      "Currently You Don't Have Any Booking": "Saat Ini Anda Tidak Memiliki Pemesanan",
      "Call": "Panggil",
      "About Appointment": "Tentang Janji",
      "Patient Info": "Info Pasien",
      "In Person Appointment": "Janji Tatap Muka",
      "In Video Appointment": "Janji Video",
      "OTP Info": "Info OTP",
      "QR Code": "Kode QR",
      "Appointment Checklists": "Daftar Periksa Janji",
      "Download Prescription": "Unduh Resep",
      "Booking Date & Time Info": "Info Tanggal & Waktu Pemesanan",
      "Bill Summary": "Ringkasan Tagihan",
      "Doctor Consultation Charge": "Biaya Konsultasi Dokter",
      "Additional Price": "Harga Tambahan",
      "Doctor Commission": "Komisi Dokter",
      "Wallet Amount": "Jumlah Dompet",
      "Payment": "Pembayaran",
      "Hospital Address": "Alamat Rumah Sakit",
      "Health Concerns": "Kekhawatiran Kesehatan",
      "Add Health Documents": "Tambah Dokumen Kesehatan",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Misalnya Resep Lama, Laporan Tes, Foto, dll.",
      "Maximum File Upload Size": "Ukuran Maksimum Unggah Berkas",
      "Document": "Dokumen",
      "Add Photo": "Tambah Foto",
      "Add Document": "Tambah Dokumen",
      "Submit Details": "Kirim Detail",
      "Virtual and Physical": "Virtual dan Fisik",
      "Diagnosis Test": "Tes Diagnosa",
      "Medicine": "Obat",
      "Information": "Informasi",
      "Medicine Name": "Nama Obat",
      "Time": "Waktu",
      "Dosage": "Dosis",
      "Duration": "Durasi",
      "Frequency": "Frekuensi",
      "Instructions": "Instruksi",
      "Select Reason": "Pilih Alasan",
      "Please Select the Reason for Cancellation": "Silakan Pilih Alasan Pembatalan",
      "Confirm": "Konfirmasi",
      "Current Order": "Pesanan Saat Ini",
      "Past Order": "Pesanan Sebelumnya",
      "Info": "Info",
      "No Order Placed!!": "Tidak Ada Pesanan!!",
      "Currently You Don't Have Any Order": "Saat Ini Anda Tidak Memiliki Pesanan",
      "Order Info": "Info Pesanan",
      "Medicine Prescription": "Resep Obat",
      "Order Status": "Status Pesanan",
      "Pending": "Menunggu",
      "Processing": "Diproses",
      "On Route": "Dalam Perjalanan",
      "Payment & Address Info": "Info Pembayaran & Alamat",
      "Seller Commission": "Komisi Penjual",
      "Site Commission": "Komisi Situs",
      "Payment Method": "Metode Pembayaran",
      "Address": "Alamat",
      "Paid from Wallet": "Dibayar dari Dompet",
      "Online Paid": "Dibayar Online",
      "Deliver": "Kirim",
      "Complete": "Selesai",
      "Check Status": "Periksa Status",
      "Report": "Laporan",
      "Package Charge": "Biaya Paket",
      "Home Collection Fee": "Biaya Pengambilan di Rumah",
      "TOTAL WALLET BALANCE": "SALDO DOMPET TOTAL",
      "Top Up": "Isi Ulang",
      "Transaction History": "Riwayat Transaksi",
      "Go & Add Your Amount": "Pergi & Tambah Jumlah Anda",
      "Continue": "Lanjutkan",
      "Add Wallet Amount": "Tambah Jumlah Dompet",
      "Earn": "Dapatkan",
      "For Each Friend You Refer": "Untuk Setiap Teman yang Anda Referensikan",
      "Share the Referral Link with Your Friends": "Bagikan Tautan Referensi dengan Teman Anda",
      "Friend Gets": "Teman Mendapatkan",
      "On First Complete Transaction": "Pada Transaksi Lengkap Pertama",
      "You Get": "Anda Mendapatkan",
      "On Your Wallet": "Di Dompet Anda",
      "Select User": "Pilih Pengguna",
      "Send Notification": "Kirim Notifikasi",
      "Appointment Cancel": "Batal Janji",
      "Product Amount": "Jumlah Produk",
      "Login": "Masuk",
      "Search Doctor": "Cari Dokter",
      "Incoming Video Call From": "Panggilan Video Masuk Dari",
      "Patient Name": "Nama Pasien",
      "Relationship": "Hubungan",
      "Blood Type": "Golongan Darah",
      "Patient Gender": "Jenis Kelamin Pasien",
      "Male": "Laki-laki",
      "Female": "Perempuan",
      "Patient Age": "Usia Pasien",
      "National ID": "ID Nasional",
      "Height": "Tinggi",
      "Weight": "Berat",
      "Allergies": "Alergi",
      "Medical History": "Riwayat Medis",
      "SUBMIT": "KIRIM",
      "Relationship Type": "Jenis Hubungan",
      "Includes": "Termasuk",
      "tests": "tes",
      "Reports in": "Laporan dalam",
      "Hours": "Jam",
      "Package Price": "Harga Paket",
      "Prescription Required": "Resep Diperlukan",
      "No Store available": "Toko Tidak Tersedia",
      "in your area.": "di area Anda.",
      "Call doctor": "Panggil dokter",
      "No Booking placed !!": "Tidak Ada Pemesanan!!",
      "Currently you don't have any Booking": "Saat ini Anda tidak memiliki pemesanan",
      "Required for voice and video calls. Make": "Diperlukan untuk panggilan suara dan video. Pastikan",
      "sure your audio device (headset, speakers,": "perangkat audio Anda (headset, speaker,",
      "or microphone) is connected and working.": "atau mikrofon) terhubung dan berfungsi.",
      "Vital & Physical Information": "Informasi Vital & Fisik",
      "Physical examination details": "Detail pemeriksaan fisik",
      "Drugs & Prescription Info": "Info Obat & Resep",
      "Medications prescription and dosage instructions": "Resep obat dan instruksi dosis",
      "Diagnosis Tests": "Tes Diagnosa",
      "Medical tests and diagnostic evaluations": "Tes medis dan evaluasi diagnostik",
      "Booking": "Pemesanan",
      "Share Health Concerns": "Bagikan Kekhawatiran Kesehatan",
      "With": "Dengan",
      "prior to your consultation": "sebelum konsultasi Anda",
      "Enter Disease": "Masukkan Penyakit",
      "Start OTP": "Mulai OTP",
      "End OTP": "Akhiri OTP",
      "Appointment ID": "ID Janji",
      "Accepted": "Diterima",
      "Collector Assigned": "Pengumpul Ditugaskan",
      "Ongoing": "Sedang Berlangsung",
      "Completed": "Selesai",
      "Cancelled": "Dibatalkan",
      "YourOrderPlaced": "Menunggu konfirmasi dari laboratorium.",
      "OrderPending": "Laboratorium telah menerima permintaan janji temu.",
      "OrderDelivering": "Janji temu sedang berlangsung.",
      "ProductDelivered": "Tes laboratorium sedang diproses dan dianalisis.",
      "OrderDelivered": "Janji temu dan semua tes terkait telah selesai.",
      "CollectorAssigned": "Teknisi laboratorium telah ditugaskan untuk pengambilan sampel.",
      "Search...": "Cari...",
      "Say Something...": "Katakan Sesuatu...",
      "Please Select User !!": "Harap Pilih Pengguna!!",
      "Please Write Message !!": "Harap Tulis Pesan!!",
      "Add Patient Photo": "Tambah Foto Pasien",
      "Add Patient Details": "Tambah Detail Pasien",
      "You cannot book this time": "Anda tidak bisa memesan pada waktu ini",
      "This time is already book": "Waktu ini sudah dipesan",
      "Select time for your appointment!": "Pilih waktu untuk janji Anda!",
      "Coupon Add Successful": "Kupon Berhasil Ditambahkan",
      "Please Select Patient": "Harap Pilih Pasien",
      "Please Select Date & Time": "Harap Pilih Tanggal & Waktu",
      "Please Select Address": "Harap Pilih Alamat",
      "Please Enter Details": "Harap Masukkan Detail",
      "Edit Profile": "Edit Profil",
      "Update": "Perbarui",
      "Please Select Patients": "Harap Pilih Pasien",
      "Add patient prescription": "Tambah resep pasien",
      "Select deliver address": "Pilih alamat pengiriman",
      "Select Cancel Reason": "Pilih Alasan Pembatalan",
      "Enter Other Reason": "Masukkan Alasan Lain",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Dokter belum mengunggah detail Anda. Silakan hubungi mereka untuk memperbarui info Anda.",
      "Upload Profile Photo": "Unggah Foto Profil",
      "Enter details": "Masukkan detail",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Belum ada laporan lab yang diunggah. Anda akan diberitahu setelah tersedia.",
      "Text copied to clipboard !!": "Teks telah disalin ke clipboard!!",
      "Logout Successful!": "Berhasil Keluar!",
      "Please Enter Amount": "Harap Masukkan Jumlah",
      "Please enter number": "Harap masukkan angka",
      "Please enter password": "Harap masukkan kata sandi",
      "OTP is invalid !!": "OTP tidak valid!!",
      "Please Enter a Valid Email": "Harap Masukkan Email yang Valid",
      "No Doctor available in your area.": "Tidak ada dokter tersedia di daerah Anda.",
      "ID": "ID",
      "No Lab available in your area.": "Tidak ada laboratorium tersedia di daerah Anda.",
      "Book Now": "Pesan Sekarang",
      "You have successfully booking": "Pemesanan Anda berhasil",
      "Booking Fee": "Biaya Pemesanan",
      "Clinic name": "Nama Klinik",
      "Department name": "Nama Departemen",
      "SubType": "Subtipe",
      "Transaction Dtails": "Detail Transaksi",
      "Payment Type": "Jenis Pembayaran",
      "View Booking": "Lihat Pemesanan",
      "1 Love this": "1 Suka ini",
      "Reviews": "Ulasan",
      "Currently you don't have any": "Saat ini Anda belum memiliki apa pun",
      "doctor in you area!.": "Tidak ada dokter di daerah Anda!",
      "No Doctor yet!": "Belum ada dokter!",
      "Leave a Review": "Tinggalkan Ulasan",
      "How was your experience": "Bagaimana pengalaman Anda?",
      "Maybe Later": "Mungkin Nanti",
      "Submit": "Kirim",
      "Write Your Rewiew": "Tulis Ulasan Anda",
      "Your reviewe here..": "Tulis ulasan Anda di sini..",
      "Home Collect Person": "Petugas Pengambilan di Rumah",
      "Name": "Nama",
      "Email": "Email",
      "Phone Number": "Nomor Telepon",
      "Appointment": "Janji Temu",
      "Comment": "Komentar",
      "Order ID": "ID Pesanan",
      "Enter Amount": "Masukkan Jumlah",
      "Appointment Date & Time Info": "Informasi Tanggal dan Waktu Janji",
      "Upload": "Unggah",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Didukung oleh GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Pilih kami untuk layanan kebersihan yang andal dan teliti",
      "that meets all your cleanliness needs.": "yang memenuhi semua kebutuhan kebersihan Anda.",
      "Enable Location Services": "Aktifkan Layanan Lokasi",
      "To provide accurate services, please enable your location.": "Untuk memberikan layanan yang akurat, silakan aktifkan lokasi Anda.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Izinkan akses lokasi saat diminta. Jika tidak diminta, aktifkan di pengaturan browser Anda.",
      "Refresh the page after enabling.": "Segarkan halaman setelah diaktifkan.",
      "Enable Now": "Aktifkan Sekarang",
      "TransactionId": "ID Transaksi",
      "Search Hevan Medical Store Product": "Cari produk di Toko Medis Hevan",
      "No product yet!": "Belum ada produk!",
      "product in you area!.": "Tidak ada produk di wilayah Anda.",
      "No Doctors found !!": "Tidak ada dokter yang ditemukan !!",
      "No messages found !!": "Tidak ada pesan yang ditemukan !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Solusi janji temu dokter mengacu pada sistem, sering kali dalam bentuk aplikasi, yang menyederhanakan proses pemesanan,",
      "managing, and attending doctor's appointments.": "mengelola, dan menghadiri janji temu dengan dokter.",
      "Shop by Categories": "Belanja berdasarkan kategori",
      "No Store yet!": "Belum ada toko!",
      "store in you area!.": "Toko di area Anda.",
      "Search by store": "Cari berdasarkan toko",
      "Your Token": "Nomor Anda",
      "Waiting": "Menunggu",
      "Now Serving": "Sedang dilayani",
      "Ahead fo You": "Di depan Anda",
      "Add New Patient": "Tambah pasien baru",
      "Book Today": "Pesan hari ini",
      "View All": "Lihat semua",
      "Cancellation Policy": "Kebijakan pembatalan",
      "Clinic Photos": "Foto klinik",
      "No review": "Belum ada ulasan",
      "years": "tahun",
      "Video": "Video",
      "No doctors found": "Tidak ada dokter ditemukan",
      "Try adjusting your search": "Coba sesuaikan pencarian Anda",
      "Clinic": "Klinik",
      "Welcome back": "Selamat datang kembali",
      "Manage your health services": "Kelola layanan kesehatan Anda",
      "Logout": "Keluar",
      "Wallet Balance": "Saldo Dompet",
      "My Profile (Member Since)": "Profil Saya (Anggota sejak)",
      "Only JPG, PNG, WEBP files are allowed!": "Hanya file JPG, PNG, WEBP yang diperbolehkan!",
      "My Profile": "Profil Saya",
      "Full Name": "Nama Lengkap",
      "Email Address": "Alamat Email",
      "Password": "Kata Sandi",
      "Save Changes": "Simpan Perubahan",
      "Enter Password (Optional)": "Masukkan Kata Sandi (Opsional)"
    }
  },
  so: {
    translation: {
      "Emergency Line": "Noodlyn",
      "Support Email": "Ondersteunings-e-pos",
      "Doctor Appointment": "Doktersafspraak",
      "Book": "Bespreek",
      "Lab Booking": "Laboratoriumbespreking",
      "Medicine Booking": "Medisynebespreking",
      "Skins": "Huid",
      "Care & Vitamin": "Sorg & Vitamiene",
      "My Patient": "My Pasiënt",
      "Add New": "Voeg Nuwe By",
      "Your Favorites": "Jou Favoriete",
      "Doctor Your Love": "Dokter Wat Jy Liefhet",
      "Go Home": "Gaan Huis Toe",
      "Home": "Tuis",
      "Our Services": "Ons Dienste",
      "In Person": "Persoonlik",
      "Video Visit": "Videobesoek",
      "Total Experience": "Totale Ervaring",
      "Rating": "Gradering",
      "Consultation Fee": "Konsultasiefooi",
      "Book Appointment": "Bespreek Afspraak",
      "Doctor Details": "Dokterbesonderhede",
      "FAQs": "Gereelde Vrae",
      "Cancel Policy": "Kansellasiebeleid",
      "About": "Oor",
      "Review": "Oorsig",
      "Awards": "Toekennings",
      "Photos": "Foto's",
      "Service": "Diens",
      "Availability": "Beskikbaarheid",
      "Morning": "Môre",
      "Afternoon": "Middag",
      "Evening": "Aand",
      "Loading...": "Laai...",
      "Clinic Details": "Kliniekbesonderhede",
      "Doctor Bio": "Dokter Bio",
      "Doctor Profile": "Dokterprofiel",
      "Years Experience": "Jare Ervaring",
      "Appointment Details": "Afspraakbesonderhede",
      "Select Patient": "Kies Pasiënt",
      "Message": "Boodskap",
      "Pay from Wallet": "Betaal van Sakgeld",
      "My Wallet": "My Sakgeld",
      "Apply Coupon": "Pas Koepon Toe",
      "Use Code": "Gebruik Kode",
      "Remove": "Verwyder",
      "Apply": "Pas Toe",
      "View All Coupons": "Sien Alle Koeponne",
      "Review Your Requirements for This Request": "Hersien Jou Vereistes vir Hierdie Versoek",
      "Service Total": "Diens Totaal",
      "Additional Service Charge(s)": "Bykomende Diensheffings",
      "Wallet": "Sakgeld",
      "Coupon": "Koepon",
      "Service Fee & Tax": "Diensfooi & Belasting",
      "Additional Patient Charge": "Bykomende Pasiëntheffing",
      "Total Payable Amount": "Totale Betaalbare Bedrag",
      "View Detailed Bill": "Sien Gedetailleerde Faktuur",
      "Proceed": "Gaan Voort",
      "Best Coupon": "Beste Koepon",
      "Coupon Code": "Koeponkode",
      "Coupon Amount": "Koeponbedrag",
      "Minimum Amount": "Minimum Bedrag",
      "Ex Date": "Vervaldatum",
      "Apply Coupons": "Pas Koeponne Toe",
      "Select Payment Method": "Kies Betaalmetode",
      "Category": "Kategorie",
      "Lab Details": "Laboratoriumbesonderhede",
      "Popular Tests": "Gewilde Toetse",
      "Affordable Packages": "Bekostigbare Pakkette",
      "Recommended Packages": "Aanbevole Pakkette",
      "Item in Cart": "Item in Mandjie",
      "Home Collect Extra Price": "Ekstra Prys vir Huisversameling",
      "Sample Type": "Monster Tipe",
      "Fasting Required": "Vas Vereis",
      "Test Report Time": "Toetsverslagtyd",
      "Package Includes": "Pakket Sluit In",
      "Package Description": "Pakketbeskrywing",
      "Test Details & Package Details": "Toetsbesonderhede & Pakketbesonderhede",
      "Remove Cart?": "Verwyder Mandjie?",
      "Are You Sure You Want To Delete All Items?": "Is Jy Verseker Jy Wil Alle Items Verwyder?",
      "From Urine Test Report": "Van Urientoetsverslag",
      "Cancel": "Kanselleer",
      "Select Sample Collection Slot": "Kies Monster Versameltyd",
      "Select Date": "Kies Datum",
      "Select Time": "Kies Tyd",
      "Symptoms / Private Note": "Simptome / Privaat Nota",
      "Home Service (Collect my test sample)": "Huisdiens (Versamel my toetsmonster)",
      "Additional Cost Required to Pay": "Bykomende Koste Vereis om te Betaal",
      "Your Lab Appointment Location": "Jou Laboratoriumafspraakligging",
      "Kindly visit the address below for your scheduled lab services.": "Besoek asseblief die adres hieronder vir jou geskeduleerde laboratoriumdienste.",
      "Choose a Delivery Address": "Kies 'n Afleweringsadres",
      "Add New Address": "Voeg Nuwe Adres By",
      "Save Address As": "Stoor Adres As",
      "Save Address": "Stoor Adres",
      "We Come to You": "Ons Kom Na Jou",
      "Choose your address for hassle-free sample collection at home": "Kies jou adres vir maklike monsterinsameling by die huis",
      "Home Collection Free": "Huisversameling Gratis",
      "Our Category": "Ons Kategorie",
      "Shop": "Winkel",
      "Shop List": "Winkel Lys",
      "Categories": "Kategorieë",
      "Bestseller Products": "Bestseller Produkte",
      "Add": "Voeg By",
      "Option": "Opsie",
      "No Store Available": "Geen Winkel Beskikbaar Nie",
      "In Your Area.": "In Jou Omgewing.",
      "Done": "Klaar",
      "View Cart": "Bekyk Mandjie",
      "Items": "Items",
      "Shop Home Page": "Winkel Tuisblad",
      "Checkout": "Betaal",
      "Order Details": "Bestelbesonderhede",
      "Your Uploaded Prescription": "Jou Oplaai Resep",
      "+ Add Prescription": "+ Voeg Resep By",
      "+ Add More": "+ Voeg Meer By",
      "Total Price": "Totale Prys",
      "Select Delivery Address": "Kies Afleweringsadres",
      "We deliver the product to this address.": "Ons lewer die produk aan hierdie adres.",
      "Shop Total": "Winkel Totaal",
      "Commission Rate (Fixed)": "Kommissiekoers (Vastestel)",
      "Continue Total Payable Amount": "Gaan Voort Totale Betaalbare Bedrag",
      "Packages": "Pakkette",
      "Cart Booking": "Mandjie Bespreking",
      "My Booking": "My Bespreking",
      "My Order": "My Bestelling",
      "Booking Package": "Besprekingspakket",
      "Refer & Earn": "Verwys & Verdien",
      "Language": "Taal",
      "Chat": "Gesels",
      "Log Out": "Teken Uit",
      "Current Booking": "Huidige Bespreking",
      "Past Booking": "Verlede Bespreking",
      "Call Doctor": "Bel Dokter",
      "No Booking Placed!!": "Geen Bespreking Gemaak Nie!!",
      "Currently You Don't Have Any Booking": "Jy Het Tans Geen Besprekings Nie",
      "Call": "Bel",
      "About Appointment": "Oor Afspraak",
      "Patient Info": "Pasiëntinligting",
      "In Person Appointment": "Persoonlike Afspraak",
      "In Video Appointment": "Video-afspraak",
      "OTP Info": "OTP Inligting",
      "QR Code": "QR-kode",
      "Appointment Checklists": "Afspraak Kontrolelyste",
      "Download Prescription": "Laai Resep Af",
      "Booking Date & Time Info": "Besprekingsdatum & Tyd Inligting",
      "Bill Summary": "Faktuur Opsomming",
      "Doctor Consultation Charge": "Dokter Konsultasiefooi",
      "Additional Price": "Bykomende Prys",
      "Doctor Commission": "Dokter Kommissie",
      "Wallet Amount": "Sakgeld Bedrag",
      "Payment": "Betaling",
      "Hospital Address": "Hospitaaladres",
      "Health Concerns": "Gesondheidskwessies",
      "Add Health Documents": "Voeg Gesondheidsdokumente By",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Byv. Vorige Resep, Toetsverslag, Foto, ens.",
      "Maximum File Upload Size": "Maksimum Lêergrootte",
      "Document": "Dokument",
      "Add Photo": "Voeg Foto By",
      "Add Document": "Voeg Dokument By",
      "Submit Details": "Dien Besonderhede In",
      "Virtual and Physical": "Virtueel en Fisies",
      "Diagnosis Test": "Diagnosetoets",
      "Medicine": "Medisyne",
      "Information": "Inligting",
      "Medicine Name": "Medisyne Naam",
      "Time": "Tyd",
      "Dosage": "Dosering",
      "Duration": "Duur",
      "Frequency": "Frekwensie",
      "Instructions": "Instruksies",
      "Select Reason": "Kies Rede",
      "Please Select the Reason for Cancellation": "Kies Asseblief die Rede vir Kansellasie",
      "Confirm": "Bevestig",
      "Current Order": "Huidige Bestelling",
      "Past Order": "Verlede Bestelling",
      "Info": "Inligting",
      "No Order Placed!!": "Geen Bestelling Gemaak Nie!!",
      "Currently You Don't Have Any Order": "Jy Het Tans Geen Bestellings Nie",
      "Order Info": "Bestellingsinligting",
      "Medicine Prescription": "Medisyne Resep",
      "Order Status": "Bestellingsstatus",
      "Pending": "Hangende",
      "Processing": "Verwerking",
      "On Route": "Onderweg",
      "Payment & Address Info": "Betalings- en Adresinligting",
      "Seller Commission": "Verkoperskommissie",
      "Site Commission": "Terrein Kommissie",
      "Payment Method": "Betalingsmetode",
      "Address": "Adres",
      "Paid from Wallet": "Betaal vanaf Sakgeld",
      "Online Paid": "Aanlyn Betaal",
      "Deliver": "Lewer",
      "Complete": "Voltooi",
      "Check Status": "Kontroleer Status",
      "Report": "Verslag",
      "Package Charge": "Pakketfooie",
      "Home Collection Fee": "Huisversamelingsfooie",
      "TOTAL WALLET BALANCE": "TOTALE SAKGELDBALANS",
      "Top Up": "Laai Op",
      "Transaction History": "Transaksiegeskiedenis",
      "Go & Add Your Amount": "Gaan & Voeg Jou Bedrag By",
      "Continue": "Gaan Voort",
      "Add Wallet Amount": "Voeg Sakgeld By",
      "Earn": "Verdien",
      "For Each Friend You Refer": "Vir Elke Vriend Wat Jy Verwys",
      "Share the Referral Link with Your Friends": "Deel die Verwysingskakel Met Jou Vriende",
      "Friend Gets": "Vriend Kry",
      "On First Complete Transaction": "By Eerste Voltooide Transaksie",
      "You Get": "Jy Kry",
      "On Your Wallet": "Op Jou Sakgeld",
      "Select User": "Kies Gebruiker",
      "Send Notification": "Stuur Kennisgewing",
      "Appointment Cancel": "Afspraak Kanselleer",
      "Product Amount": "Produkbedrag",
      "Login": "Teken In",
      "Search Doctor": "Soek Dokter",
      "Incoming Video Call From": "Inkomende Video-oproep Van",
      "Patient Name": "Pasiënt Naam",
      "Relationship": "Verhouding",
      "Blood Type": "Blootip",
      "Patient Gender": "Pasiënt Geslag",
      "Male": "Manlik",
      "Female": "Vroulik",
      "Patient Age": "Pasiënt Ouderdom",
      "National ID": "Nasionale ID",
      "Height": "Hoogte",
      "Weight": "Gewig",
      "Allergies": "Alergies",
      "Medical History": "Mediese Geskiedenis",
      "SUBMIT": "DIEN IN",
      "Relationship Type": "Verhouding Tipe",
      "Includes": "Sluit In",
      "tests": "toetse",
      "Reports in": "Verslae binne",
      "Hours": "Ure",
      "Package Price": "Pakketprys",
      "Prescription Required": "Resep Vereis",
      "No Store available": "Geen Winkel beskikbaar",
      "in your area.": "in jou omgewing.",
      "Call doctor": "Bel dokter",
      "No Booking placed !!": "Geen Bespreking gemaak !!",
      "Currently you don't have any Booking": "Jy het tans geen besprekings nie",
      "Required for voice and video calls. Make": "Vereis vir stem- en video-oproepe. Maak",
      "sure your audio device (headset, speakers,": "verseker jou oudio-toestel (hooftoestel, luidsprekers,",
      "or microphone) is connected and working.": "of mikrofoon) is verbind en werk.",
      "Vital & Physical Information": "Belangrike & Fisiese Inligting",
      "Physical examination details": "Fisiese ondersoek besonderhede",
      "Drugs & Prescription Info": "Medisyne & Resep Inligting",
      "Medications prescription and dosage instructions": "Medisyne resep en doseringsinstruksies",
      "Diagnosis Tests": "Diagnosetoetse",
      "Medical tests and diagnostic evaluations": "Mediese toetse en diagnostiese evaluasies",
      "Booking": "Bespreking",
      "Share Health Concerns": "Deel Gesondheidskwessies",
      "With": "Met",
      "prior to your consultation": "voor jou konsultasie",
      "Enter Disease": "Voer Siekte In",
      "Start OTP": "Begin OTP",
      "End OTP": "Eindig OTP",
      "Appointment ID": "Afspraak ID",
      "Accepted": "Gaan Aan",
      "Collector Assigned": "Versamelaar Toegewys",
      "Ongoing": "Aan die gang",
      "Completed": "Voltooi",
      "Cancelled": "Gekanselleer",
      "YourOrderPlaced": "Wag op bevestiging van die laboratorium.",
      "OrderPending": "Die laboratorium het die afspraakversoek aanvaar.",
      "OrderDelivering": "Die afspraak is tans aan die gang.",
      "ProductDelivered": "Laboratoriumtoetse word verwerk en ontleed.",
      "OrderDelivered": "Die afspraak en alle verwante toetse is voltooi.",
      "CollectorAssigned": "’n Laboratoriumtegnikus is aangestel vir monsterinsameling.",
      "Search...": "Soek...",
      "Say Something...": "Sê iets...",
      "Please Select User !!": "Kies asseblief 'n gebruiker !!",
      "Please Write Message !!": "Skryf asseblief 'n boodskap !!",
      "Add Patient Photo": "Voeg Pasiëntfoto By",
      "Add Patient Details": "Voeg Pasiëntbesonderhede By",
      "You cannot book this time": "Jy kan nie hierdie tyd bespreek nie",
      "This time is already book": "Hierdie tyd is reeds bespreek",
      "Select time for your appointment!": "Kies tyd vir jou afspraak!",
      "Coupon Add Successful": "Koepon suksesvol bygevoeg",
      "Please Select Patient": "Kies asseblief 'n pasiënt",
      "Please Select Date & Time": "Kies asseblief datum & tyd",
      "Please Select Address": "Kies asseblief adres",
      "Please Enter Details": "Voer asseblief besonderhede in",
      "Edit Profile": "Wysig Profiel",
      "Update": "Werk By",
      "Please Select Patients": "Kies asseblief pasiënte",
      "Add patient prescription": "Voeg pasiënte resep by",
      "Select deliver address": "Kies afleweringsadres",
      "Select Cancel Reason": "Kies kansellasierede",
      "Enter Other Reason": "Voer ander rede in",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Dokter het jou besonderhede nie opgelaai nie. Kontak hulle asseblief om jou inligting by te werk.",
      "Upload Profile Photo": "Laai profielfoto op",
      "Enter details": "Voer besonderhede in",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Geen laboratoriumverslag opgelaai nie. Jy sal in kennis gestel word wanneer dit beskikbaar is.",
      "Text copied to clipboard !!": "Tekst gekopieer na knipbord !!",
      "Logout Successful!": "Teken suksesvol uit!",
      "Please Enter Amount": "Voer asseblief bedrag in",
      "Please enter number": "Voer asseblief nommer in",
      "Please enter password": "Voer asseblief wagwoord in",
      "OTP is invalid !!": "OTP is ongeldig !!",
      "Please Enter a Valid Email": "Voer asseblief 'n geldige e-pos in",
      "No Doctor available in your area.": "Geen dokter beskikbaar in jou area nie.",
      "ID": "ID",
      "No Lab available in your area.": "Geen laboratorium beskikbaar in jou area nie.",
      "Book Now": "Bespreek Nou",
      "You have successfully booking": "Jou bespreking was suksesvol",
      "Booking Fee": "Besprekingsfooi",
      "Clinic name": "Klinieknaam",
      "Department name": "Afdelingsnaam",
      "SubType": "Subtipe",
      "Transaction Dtails": "Transaksiebesonderhede",
      "Payment Type": "Betalingstipe",
      "View Booking": "Sien Bespreking",
      "1 Love this": "1 Hou hiervan",
      "Reviews": "Resensies",
      "Currently you don't have any": "Tans het jy geen",
      "doctor in you area!.": "Geen dokter in jou area nie!",
      "No Doctor yet!": "Nog geen dokter nie!",
      "Leave a Review": "Laat 'n Resensie",
      "How was your experience": "Hoe was jou ervaring?",
      "Maybe Later": "Miskien Later",
      "Submit": "Indien",
      "Write Your Rewiew": "Skryf jou resensie",
      "Your reviewe here..": "Skryf jou resensie hier..",
      "Home Collect Person": "Tuisafhaal Persoon",
      "Name": "Naam",
      "Email": "E-pos",
      "Phone Number": "Telefoonnommer",
      "Appointment": "Afspraak",
      "Comment": "Opmerking",
      "Order ID": "Bestel-ID",
      "Enter Amount": "Voer Bedrag In",
      "Appointment Date & Time Info": "Afspraakdatum en tydinligting",
      "Upload": "Oplaai",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Aangedryf deur GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Kies ons vir betroubare, detail-gefokusde skoonmaak",
      "that meets all your cleanliness needs.": "wat aan al jou skoonmaakbehoeftes voldoen.",
      "Enable Location Services": "Skakel Liggingdienste aan",
      "To provide accurate services, please enable your location.": "Om akkurate dienste te lewer, skakel asseblief jou ligging aan.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Laat liggingtoegang toe wanneer gevra. Indien nie gevra nie, aktiveer dit in jou blaaier se instellings.",
      "Refresh the page after enabling.": "Verfris die bladsy nadat dit geaktiveer is.",
      "Enable Now": "Skakel nou aan",
      "TransactionId": "Transaksie-ID",
      "Search Hevan Medical Store Product": "Soek produkte van Hevan Mediese Winkel",
      "No product yet!": "Nog geen produkte nie!",
      "product in you area!.": "Geen produkte in jou area nie.",
      "No Doctors found !!": "Geen dokters gevind nie !!",
      "No messages found !!": "Geen boodskappe gevind nie !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "’n Dokterafspraak-oplossing verwys na ’n stelsel, dikwels in die vorm van ’n toepassing, wat die proses van bespreking vereenvoudig,",
      "managing, and attending doctor's appointments.": "bestuur en bywoning van dokterafsprake.",
      "Shop by Categories": "Koop volgens kategorieë",
      "No Store yet!": "Nog geen winkel nie!",
      "store in you area!.": "Winkel in jou area.",
      "Search by store": "Soek volgens winkel",
      "Your Token": "Jou nommer",
      "Waiting": "Wag",
      "Now Serving": "Word nou bedien",
      "Ahead fo You": "Voor jou",
      "Add New Patient": "Voeg nuwe pasiënt by",
      "Book Today": "Bespreek vandag",
      "View All": "Sien alles",
      "Cancellation Policy": "Kansellasiebeleid",
      "Clinic Photos": "Kliniekfoto's",
      "No review": "No review",
      "years": "years",
      "Video": "Video",
      "No doctors found": "No doctors found",
      "Try adjusting your search": "Try adjusting your search",
      "Clinic": "Clinic",
      "Welcome back": "Welcome back",
      "Manage your health services": "Manage your health services",
      "Logout": "Logout",
      "Wallet Balance": "Wallet Balance",
      "My Profile (Member Since)": "My Profile (Member Since)",
      "Only JPG, PNG, WEBP files are allowed!": "Only JPG, PNG, WEBP files are allowed!",
      "My Profile": "My Profile",
      "Full Name": "Full Name",
      "Email Address": "Email Address",
      "Password": "Password",
      "Save Changes": "Save Changes",
      "Enter Password (Optional)": "Enter Password (Optional)"
    }
  },
  tu: {
    translation: {
      "Emergency Line": "Acil Hat",
      "Support Email": "Destek E-postası",
      "Doctor Appointment": "Doktor Randevusu",
      "Book": "Rezerve Et",
      "Lab Booking": "Laboratuvar Randevusu",
      "Medicine Booking": "İlaç Siparişi",
      "Skins": "Cilt Ürünleri",
      "Care & Vitamin": "Bakım & Vitamin",
      "My Patient": "Hastam",
      "Add New": "Yeni Ekle",
      "Your Favorites": "Favorileriniz",
      "Doctor Your Love": "Sevdiğiniz Doktor",
      "Go Home": "Ana Sayfaya Git",
      "Home": "Ana Sayfa",
      "Our Services": "Hizmetlerimiz",
      "In Person": "Yüz Yüze",
      "Video Visit": "Video Görüşme",
      "Total Experience": "Toplam Deneyim",
      "Rating": "Puan",
      "Consultation Fee": "Danışma Ücreti",
      "Book Appointment": "Randevu Al",
      "Doctor Details": "Doktor Detayları",
      "FAQs": "SSS",
      "Cancel Policy": "İptal Politikası",
      "About": "Hakkında",
      "Review": "Yorum",
      "Awards": "Ödüller",
      "Photos": "Fotoğraflar",
      "Service": "Hizmet",
      "Availability": "Uygunluk",
      "Morning": "Sabah",
      "Afternoon": "Öğle",
      "Evening": "Akşam",
      "Loading...": "Yükleniyor...",
      "Clinic Details": "Klinik Detayları",
      "Doctor Bio": "Doktor Biyografisi",
      "Doctor Profile": "Doktor Profili",
      "Years Experience": "Yıllık Deneyim",
      "Appointment Details": "Randevu Detayları",
      "Select Patient": "Hasta Seç",
      "Message": "Mesaj",
      "Pay from Wallet": "Cüzdandan Öde",
      "My Wallet": "Cüzdanım",
      "Apply Coupon": "Kupon Uygula",
      "Use Code": "Kodu Kullan",
      "Remove": "Kaldır",
      "Apply": "Uygula",
      "View All Coupons": "Tüm Kuponları Gör",
      "Review Your Requirements for This Request": "Bu Talep İçin Gereksinimlerinizi Gözden Geçirin",
      "Service Total": "Hizmet Toplamı",
      "Additional Service Charge(s)": "Ek Hizmet Ücreti(leri)",
      "Wallet": "Cüzdan",
      "Coupon": "Kupon",
      "Service Fee & Tax": "Hizmet Ücreti ve Vergi",
      "Additional Patient Charge": "Ek Hasta Ücreti",
      "Total Payable Amount": "Toplam Ödenecek Tutar",
      "View Detailed Bill": "Detaylı Faturayı Gör",
      "Proceed": "Devam Et",
      "Best Coupon": "En İyi Kupon",
      "Coupon Code": "Kupon Kodu",
      "Coupon Amount": "Kupon Tutarı",
      "Minimum Amount": "Minimum Tutar",
      "Ex Date": "Son Kullanma Tarihi",
      "Apply Coupons": "Kuponları Uygula",
      "Select Payment Method": "Ödeme Yöntemi Seç",
      "Category": "Kategori",
      "Lab Details": "Laboratuvar Detayları",
      "Popular Tests": "Popüler Testler",
      "Affordable Packages": "Uygun Paketler",
      "Recommended Packages": "Tavsiye Edilen Paketler",
      "Item in Cart": "Sepetteki Ürün",
      "Home Collect Extra Price": "Evden Alım Ek Ücreti",
      "Sample Type": "Numune Türü",
      "Fasting Required": "Açlık Gerekli",
      "Test Report Time": "Test Sonucu Süresi",
      "Package Includes": "Paket İçeriği",
      "Package Description": "Paket Açıklaması",
      "Test Details & Package Details": "Test ve Paket Detayları",
      "Remove Cart?": "Sepeti Kaldır?",
      "Are You Sure You Want To Delete All Items?": "Tüm Öğeleri Silmek İstediğinize Emin misiniz?",
      "From Urine Test Report": "İdrar Testi Raporundan",
      "Cancel": "İptal",
      "Select Sample Collection Slot": "Numune Alım Zamanı Seç",
      "Select Date": "Tarih Seç",
      "Select Time": "Saat Seç",
      "Symptoms / Private Note": "Belirtiler / Özel Not",
      "Home Service (Collect my test sample)": "Evde Hizmet (Numunemi Alın)",
      "Additional Cost Required to Pay": "Ek Ücret Gerekiyor",
      "Your Lab Appointment Location": "Laboratuvar Randevu Adresiniz",
      "Kindly visit the address below for your scheduled lab services.": "Planlanan laboratuvar hizmetleriniz için lütfen aşağıdaki adresi ziyaret ediniz.",
      "Choose a Delivery Address": "Teslimat Adresi Seçin",
      "Add New Address": "Yeni Adres Ekle",
      "Save Address As": "Adresi Kaydet",
      "Save Address": "Adresi Kaydet",
      "We Come to You": "Size Geliyoruz",
      "Choose your address for hassle-free sample collection at home": "Evde numune alımı için adresinizi seçin",
      "Home Collection Free": "Evden Alım Ücretsiz",
      "Our Category": "Kategorilerimiz",
      "Shop": "Mağaza",
      "Shop List": "Mağaza Listesi",
      "Categories": "Kategoriler",
      "Bestseller Products": "En Çok Satan Ürünler",
      "Add": "Ekle",
      "Option": "Seçenek",
      "No Store Available": "Mağaza Bulunamadı",
      "In Your Area.": "Bölgenizde.",
      "Done": "Tamamlandı",
      "View Cart": "Sepeti Görüntüle",
      "Items": "Ürünler",
      "Shop Home Page": "Mağaza Ana Sayfası",
      "Checkout": "Ödeme",
      "Order Details": "Sipariş Detayları",
      "Your Uploaded Prescription": "Yüklediğiniz Reçete",
      "+ Add Prescription": "+ Reçete Ekle",
      "+ Add More": "+ Daha Fazla Ekle",
      "Total Price": "Toplam Fiyat",
      "Select Delivery Address": "Teslimat Adresi Seç",
      "We deliver the product to this address.": "Ürünü bu adrese teslim ediyoruz.",
      "Shop Total": "Mağaza Toplamı",
      "Commission Rate (Fixed)": "Komisyon Oranı (Sabit)",
      "Continue Total Payable Amount": "Devam Et - Toplam Ödenecek Tutar",
      "Packages": "Paketler",
      "Cart Booking": "Sepet Rezervasyonu",
      "My Booking": "Rezervasyonlarım",
      "My Order": "Siparişlerim",
      "Booking Package": "Paket Rezervasyonu",
      "Refer & Earn": "Tavsiye Et ve Kazan",
      "Language": "Dil",
      "Chat": "Sohbet",
      "Log Out": "Çıkış Yap",
      "Current Booking": "Mevcut Rezervasyon",
      "Past Booking": "Geçmiş Rezervasyon",
      "Call Doctor": "Doktoru Ara",
      "No Booking Placed!!": "Hiç Rezervasyon Yapılmadı!!",
      "Currently You Don't Have Any Booking": "Şu Anda Herhangi Bir Rezervasyonunuz Yok",
      "Call": "Ara",
      "About Appointment": "Randevu Hakkında",
      "Patient Info": "Hasta Bilgisi",
      "In Person Appointment": "Yüz Yüze Randevu",
      "In Video Appointment": "Video Randevu",
      "OTP Info": "OTP Bilgisi",
      "QR Code": "QR Kodu",
      "Appointment Checklists": "Randevu Kontrol Listeleri",
      "Download Prescription": "Reçeteyi İndir",
      "Booking Date & Time Info": "Randevu Tarih ve Saat Bilgisi",
      "Bill Summary": "Fatura Özeti",
      "Doctor Consultation Charge": "Doktor Görüşme Ücreti",
      "Additional Price": "Ek Ücret",
      "Doctor Commission": "Doktor Komisyonu",
      "Wallet Amount": "Cüzdan Tutarı",
      "Payment": "Ödeme",
      "Hospital Address": "Hastane Adresi",
      "Health Concerns": "Sağlık Sorunları",
      "Add Health Documents": "Sağlık Belgeleri Ekle",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Örn. Önceki Reçete, Test Raporu, Fotoğraf vb.",
      "Maximum File Upload Size": "Maksimum Dosya Yükleme Boyutu",
      "Document": "Belge",
      "Add Photo": "Fotoğraf Ekle",
      "Add Document": "Belge Ekle",
      "Submit Details": "Bilgileri Gönder",
      "Virtual and Physical": "Sanal ve Fiziksel",
      "Diagnosis Test": "Teşhis Testi",
      "Medicine": "İlaç",
      "Information": "Bilgi",
      "Medicine Name": "İlaç Adı",
      "Time": "Zaman",
      "Dosage": "Dozaj",
      "Duration": "Süre",
      "Frequency": "Sıklık",
      "Instructions": "Talimatlar",
      "Select Reason": "Sebep Seç",
      "Please Select the Reason for Cancellation": "Lütfen İptal Sebebini Seçin",
      "Confirm": "Onayla",
      "Current Order": "Mevcut Sipariş",
      "Past Order": "Geçmiş Sipariş",
      "Info": "Bilgi",
      "No Order Placed!!": "Hiç Sipariş Verilmedi!!",
      "Currently You Don't Have Any Order": "Şu Anda Herhangi Bir Siparişiniz Yok",
      "Order Info": "Sipariş Bilgisi",
      "Medicine Prescription": "İlaç Reçetesi",
      "Order Status": "Sipariş Durumu",
      "Pending": "Beklemede",
      "Processing": "İşleniyor",
      "On Route": "Yolda",
      "Payment & Address Info": "Ödeme ve Adres Bilgisi",
      "Seller Commission": "Satıcı Komisyonu",
      "Site Commission": "Site Komisyonu",
      "Payment Method": "Ödeme Yöntemi",
      "Address": "Adres",
      "Paid from Wallet": "Cüzdandan Ödendi",
      "Online Paid": "Çevrimiçi Ödendi",
      "Deliver": "Teslim Et",
      "Complete": "Tamamla",
      "Check Status": "Durumu Kontrol Et",
      "Report": "Rapor",
      "Package Charge": "Paket Ücreti",
      "Home Collection Fee": "Evden Alım Ücreti",
      "TOTAL WALLET BALANCE": "TOPLAM CÜZDAN BAKİYESİ",
      "Top Up": "Bakiye Yükle",
      "Transaction History": "İşlem Geçmişi",
      "Go & Add Your Amount": "Gidip Tutarınızı Ekleyin",
      "Continue": "Devam Et",
      "Add Wallet Amount": "Cüzdan Tutarı Ekle",
      "Earn": "Kazanç",
      "For Each Friend You Refer": "Her Yönlendirdiğiniz Arkadaş İçin",
      "Share the Referral Link with Your Friends": "Yönlendirme Bağlantısını Arkadaşlarınızla Paylaşın",
      "Friend Gets": "Arkadaş Kazanır",
      "On First Complete Transaction": "İlk Tam İşlemde",
      "You Get": "Siz Kazanırsınız",
      "On Your Wallet": "Cüzdanınıza",
      "Select User": "Kullanıcı Seçin",
      "Send Notification": "Bildirim Gönder",
      "Appointment Cancel": "Randevu İptali",
      "Product Amount": "Ürün Tutarı",
      "Login": "Giriş Yap",
      "Search Doctor": "Doktor Ara",
      "Incoming Video Call From": "Gelen Görüntülü Arama",
      "Patient Name": "Hasta Adı",
      "Relationship": "Yakınlık",
      "Blood Type": "Kan Grubu",
      "Patient Gender": "Hasta Cinsiyeti",
      "Male": "Erkek",
      "Female": "Kadın",
      "Patient Age": "Hasta Yaşı",
      "National ID": "T.C. Kimlik No",
      "Height": "Boy",
      "Weight": "Kilo",
      "Allergies": "Alerjiler",
      "Medical History": "Tıbbi Geçmiş",
      "SUBMIT": "GÖNDER",
      "Relationship Type": "Yakınlık Türü",
      "Includes": "İçerir",
      "tests": "testler",
      "Reports in": "Sonuç Süresi",
      "Hours": "Saat",
      "Package Price": "Paket Fiyatı",
      "Prescription Required": "Reçete Gerekli",
      "No Store available": "Mağaza mevcut değil",
      "in your area.": "bulunduğunuz bölgede.",
      "Call doctor": "Doktoru ara",
      "No Booking placed !!": "Rezervasyon yapılmadı !!",
      "Currently you don't have any Booking": "Şu anda herhangi bir rezervasyonunuz yok",
      "Required for voice and video calls. Make": "Sesli ve görüntülü aramalar için gereklidir. Lütfen",
      "sure your audio device (headset, speakers,": "ses cihazınızın (kulaklık, hoparlör",
      "or microphone) is connected and working.": "veya mikrofon) bağlı ve çalışır durumda olduğundan emin olun.",
      "Vital & Physical Information": "Hayati ve Fiziksel Bilgiler",
      "Physical examination details": "Fiziksel muayene detayları",
      "Drugs & Prescription Info": "İlaç ve Reçete Bilgisi",
      "Medications prescription and dosage instructions": "İlaç reçetesi ve dozaj talimatları",
      "Diagnosis Tests": "Tanı Testleri",
      "Medical tests and diagnostic evaluations": "Tıbbi testler ve tanı değerlendirmeleri",
      "Booking": "Rezervasyon",
      "Share Health Concerns": "Sağlık Sorunlarını Paylaşın",
      "With": "ile",
      "prior to your consultation": "danışmanlık öncesinde",
      "Enter Disease": "Hastalık Girin",
      "Start OTP": "OTP Başlat",
      "End OTP": "OTP Bitir",
      "Appointment ID": "Randevu ID",
      "Accepted": "Kabul Edildi",
      "Collector Assigned": "Toplayıcı Atandı",
      "Ongoing": "Devam Ediyor",
      "Completed": "Tamamlandı",
      "Cancelled": "İptal Edildi",
      "YourOrderPlaced": "Laboratuvardan onay bekleniyor.",
      "OrderPending": "Laboratuvar, randevu talebini kabul etti.",
      "OrderDelivering": "Randevu şu anda devam ediyor.",
      "ProductDelivered": "Laboratuvar testleri işleniyor ve analiz ediliyor.",
      "OrderDelivered": "Randevu ve ilgili tüm testler tamamlandı.",
      "CollectorAssigned": "Numune toplama için bir laboratuvar teknisyeni atandı.",
      "Search...": "Ara...",
      "Say Something...": "Bir şey söyleyin...",
      "Please Select User !!": "Lütfen Kullanıcı Seçin !!",
      "Please Write Message !!": "Lütfen Mesaj Yazın !!",
      "Add Patient Photo": "Hasta Fotoğrafı Ekle",
      "Add Patient Details": "Hasta Bilgileri Ekle",
      "You cannot book this time": "Bu zaman dilimi için randevu alamazsınız",
      "This time is already book": "Bu zaman zaten rezerve edilmiş",
      "Select time for your appointment!": "Randevunuz için zaman seçin!",
      "Coupon Add Successful": "Kupon Başarıyla Eklendi",
      "Please Select Patient": "Lütfen Hasta Seçin",
      "Please Select Date & Time": "Lütfen Tarih ve Saat Seçin",
      "Please Select Address": "Lütfen Adres Seçin",
      "Please Enter Details": "Lütfen Bilgileri Girin",
      "Edit Profile": "Profili Düzenle",
      "Update": "Güncelle",
      "Please Select Patients": "Lütfen Hastaları Seçin",
      "Add patient prescription": "Hasta reçetesi ekle",
      "Select deliver address": "Teslimat adresi seçin",
      "Select Cancel Reason": "İptal Sebebini Seçin",
      "Enter Other Reason": "Diğer Nedeni Girin",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "Doktor bilgileriniz henüz yüklemedi. Lütfen doktorla iletişime geçin.",
      "Upload Profile Photo": "Profil Fotoğrafı Yükle",
      "Enter details": "Bilgileri girin",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Henüz laboratuvar raporu yüklenmedi. Hazır olduğunda bilgilendirileceksiniz.",
      "Text copied to clipboard !!": "Metin panoya kopyalandı !!",
      "Logout Successful!": "Çıkış Başarılı!",
      "Please Enter Amount": "Lütfen Tutar Girin",
      "Please enter number": "Lütfen numara girin",
      "Please enter password": "Lütfen şifre girin",
      "OTP is invalid !!": "OTP geçersiz !!",
      "Please Enter a Valid Email": "Lütfen Geçerli Bir E-posta Girin",
      "No Doctor available in your area.": "Bölgenizde uygun doktor yok.",
      "ID": "Kimlik",
      "No Lab available in your area.": "Bölgenizde uygun laboratuvar yok.",
      "Book Now": "Pesan Sekarang",
      "You have successfully booking": "Pemesanan Anda berhasil",
      "Booking Fee": "Biaya Pemesanan",
      "Clinic name": "Nama Klinik",
      "Department name": "Nama Departemen",
      "SubType": "Subtipe",
      "Transaction Dtails": "Detail Transaksi",
      "Payment Type": "Jenis Pembayaran",
      "View Booking": "Lihat Pemesanan",
      "1 Love this": "1 Bunu seviyorum",
      "Reviews": "Yorumlar",
      "Currently you don't have any": "Şu anda hiçbir şeyiniz yok",
      "doctor in you area!.": "Bölgenizde doktor yok!",
      "No Doctor yet!": "Henüz doktor yok!",
      "Leave a Review": "Bir Değerlendirme Bırak",
      "How was your experience": "Deneyiminiz nasıldı?",
      "Maybe Later": "Belki Daha Sonra",
      "Submit": "Gönder",
      "Write Your Rewiew": "Yorumunuzu Yazın",
      "Your reviewe here..": "Yorumunuzu buraya yazın..",
      "Home Collect Person": "Evden Alım Görevlisi",
      "Name": "İsim",
      "Email": "E-posta",
      "Phone Number": "Telefon Numarası",
      "Appointment": "Randevu",
      "Comment": "Yorum",
      "Order ID": "Sipariş Numarası",
      "Enter Amount": "Tutar Girin",
      "Appointment Date & Time Info": "Randevu Tarihi ve Saati Bilgisi",
      "Upload": "Yükle",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ GoDoctor tarafından desteklenmektedir",
      "Choose us for reliable, detail-oriented cleaning": "Güvenilir ve detay odaklı temizlik için bizi tercih edin",
      "that meets all your cleanliness needs.": "tüm temizlik ihtiyaçlarınızı karşılayan.",
      "Enable Location Services": "Konum Servislerini Etkinleştir",
      "To provide accurate services, please enable your location.": "Doğru hizmetler sunabilmek için lütfen konumunuzu etkinleştirin.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "İstendiğinde konum erişimine izin verin. İstenmiyorsa, tarayıcı ayarlarından etkinleştirin.",
      "Refresh the page after enabling.": "Etkinleştirdikten sonra sayfayı yenileyin.",
      "Enable Now": "Şimdi Etkinleştir",
      "TransactionId": "İşlem Kimliği",
      "Search Hevan Medical Store Product": "Hevan Medikal Mağazası ürünlerini ara",
      "No product yet!": "Henüz ürün yok!",
      "product in you area!.": "Bulunduğunuz bölgede ürün yok.",
      "No Doctors found !!": "Doktor bulunamadı !!",
      "No messages found !!": "Mesaj bulunamadı !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Doktor randevu çözümü, genellikle bir uygulama şeklinde olan ve randevu alma sürecini kolaylaştıran bir sistemi ifade eder,",
      "managing, and attending doctor's appointments.": "randevuları yönetme ve doktor randevularına katılma işlemlerini de kapsar.",
      "Shop by Categories": "Kategorilere göre alışveriş yap",
      "No Store yet!": "Henüz mağaza yok!",
      "store in you area!.": "Bölgenizde mağaza.",
      "Search by store": "Mağazaya göre ara",
      "Your Token": "Numaranız",
      "Waiting": "Bekliyor",
      "Now Serving": "Şu anda hizmet veriliyor",
      "Ahead fo You": "Önünüzde",
      "Add New Patient": "Yeni hasta ekle",
      "Book Today": "Bugün randevu al",
      "View All": "Tümünü görüntüle",
      "Cancellation Policy": "İptal politikası",
      "Clinic Photos": "Klinik fotoğrafları",
      "No review": "İnceleme yok",
      "years": "yıl",
      "Video": "Video",
      "No doctors found": "Doktor bulunamadı",
      "Try adjusting your search": "Aramanızı ayarlamayı deneyin",
      "Clinic": "Klinik",
      "Welcome back": "Tekrar hoş geldiniz",
      "Manage your health services": "Sağlık hizmetlerinizi yönetin",
      "Logout": "Çıkış yap",
      "Wallet Balance": "Cüzdan Bakiyesi",
      "My Profile (Member Since)": "Profilim (Üyelik Tarihi)",
      "Only JPG, PNG, WEBP files are allowed!": "Sadece JPG, PNG veya WEBP dosyalarına izin verilir!",
      "My Profile": "Profilim",
      "Full Name": "Tam Adı",
      "Email Address": "E-posta Adresi",
      "Password": "Şifre",
      "Save Changes": "Değişiklikleri Kaydet",
      "Enter Password (Optional)": "Şifre Girin (Opsiyonel)"
    }
  },
  po: {
    translation: {
      "Emergency Line": "Linha de Emergência",
      "Support Email": "E-mail de Suporte",
      "Doctor Appointment": "Consulta Médica",
      "Book": "Agendar",
      "Lab Booking": "Agendamento de Laboratório",
      "Medicine Booking": "Pedido de Medicamento",
      "Skins": "Peles",
      "Care & Vitamin": "Cuidados e Vitaminas",
      "My Patient": "Meu Paciente",
      "Add New": "Adicionar Novo",
      "Your Favorites": "Seus Favoritos",
      "Doctor Your Love": "Seu Médico Preferido",
      "Go Home": "Ir para Início",
      "Home": "Início",
      "Our Services": "Nossos Serviços",
      "In Person": "Presencial",
      "Video Visit": "Consulta por Vídeo",
      "Total Experience": "Experiência Total",
      "Rating": "Avaliação",
      "Consultation Fee": "Taxa de Consulta",
      "Book Appointment": "Agendar Consulta",
      "Doctor Details": "Detalhes do Médico",
      "FAQs": "Perguntas Frequentes",
      "Cancel Policy": "Política de Cancelamento",
      "About": "Sobre",
      "Review": "Avaliação",
      "Awards": "Prêmios",
      "Photos": "Fotos",
      "Service": "Serviço",
      "Availability": "Disponibilidade",
      "Morning": "Manhã",
      "Afternoon": "Tarde",
      "Evening": "Noite",
      "Loading...": "Carregando...",
      "Clinic Details": "Detalhes da Clínica",
      "Doctor Bio": "Biografia do Médico",
      "Doctor Profile": "Perfil do Médico",
      "Years Experience": "Anos de Experiência",
      "Appointment Details": "Detalhes da Consulta",
      "Select Patient": "Selecionar Paciente",
      "Message": "Mensagem",
      "Pay from Wallet": "Pagar com Carteira",
      "My Wallet": "Minha Carteira",
      "Apply Coupon": "Aplicar Cupom",
      "Use Code": "Usar Código",
      "Remove": "Remover",
      "Apply": "Aplicar",
      "View All Coupons": "Ver Todos os Cupons",
      "Review Your Requirements for This Request": "Revise Seus Requisitos para Esta Solicitação",
      "Service Total": "Total do Serviço",
      "Additional Service Charge(s)": "Encargo(s) Adicional(is)",
      "Wallet": "Carteira",
      "Coupon": "Cupom",
      "Service Fee & Tax": "Taxa de Serviço e Impostos",
      "Additional Patient Charge": "Cobrança Adicional por Paciente",
      "Total Payable Amount": "Valor Total a Pagar",
      "View Detailed Bill": "Ver Fatura Detalhada",
      "Proceed": "Prosseguir",
      "Best Coupon": "Melhor Cupom",
      "Coupon Code": "Código do Cupom",
      "Coupon Amount": "Valor do Cupom",
      "Minimum Amount": "Valor Mínimo",
      "Ex Date": "Data de Validade",
      "Apply Coupons": "Aplicar Cupons",
      "Select Payment Method": "Selecionar Método de Pagamento",
      "Category": "Categoria",
      "Lab Details": "Detalhes do Laboratório",
      "Popular Tests": "Testes Populares",
      "Affordable Packages": "Pacotes Acessíveis",
      "Recommended Packages": "Pacotes Recomendados",
      "Item in Cart": "Item no Carrinho",
      "Home Collect Extra Price": "Preço Adicional para Coleta em Casa",
      "Sample Type": "Tipo de Amostra",
      "Fasting Required": "Jejum Necessário",
      "Test Report Time": "Tempo de Resultado do Exame",
      "Package Includes": "O Pacote Inclui",
      "Package Description": "Descrição do Pacote",
      "Test Details & Package Details": "Detalhes dos Testes e Pacotes",
      "Remove Cart?": "Remover Carrinho?",
      "Are You Sure You Want To Delete All Items?": "Tem Certeza de que Deseja Excluir Todos os Itens?",
      "From Urine Test Report": "Do Relatório de Urina",
      "Cancel": "Cancelar",
      "Select Sample Collection Slot": "Selecione o Horário de Coleta",
      "Select Date": "Selecione a Data",
      "Select Time": "Selecione o Horário",
      "Symptoms / Private Note": "Sintomas / Nota Pessoal",
      "Home Service (Collect my test sample)": "Serviço Domiciliar (Coleta da Amostra em Casa)",
      "Additional Cost Required to Pay": "Custo Adicional a Pagar",
      "Your Lab Appointment Location": "Local da Consulta de Laboratório",
      "Kindly visit the address below for your scheduled lab services.": "Por favor, visite o endereço abaixo para os serviços de laboratório agendados.",
      "Choose a Delivery Address": "Escolha um Endereço de Entrega",
      "Add New Address": "Adicionar Novo Endereço",
      "Save Address As": "Salvar Endereço Como",
      "Save Address": "Salvar Endereço",
      "We Come to You": "Nós Vamos até Você",
      "Choose your address for hassle-free sample collection at home": "Escolha seu endereço para uma coleta de amostra em casa sem complicações",
      "Home Collection Free": "Coleta Domiciliar Gratuita",
      "Our Category": "Nossa Categoria",
      "Shop": "Loja",
      "Shop List": "Lista de Lojas",
      "Categories": "Categorias",
      "Bestseller Products": "Produtos Mais Vendidos",
      "Add": "Adicionar",
      "Option": "Opção",
      "No Store Available": "Nenhuma loja disponível",
      "In Your Area.": "Na sua área.",
      "Done": "Concluído",
      "View Cart": "Ver Carrinho",
      "Items": "Itens",
      "Shop Home Page": "Página Inicial da Loja",
      "Checkout": "Finalizar Compra",
      "Order Details": "Detalhes do Pedido",
      "Your Uploaded Prescription": "Sua Receita Enviada",
      "+ Add Prescription": "+ Adicionar Receita",
      "+ Add More": "+ Adicionar Mais",
      "Total Price": "Preço Total",
      "Select Delivery Address": "Selecionar Endereço de Entrega",
      "We deliver the product to this address.": "Entregamos o produto neste endereço.",
      "Shop Total": "Total da Loja",
      "Commission Rate (Fixed)": "Taxa de Comissão (Fixa)",
      "Continue Total Payable Amount": "Continuar com Valor Total a Pagar",
      "Packages": "Pacotes",
      "Cart Booking": "Reserva no Carrinho",
      "My Booking": "Minhas Reservas",
      "My Order": "Meus Pedidos",
      "Booking Package": "Pacote de Reserva",
      "Refer & Earn": "Indique e Ganhe",
      "Language": "Idioma",
      "Chat": "Chat",
      "Log Out": "Sair",
      "Current Booking": "Reserva Atual",
      "Past Booking": "Reservas Passadas",
      "Call Doctor": "Ligar para o Médico",
      "No Booking Placed!!": "Nenhuma Reserva Realizada!!",
      "Currently You Don't Have Any Booking": "Atualmente, você não tem nenhuma reserva",
      "Call": "Ligar",
      "About Appointment": "Sobre a Consulta",
      "Patient Info": "Informações do Paciente",
      "In Person Appointment": "Consulta Presencial",
      "In Video Appointment": "Consulta por Vídeo",
      "OTP Info": "Informações do OTP",
      "QR Code": "Código QR",
      "Appointment Checklists": "Checklist da Consulta",
      "Download Prescription": "Baixar Receita",
      "Booking Date & Time Info": "Data e Hora da Reserva",
      "Bill Summary": "Resumo da Fatura",
      "Doctor Consultation Charge": "Taxa de Consulta Médica",
      "Additional Price": "Preço Adicional",
      "Doctor Commission": "Comissão do Médico",
      "Wallet Amount": "Valor na Carteira",
      "Payment": "Pagamento",
      "Hospital Address": "Endereço do Hospital",
      "Health Concerns": "Preocupações de Saúde",
      "Add Health Documents": "Adicionar Documentos Médicos",
      "E.g. Past Prescription, Test Report, Photo, etc.": "Ex.: Receita anterior, resultado de exame, foto etc.",
      "Maximum File Upload Size": "Tamanho Máximo do Arquivo",
      "Document": "Documento",
      "Add Photo": "Adicionar Foto",
      "Add Document": "Adicionar Documento",
      "Submit Details": "Enviar Detalhes",
      "Virtual and Physical": "Virtual e Presencial",
      "Diagnosis Test": "Teste de Diagnóstico",
      "Medicine": "Medicamento",
      "Information": "Informações",
      "Medicine Name": "Nome do Medicamento",
      "Time": "Horário",
      "Dosage": "Dosagem",
      "Duration": "Duração",
      "Frequency": "Frequência",
      "Instructions": "Instruções",
      "Select Reason": "Selecionar Motivo",
      "Please Select the Reason for Cancellation": "Por favor, selecione o motivo do cancelamento",
      "Confirm": "Confirmar",
      "Current Order": "Pedido Atual",
      "Past Order": "Pedidos Anteriores",
      "Info": "Informações",
      "No Order Placed!!": "Nenhum Pedido Realizado!!",
      "Currently You Don't Have Any Order": "Atualmente, você não tem nenhum pedido",
      "Order Info": "Informações do Pedido",
      "Medicine Prescription": "Receita Médica",
      "Order Status": "Status do Pedido",
      "Pending": "Pendente",
      "Processing": "Em Processamento",
      "On Route": "A Caminho",
      "Payment & Address Info": "Informações de Pagamento e Endereço",
      "Seller Commission": "Comissão do Vendedor",
      "Site Commission": "Comissão do Site",
      "Payment Method": "Método de Pagamento",
      "Address": "Endereço",
      "Paid from Wallet": "Pago com Carteira",
      "Online Paid": "Pago Online",
      "Deliver": "Entregar",
      "Complete": "Concluir",
      "Check Status": "Verificar Status",
      "Report": "Relatório",
      "Package Charge": "Taxa do Pacote",
      "Home Collection Fee": "Taxa de Coleta em Casa",
      "TOTAL WALLET BALANCE": "SALDO TOTAL NA CARTEIRA",
      "Top Up": "Recarregar",
      "Transaction History": "Histórico de Transações",
      "Go & Add Your Amount": "Ir e Adicionar Seu Valor",
      "Continue": "Continuar",
      "Add Wallet Amount": "Adicionar Valor à Carteira",
      "Earn": "Ganhe",
      "For Each Friend You Refer": "Para Cada Amigo que Você Indicar",
      "Share the Referral Link with Your Friends": "Compartilhe o Link de Indicação com Seus Amigos",
      "Friend Gets": "Amigo Recebe",
      "On First Complete Transaction": "Na Primeira Transação Concluída",
      "You Get": "Você Recebe",
      "On Your Wallet": "Na Sua Carteira",
      "Select User": "Selecionar Usuário",
      "Send Notification": "Enviar Notificação",
      "Appointment Cancel": "Cancelar Consulta",
      "Product Amount": "Valor do Produto",
      "Login": "Entrar",
      "Search Doctor": "Buscar Médico",
      "Incoming Video Call From": "Chamada de Vídeo Recebida de",
      "Patient Name": "Nome do Paciente",
      "Relationship": "Parentesco",
      "Blood Type": "Tipo Sanguíneo",
      "Patient Gender": "Gênero do Paciente",
      "Male": "Masculino",
      "Female": "Feminino",
      "Patient Age": "Idade do Paciente",
      "National ID": "Documento de Identidade",
      "Height": "Altura",
      "Weight": "Peso",
      "Allergies": "Alergias",
      "Medical History": "Histórico Médico",
      "SUBMIT": "ENVIAR",
      "Relationship Type": "Tipo de Parentesco",
      "Includes": "Inclui",
      "tests": "exames",
      "Reports in": "Relatórios em",
      "Hours": "Horas",
      "Package Price": "Preço do Pacote",
      "Prescription Required": "Prescrição Necessária",
      "No Store available": "Nenhuma Loja Disponível",
      "in your area.": "na sua área.",
      "Call doctor": "Ligar para o médico",
      "No Booking placed !!": "Nenhuma Reserva Realizada !!",
      "Currently you don't have any Booking": "Atualmente você não tem nenhuma reserva",
      "Required for voice and video calls. Make": "Necessário para chamadas de voz e vídeo. Certifique-se de que",
      "sure your audio device (headset, speakers,": "seu dispositivo de áudio (fone, alto-falantes,",
      "or microphone) is connected and working.": "ou microfone) esteja conectado e funcionando.",
      "Vital & Physical Information": "Informações Vitais e Físicas",
      "Physical examination details": "Detalhes do exame físico",
      "Drugs & Prescription Info": "Medicamentos e Prescrição",
      "Medications prescription and dosage instructions": "Prescrição de medicamentos e instruções de dosagem",
      "Diagnosis Tests": "Exames Diagnósticos",
      "Medical tests and diagnostic evaluations": "Exames médicos e avaliações diagnósticas",
      "Booking": "Reserva",
      "Share Health Concerns": "Compartilhar Preocupações de Saúde",
      "With": "Com",
      "prior to your consultation": "antes da sua consulta",
      "Enter Disease": "Informar Doença",
      "Start OTP": "Início do OTP",
      "End OTP": "Fim do OTP",
      "Appointment ID": "ID da Consulta",
      "Accepted": "Aceito",
      "Collector Assigned": "Coletor Designado",
      "Ongoing": "Em Andamento",
      "Completed": "Concluído",
      "Cancelled": "Cancelado",
      "YourOrderPlaced": "Aguardando confirmação do laboratório.",
      "OrderPending": "O laboratório aceitou o pedido de agendamento.",
      "OrderDelivering": "O agendamento está em andamento.",
      "ProductDelivered": "Os exames laboratoriais estão sendo processados e analisados.",
      "OrderDelivered": "O agendamento e todos os exames relacionados foram concluídos.",
      "CollectorAssigned": "Um técnico de laboratório foi designado para a coleta de amostras.",
      "Search...": "Buscar...",
      "Say Something...": "Diga Algo...",
      "Please Select User !!": "Por Favor, Selecione um Usuário !!",
      "Please Write Message !!": "Por Favor, Escreva uma Mensagem !!",
      "Add Patient Photo": "Adicionar Foto do Paciente",
      "Add Patient Details": "Adicionar Detalhes do Paciente",
      "You cannot book this time": "Você não pode agendar este horário",
      "This time is already book": "Este horário já está reservado",
      "Select time for your appointment!": "Selecione o horário da sua consulta!",
      "Coupon Add Successful": "Cupom Adicionado com Sucesso",
      "Please Select Patient": "Por Favor, Selecione um Paciente",
      "Please Select Date & Time": "Por Favor, Selecione Data e Hora",
      "Please Select Address": "Por Favor, Selecione um Endereço",
      "Please Enter Details": "Por Favor, Insira os Detalhes",
      "Edit Profile": "Editar Perfil",
      "Update": "Atualizar",
      "Please Select Patients": "Por Favor, Selecione Pacientes",
      "Add patient prescription": "Adicionar Prescrição do Paciente",
      "Select deliver address": "Selecionar Endereço de Entrega",
      "Select Cancel Reason": "Selecionar Motivo do Cancelamento",
      "Enter Other Reason": "Informar Outro Motivo",
      "Doctor hasn't uploaded your details. Please contact them to update your info.": "O médico ainda não carregou seus dados. Por favor, entre em contato para atualizar suas informações.",
      "Upload Profile Photo": "Carregar Foto de Perfil",
      "Enter details": "Inserir detalhes",
      "No lab report uploaded yet. You’ll be notified once it's available.": "Nenhum relatório de laboratório carregado ainda. Você será notificado quando estiver disponível.",
      "Text copied to clipboard !!": "Texto copiado para a área de transferência !!",
      "Logout Successful!": "Logout realizado com sucesso!",
      "Please Enter Amount": "Por Favor, Insira o Valor",
      "Please enter number": "Por Favor, Insira um Número",
      "Please enter password": "Por Favor, Insira a Senha",
      "OTP is invalid !!": "OTP inválido !!",
      "Please Enter a Valid Email": "Por Favor, Insira um E-mail Válido",
      "No Doctor available in your area.": "Nenhum médico disponível na sua área.",
      "ID": "ID",
      "No Lab available in your area.": "Nenhum laboratório disponível na sua área.",
      "Book Now": "Reserve Agora",
      "You have successfully booking": "Sua reserva foi realizada com sucesso",
      "Booking Fee": "Taxa de Reserva",
      "Clinic name": "Nome da Clínica",
      "Department name": "Nome do Departamento",
      "SubType": "Subtipo",
      "Transaction Dtails": "Detalhes da Transação",
      "Payment Type": "Tipo de Pagamento",
      "View Booking": "Ver Reserva",
      "1 Love this": "1 Adorei isso",
      "Reviews": "Avaliações",
      "Currently you don't have any": "Atualmente você não tem nenhum",
      "doctor in you area!.": "Não há médico na sua área!",
      "No Doctor yet!": "Ainda não há médico!",
      "Leave a Review": "Deixe uma Avaliação",
      "How was your experience": "Como foi sua experiência?",
      "Maybe Later": "Talvez Mais Tarde",
      "Submit": "Enviar",
      "Write Your Rewiew": "Escreva sua avaliação",
      "Your reviewe here..": "Escreva sua avaliação aqui..",
      "Home Collect Person": "Pessoa de Coleta em Casa",
      "Name": "Nome",
      "Email": "E-mail",
      "Phone Number": "Número de Telefone",
      "Appointment": "Consulta",
      "Comment": "Comentário",
      "Order ID": "ID do Pedido",
      "Enter Amount": "Inserir Valor",
      "Appointment Date & Time Info": "Informações de Data e Hora da Consulta",
      "Upload": "Carregar",
      "GoDoctor": "GoDoctor",
      "@ Powered By GoDoctor": "@ Desenvolvido por GoDoctor",
      "Choose us for reliable, detail-oriented cleaning": "Escolha-nos para uma limpeza confiável e detalhada",
      "that meets all your cleanliness needs.": "que atenda a todas as suas necessidades de limpeza.",
      "Enable Location Services": "Konum Servislerini Etkinleştir",
      "To provide accurate services, please enable your location.": "Doğru hizmetler sunabilmek için lütfen konumunuzu etkinleştirin.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "İstendiğinde konum erişimine izin verin. İstenmiyorsa, tarayıcı ayarlarından etkinleştirin.",
      "Refresh the page after enabling.": "Etkinleştirdikten sonra sayfayı yenileyin.",
      "Enable Now": "Şimdi Etkinleştir",
      "TransactionId": "ID da Transação",
      "Search Hevan Medical Store Product": "Search Hevan Medical Store Products",
      "No product yet!": "No products yet!",
      "product in you area!.": "products in your area.",
      "No Doctors found !!": "Nenhum médico encontrado !!",
      "No messages found !!": "Nenhuma mensagem encontrada !!",
      "A doctor appointment solution refers to a system, often in the form of an app, that streamlines the process of booking,": "Uma solução para agendamento de consultas médicas refere-se a um sistema, frequentemente na forma de um aplicativo, que simplifica o processo de marcação,",
      "managing, and attending doctor's appointments.": "gerenciamento e participação em consultas médicas.",
      "Shop by Categories": "Comprar por categorias",
      "No Store yet!": "Ainda não há loja!",
      "store in you area!.": "Loja na sua área.",
      "Search by store": "Buscar por loja",
      "Your Token": "Seu número",
      "Waiting": "Aguardando",
      "Now Serving": "Atendendo agora",
      "Ahead fo You": "À sua frente",
      "Add New Patient": "Adicionar novo paciente",
      "Book Today": "Agendar hoje",
      "View All": "Ver tudo",
      "Cancellation Policy": "Política de cancelamento",
      "Clinic Photos": "Fotos da clínica",
      "No review": "Sem avaliações",
      "years": "anos",
      "Video": "Vídeo",
      "No doctors found": "Nenhum médico encontrado",
      "Try adjusting your search": "Tente ajustar sua busca",
      "Clinic": "Clínica",
      "Welcome back": "Bem-vindo de volta",
      "Manage your health services": "Gerencie seus serviços de saúde",
      "Logout": "Sair",
      "Wallet Balance": "Saldo da Carteira",
      "My Profile (Member Since)": "Meu Perfil (Membro desde)",
      "Only JPG, PNG, WEBP files are allowed!": "Apenas arquivos JPG, PNG ou WEBP são permitidos!",
      "My Profile": "Meu Perfil",
      "Full Name": "Nome Completo",
      "Email Address": "Endereço de E-mail",
      "Password": "Senha",
      "Save Changes": "Salvar Alterações",
      "Enter Password (Optional)": "Digite a Senha (Opcional)"
    }
  },

};

const savedLanguage = secureLocalStorage.getItem('I18') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
